<!--
 * @Author: your name
 * @Date: 2021-05-20 10:15:19
 * @LastEditTime: 2024-08-30 14:29:53
 * @LastEditors: dyl
 * @Description: In User Settings Edit
 * @FilePath: /nqc-pc-ui/src/apps/modules/qc-check/check/_components/dialog/AddTaskDialog.vue
-->
<template>
  <div class="modal-window">
    <div class="flex">
      <section class="form" style="width: 90%; margin-bottom: 10px !important">
        <w-popover v-if="SHNR" class="tip" trigger="hover">
          <div style="word-break: break-all; max-width: 400px">{{ SHNR }}</div>
          <i slot="reference" class="w-icon-warning"></i>
        </w-popover>
        <w-form label-width="80px" label-align="right" size="small">
          <w-row>
            <w-col v-if="selectZkjb" :span="4">
              <w-form-item label="质控级别:" label-width="120px">
                <w-select
                  ref="select"
                  v-model="form.ZKJB"
                  placeholder="请选择"
                  style="width: 100%"
                  :disabled="type !== 'add' || !canSelectZkjb"
                  @change="getCheckDepartInfo(form.ZKJB)"
                >
                  <w-option
                    v-for="item in zkjbOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </w-option>
                </w-select>
              </w-form-item>
            </w-col>
            <w-col v-if="selectZkjb" :span="4">
              <w-form-item label="督查部门:" label-width="120px">
                <w-select
                  ref="select"
                  v-model="form.ORGID"
                  placeholder="请选择"
                  style="width: 100%"
                  :disabled="type !== 'add' || !canSelectDcbm"
                  @change="handleDcbmChange()"
                >
                  <w-option
                    v-for="item in orgIdArr"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    :disabled="item.QYZT !== '1' || item.id == '-1112'"
                  >
                  </w-option>
                </w-select>
              </w-form-item>
            </w-col>
            <w-col :span="selectZkjb ? 4 : 6">
              <!-- 开始检查时 不允许编辑 现在组件disabled功能不支持-->
              <w-form-item label="受检科室:" label-width="120px">
                <popover-input
                  v-if="type === 'add' && !isSaved && !rowData.KFXDM"
                  label-key="SJKSMC"
                  value-key="SJKS"
                  type="DeptForm"
                  :row="{
                    ...form,
                    HospitalCode: listQuery.HospitalCode
                  }"
                  :is-single="true"
                  :has-foot="true"
                  :is-keepalive="true"
                  :data-list="sjksDataList"
                  icon="w-icon-triangle-bottom"
                  @changeValue="(detail) => changeSearchForm(detail, 'SJKS')"
                >
                </popover-input>
                <w-input v-else :value="form.SJKSMC" readonly></w-input>
              </w-form-item>
            </w-col>
            <w-col :span="selectZkjb ? 4 : 6">
              <w-form-item label="检查表单:" label-width="120px">
                <popover-input
                  v-if="
                    type === 'add' && form.SJKS && !isSaved && !rowData.KFXDM
                  "
                  label-key="JCBDMC"
                  value-key="JCBD"
                  type="CheckForm"
                  :row="{
                    type: 'qccheck',
                    ...form,
                    orgid: listQuery.ORGID,
                    ZKJB: listQuery.ZKJB
                  }"
                  :is-single="true"
                  :has-foot="true"
                  icon="w-icon-triangle-bottom"
                  :show-create-btn="xtmj1111"
                  :placeholder="'请选择'"
                  @changeValue="changeSearchForm"
                >
                </popover-input>
                <w-input v-else :value="form.JCBDMC" readonly></w-input>
              </w-form-item>
            </w-col>
            <w-col :span="selectZkjb ? 4 : 6">
              <w-form-item label="督查时间:" label-width="120px" class="flex">
                <w-date-picker
                  v-model="form.DCSJ"
                  type="date"
                  format="yyyy-MM-dd"
                  placeholder="请选择"
                  style="width: 80%"
                  :disabled="canNotModifyCheckDate || !!rowData.KFXDM"
                  :clearable="false"
                  @change="handleChangeContent"
                ></w-date-picker>
                <w-checkbox
                  v-show="xtmj1190"
                  v-model="laterUse"
                  :disabled="canNotModifyCheckDate"
                  class="yan-yong"
                  title="勾选此项,保存当前表单会记住督查时间,下一份检查表单可继续使用"
                  @change="handleChangeContent"
                  >延用</w-checkbox
                >
              </w-form-item>
            </w-col>
            <w-col :span="selectZkjb ? 4 : 6">
              <w-form-item label="检查者:" label-width="120px">
                <popover-check
                  label-key="ZYMC"
                  value-key="JCZ"
                  :row="{
                    OrgId: form.ORGID || listQuery.ORGID,
                    JCFW_DM: form.ORGID || listQuery.ORGID,
                    JCZ: form.JCZ ? form.JCZ.split(',') : [],
                    ZYMC: form.ZYMC ? form.ZYMC.split(',') : [],
                    CFXH: form.CFXH,
                    type: 'checkForJcz',
                    SFZKZ: form.SFZKZ
                  }"
                  :is-single="true"
                  :disabled="!!rowData.KFXDM"
                  :data-list="jczOptions"
                  :disabled-arr="
                    Array.isArray(form.QTJCZID)
                      ? form.QTJCZID
                      : form.QTJCZID
                      ? form.QTJCZID.split(',')
                      : []
                  "
                  @changeValue="handleChangeJCZ"
                >
                </popover-check>
              </w-form-item>
            </w-col>
          </w-row>
          <w-row v-show="moreVisiable" class="mt-4">
            <w-col :span="12">
              <w-form-item
                v-if="form.JCLX != 1020"
                label="被查护士:"
                label-width="120px"
              >
                <div class="d-flex">
                  <w-select
                    ref="examineeSelect"
                    v-model="form.BCHSDM"
                    :popper-append-to-body="false"
                    :disabled="!!rowData.KFXDM"
                    multiple
                    filterable
                    :tags-threshold="1"
                    class="multiSelect"
                    collapse-tags
                    placeholder="请选择"
                    style="width: 85%"
                    @change="handleExamineeChange(1)"
                  >
                    <w-option
                      v-for="item in bchsSelectList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                      <span>{{ item.name }}</span>
                    </w-option>
                  </w-select>
                  <popover-nurse
                    label-key="BCHSMC"
                    value-key="BCHSDM"
                    class="popover-nurse-top"
                    :row="{
                      BCHSDM: form.BCHSDM,
                      BCHSMC: form.BCHSMC,
                      JCFW_DM: form.SJKS,
                      type: 'checkForHs',
                      title:'被查护士选择'
                    }"
                    @changeValue="changeTopBCHS"
                  >
                  </popover-nurse>
                <w-checkbox
                  class="margin-left-10"
                  :disabled="!!rowData.KFXDM"
                  @change="handleSelectAll"
                  v-model="isAllSelected"
                >
                  全选
                </w-checkbox>
              </div>
              </w-form-item>
              <!-- 只检查患者，只显示患者，为了布局，此时需要把下方的患者选择框挪到上面一行 -->
              <w-form-item
                v-if="form.JCLX === 1020"
                label="被查患者:"
                label-width="120px"
              >
                <w-select
                  ref="bchzSelect"
                  v-model="form.BCHZDM"
                  :popper-append-to-body="false"
                  :disabled="!!rowData.KFXDM"
                  multiple
                  filterable
                  :tags-threshold="1"
                  class="multiSelect"
                  collapse-tags
                  placeholder="请选择"
                  style="width: 85%"
                  @change="handleExamineeChange(2)"
                >
                  <w-option
                    v-for="item in bchzSelectList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                    <span>{{ item.name }}</span>
                  </w-option>
                </w-select>
                <img
                  class="pic-people left"
                  style="position: absolute; transform: translateY(2px)"
                  src="@/common/assets/images/addpeople.png"
                  alt="添加患者"
                  @click="addMainTaskPatient"
                />
              </w-form-item>
            </w-col>
            <w-col :span="TSHCB === '1' ? 6 : 12">
              <w-form-item label="其他检查者:" label-width="120px">
                <popover-check
                  v-if="!loadingcheck"
                  style="width: calc(100% - 47px)"
                  label-key="QTJCZMC"
                  value-key="QTJCZID"
                  :row="{
                    OrgId: form.ORGID || listQuery.ORGID,
                    JCFW_DM: form.ORGID || listQuery.ORGID,
                    QTJCZID: Array.isArray(form.QTJCZID)
                      ? form.QTJCZID
                      : form.QTJCZID
                      ? form.QTJCZID.split(',')
                      : [],
                    QTJCZMC: Array.isArray(form.QTJCZMC)
                      ? form.QTJCZMC
                      : form.QTJCZMC
                      ? form.QTJCZMC.split(',')
                      : [],
                    CFXH: form.CFXH,
                    type: 'checkForJcz',
                    SFZKZ: rowData.SFZKZ
                  }"
                  :dataList="otherJczOptions"
                  :disabled-arr="[form.JCZ]"
                  :disabled="!!rowData.KFXDM"
                  @changeValue="handleChangeQTJCZ"
                >
                </popover-check>
                <w-checkbox class="selectAll" @change="handleCheck">
                  全选
                </w-checkbox>
              </w-form-item>
            </w-col>
            <w-col v-if="TSHCB === '1'" :span="6">
              <w-form-item label="权重:" label-width="120px">
                <w-input
                  v-model="form.HCB_QZ"
                  style="width: 85%"
                  :disabled="!!rowData.KFXDM"
                  @change="handleChangeQz"
                ></w-input>
                <span style="margin-left: 5px">%</span>
              </w-form-item>
            </w-col>
          </w-row>
          <w-row v-show="moreVisiable" class="mt-4">
            <w-col :span="12">
              <!-- 检查科室情况下，放在另外一行 -->
              <w-form-item
                v-show="form.JCLX === 1019 && Mjdm === '1'"
                label="被查患者:"
                label-width="120px"
              >
                <w-select
                  ref="bchzSelect"
                  v-model="form.BCHZDM"
                  :popper-append-to-body="false"
                  :disabled="!!rowData.KFXDM"
                  multiple
                  filterable
                  :tags-threshold="1"
                  class="multiSelect"
                  collapse-tags
                  placeholder="请选择"
                  style="width: 85%"
                  @change="handleExamineeChange(2)"
                >
                  <w-option
                    v-for="item in bchzSelectList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                    <span>{{ item.name }}</span>
                  </w-option>
                </w-select>
                <img
                  class="pic-people left"
                  style="position: absolute; transform: translateY(2px)"
                  src="@/common/assets/images/addpeople.png"
                  alt="添加患者"
                  @click="addMainTaskPatient"
                />
              </w-form-item>
            </w-col>
          </w-row>
          <w-row
            v-if="
              xtmj1146 == '1' && xtmj1250 == '1' && checkTypeInfo.JCFS == '1024'
            "
            class="tested"
          >
            <w-col :span="3">
              <w-form-item label="受检人/次数" label-width="120px">
                <w-input-number
                  v-model="frequency"
                  :max="100"
                  :min="1"
                  @change="frequencyChange"
                ></w-input-number>
              </w-form-item>
            </w-col>
          </w-row>
          <w-row v-show="moreVisiable" class="mt-5">
            <w-col :span="12">
              <w-form-item label="备注信息:" label-width="120px">
                <w-input
                  v-model="form.MEMO"
                  type="textarea"
                  :maxlength="500"
                  :rows="2"
                  :disabled="!!rowData.KFXDM"
                  @change="handleChangeContent"
                ></w-input>
              </w-form-item>
            </w-col>
            <w-col :span="3">
              <w-row v-if="isMustReform" :span="3">
                <w-checkbox
                  v-model="form.SFBXZG"
                  style="margin-left: 40px; top: 5px"
                  >表单必须整改</w-checkbox
                >
              </w-row>
              <w-row v-if="showTaskToPlan" :span="3" style="margin-top: 8px">
                <w-checkbox
                  v-model="form.TaskToPlan"
                  style="margin-left: 40px; top: 5px"
                  >纳入原计划
                </w-checkbox>
              </w-row>
            </w-col>
            <w-col v-if="showBatchInfo" :span="5">
              <w-row :span="5">
                <i
                  v-show="showPrevious"
                  class="w-icon-back"
                  style="
                    cursor: pointer;
                    font-weight: bolder;
                    color: blue;
                    margin-left: 5px;
                  "
                  title="上一份检查"
                  @click="previousCheck"
                ></i>
                <w-input
                  v-model="jdxx"
                  style="width: 55px; margin-left: 3px"
                  readonly
                ></w-input>
                <i
                  v-show="showNext"
                  class="w-icon-forward"
                  title="下一份检查"
                  style="
                    margin-left: 3px;
                    cursor: pointer;
                    font-weight: bolder;
                    color: blue;
                  "
                  @click="nextCheck()"
                ></i>
              </w-row>
            </w-col>
            <div
              v-if="!isShowHGSCheck && groupLeader != null && groupLeader != ''"
              class="leader"
            >
              <span class="lea">检查组长：</span>
              <span>{{ groupLeader }}</span>
            </div>
            <template v-if="isShowHGSCheck">
              <w-col :span="isMustReform || showTaskToPlan ? 3 : 4">
                <w-form-item
                  label="抽检数:"
                  :label-width="isMustReform ? '90px' : '120px'"
                >
                  <w-input
                    v-model="form.BFZSLJC_CJS"
                    style="width: 120px"
                    :maxlength="4"
                    :disabled="!!rowData.KFXDM"
                    @blur="hgsChange"
                    @change="handleChangeContent"
                  ></w-input>
                </w-form-item>
              </w-col>
              <w-col :span="isMustReform || showTaskToPlan ? 3 : 4">
                <w-form-item
                  label="合格数:"
                  :label-width="isMustReform ? '90px' : '120px'"
                >
                  <w-input
                    v-model="form.BFZSLJC_HGS"
                    style="width: 120px"
                    :maxlength="4"
                    :disabled="!!rowData.KFXDM"
                    @keyup.native="hgsChange"
                    @change="handleChangeContent"
                  ></w-input>
                </w-form-item>
              </w-col>
              <w-col
                :span="isMustReform || showTaskToPlan ? 3 : 4"
                style="text-align: center"
              >
                <span>抽检合格率：</span>
                <span>{{ form.BFZSLJC_HGL }}%</span>
              </w-col>
            </template>
            <div
              v-if="isShowHGSCheck && groupLeader != null && groupLeader != ''"
              class="leaders"
            >
              <span>检查组长：</span>
              <span>{{ groupLeader }}</span>
            </div>
          </w-row>
        </w-form>
      </section>
      <div
        :class="[moreVisiable ? 'moreVisiable' : '', 'collapse']"
        @click="changeCollapse"
      >
        <i
          :class="moreVisiable ? 'w-icon-arrow-top' : 'w-icon-arrow-bottom'"
        ></i>
        {{ moreVisiable ? '隐藏' : '更多' }}
      </div>
    </div>
    <w-row class="info mb-10">
      <w-col :span="3" class="bdbb">
        表单版本：<span class="fz-16">{{ form.BBH }}</span>
      </w-col>
      <w-col :span="3">
        表单类型：<span class="fz-16"> {{ calculationFuc }}</span>
      </w-col>
      <w-col :span="18" class="text-right">
        <w-button v-if="SXTQBR" type="primary" @click="handleGet"
          >自动提取</w-button
        >
        <span v-for="item in resultCheckList" :key="item.key" class="ml-20">
          {{ item.name }}:
          <span
            class="high-color"
            v-if="item.key == 'ZDF' && checkTypeInfo.JCFS !== 1024"
          >
            {{ `${scoreInfo.ZDF ? scoreInfo.ZDF : 0}分` }}
          </span>
          <span class="high-color" v-else-if="item.key == 'DFL'">
            {{ `${scoreInfo.DFL ? scoreInfo.DFL : 0}%` }}
          </span>
          <span class="high-color" v-else-if="item.key == 'WCL'">
            {{ `${scoreInfo.WCL}%` }}
          </span>
          <span class="high-color" v-else-if="item.key == 'LSL'">
            {{ `${scoreInfo.LSL}%` }}
          </span>
          <span class="high-color" v-else-if="item.key == 'BDZF'">
            {{
              `${
                (BDZF ? BDZF : 100) + (checkTypeInfo.JCFS == 1022 ? '分' : '%')
              }`
            }}
          </span>
          <span class="high-color" v-else-if="item.key == 'ZKF'">
            {{
              `${
                (scoreInfo.ZKF ? scoreInfo.ZKF : 0) +
                (checkTypeInfo.JCFS == 1022 ? '分' : '%')
              }`
            }}
          </span>
          <span class="high-color" v-else-if="item.key == 'WSJF'">
            {{
              `${
                (scoreInfo.WSJF ? scoreInfo.WSJF : 0) +
                (checkTypeInfo.JCFS == 1022 ? '分' : '%')
              }`
            }}
          </span>
          <span class="high-color" v-else-if="checkTypeInfo.JCFS == 1024">
            {{
              `${
                scoreInfo.ItemPrecentList.find((i) => i.JGDM == item.key)
                  ? scoreInfo.ItemPrecentList.find((i) => i.JGDM == item.key)
                      .YBZB
                  : '0'
              }%`
            }}
          </span>
        </span>
        <more-cols
          class="wn-fr"
          style="margin-left: 20px"
          :show-table-col-list="resultItemColumns"
          :show-table-check-list.sync="resultCheckList"
          @getLastCheckList="checkListChange"
        ></more-cols>
      </w-col>
    </w-row>
    <vxe-table
      ref="checkTable"
      :key="checkTableKey"
      v-win-loading="tableLoading"
      class="checkTables"
      :column-config="{ resizable: true }"
      border
      :height="tableHeight"
      :scroll-y="{ enabled: tableData.length > 200 ? true : false }"
      :span-method="rowspanMethod"
      :data="tableData"
      style="width: 100%"
      show-overflow-tooltip
    >
      <vxe-column key="XMDM" field="XMDM" title="项目" min-width="230">
        <template #header>
          <more-cols
            v-if="tableData.length > 0"
            class="wn-fr"
            style="margin-left: 20px"
            :show-table-col-list="tableColumns"
            :show-table-check-list.sync="showTableCheckList"
            @getLastCheckList="getLastCheckList"
          ></more-cols>
          <span style="margin-right: 40px">项目</span>
        </template>
        <template #default="{ row }" align="left">
          <w-popover
            v-if="tableData.length > 200 && row.XMMC.length > 18"
            trigger="hover"
            :content="row.XMMC"
          >
            <span
              :id="row.XMDM"
              slot="reference"
              :class="[
                row.SFXSQX || (rowData.KFXDM && row.redXM)
                  ? 'font-red scroll-style'
                  : 'scroll-style'
              ]"
              >{{ row.XMMC }}</span
            >
          </w-popover>
          <span
            v-else
            :id="row.XMDM"
            :class="[
              row.SFXSQX || (rowData.KFXDM && row.redXM) ? 'font-red ' : ''
            ]"
            >{{ row.XMMC }}</span
          >
        </template>
      </vxe-column>
      <vxe-column key="BZDM" field="BZDM" title="质量标准" min-width="230">
        <!-- <template #default="{ row }" align="left">
          <span :class="[row.SFXSQX ? 'font-red' : '']">{{ row.BZMC }}</span>
        </template> -->
        <template #default="{ row, $rowIndex }" align="left">
          <div :id="row.BZDM" class="flex">
            <w-popover
              v-if="tableData.length > 200 && row.BZMC.length > 18"
              trigger="hover"
              :content="row.BZMC"
            >
              <span
                slot="reference"
                :class="[
                  row.SFXSQX || (rowData.KFXDM && row.redZLBZ)
                    ? 'font-red scroll-style'
                    : 'scroll-style'
                ]"
                :style="{
                  width: row && row.DCJC === 1 ? '95%' : '100%'
                }"
                >{{ row.BZMC }}</span
              >
            </w-popover>
            <span
              v-if="tableData.length <= 200 || row.BZMC.length <= 18"
              :class="[
                row.SFXSQX || (rowData.KFXDM && row.redZLBZ) ? 'font-red' : ''
              ]"
              :style="{
                width: row && row.DCJC === 1 ? '95%' : '100%'
              }"
              >{{ row.BZMC }}</span
            >
            <!-- 当不显示扣分标准时,多次检查添加按钮在质量标准迁移到列上 -->
            <div v-if="!isShowKFBZColumn && row.DCJC === 1">
              <i
                v-if="row.ISADD && TSHCB !== '1'"
                class="w-icon-reduce kfmc kfmc-del"
                @click="handleDelRow(row, $rowIndex)"
              />
              <i
                v-if="showAddBtns(row, $rowIndex)"
                class="w-icon-add kfmc kfmc-add"
                @click="handleAddRow(row, $rowIndex, '质量')"
              />
            </div>
          </div>
        </template>
      </vxe-column>
      <vxe-column
        v-if="isShowKFBZColumn"
        key="KFMC"
        field="KFMC"
        title="扣分标准"
        min-width="230"
        align="left"
      >
        <template #default="{ row, $rowIndex }" align="left">
          <div :id="row.KFDM" class="flex">
            <w-popover
              v-if="tableData.length > 200 && row.KFMC.length > 18"
              trigger="hover"
              :content="row.KFMC"
            >
              <span
                :id="row.id"
                slot="reference"
                :class="[
                  row.SFXSQX || (rowData.KFXDM && row.editAble)
                    ? 'font-red scroll-style'
                    : 'scroll-style'
                ]"
                :style="{
                  width: row && row.DCJC === 1 ? '95%' : '100%'
                }"
                >{{ row.KFMC }}</span
              >
            </w-popover>
            <span
              v-if="tableData.length <= 200 || row.KFMC.length <= 18"
              :id="row.id"
              :class="{
                'font-red': row.SFXSQX || (rowData.KFXDM && row.editAble),
                ml: true
              }"
              :style="{
                width: row && row.DCJC === 1 ? '95%' : '100%',
                position: 'inherit'
              }"
            >
              <w-tooltip
                v-if="
                  checkTypeInfo.JCFS === 1022 &&
                  row.YPFJBS > 0 &&
                  row.YPFJBS !== '1221'
                "
                :content="row.YPFJBSMC"
                placement="top-start"
              >
                <span
                  v-if="
                    checkTypeInfo.JCFS === 1022 &&
                    row.YPFJBS > 0 &&
                    row.YPFJBS !== '1221'
                  "
                  slot="reference"
                  class="hasIcon"
                >
                </span>
              </w-tooltip>
              {{ row.KFMC }}
            </span>
            <!-- 后面根据业务逻辑判断是否展示添加按钮 -->
            <div v-if="row && row.DCJC === 1">
              <i
                v-if="row.ISADD && TSHCB !== '1'"
                class="w-icon-reduce kfmc kfmc-del"
                @click="handleDelRow(row, $rowIndex)"
              />
              <i
                v-if="showAddBtns(row, $rowIndex)"
                class="w-icon-add kfmc kfmc-add"
                @click="handleAddRow(row, $rowIndex, '扣分')"
              />
            </div>
          </div>
        </template>
      </vxe-column>
      <vxe-column
        v-if="checkTypeInfo.JCFS !== 1024"
        key="KFFZ"
        field="KFFZ"
        title="分值"
        width="60"
        align="center"
      />
      <template v-if="checkTypeInfo.JCFS !== 1024 && xtmj1186 && bd1186">
        <vxe-column
          key="ZRS"
          field="ZRS"
          title="总数"
          width="70"
          align="center"
        >
          <template #default="{ row, $rowIndex }">
            <w-input
              v-model="row.ZRS"
              :disabled="row.SFWSJ || !row.editAble"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              maxlength="3"
              @change="
                (item) => {
                  handleChangeNum(item, $rowIndex, row, '总数')
                }
              "
            ></w-input>
          </template>
        </vxe-column>
        <vxe-column
          key="HGS"
          field="HGS"
          title="合格数"
          width="70"
          align="center"
        >
          <template #default="{ row, $rowIndex }">
            <w-input
              v-model="row.HGS"
              :disabled="row.SFWSJ || !row.editAble"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              maxlength="3"
              @change="
                (item) => {
                  handleChangeNum(item, $rowIndex, row, '合格数')
                }
              "
            ></w-input>
          </template>
        </vxe-column>
        <vxe-column
          key="BHGS"
          field="BHGS"
          title="不合格数"
          width="80"
          align="center"
        >
          <template #default="{ row }">
            <w-input v-model="row.BHGS" disabled></w-input>
          </template>
        </vxe-column>
        <vxe-column
          key="DXHGL"
          field="DXHGL"
          title="合格率"
          width="70"
          align="center"
        >
          <template #default="{ row }">
            <span v-if="row.DXHGL || row.DXHGL === 0">{{
              Number((row.DXHGL * 100).toFixed(2)) + '%'
            }}</span>
          </template>
        </vxe-column>
      </template>
      <vxe-column
        v-if="TSHCB === '0' && !isQualifiedRateCheck && isHGL !== '1'"
        key="KFJG"
        field="KFJG"
        :width="
          checkTypeInfo.JCFS === 1022
            ? checkTypeInfo.KFFS == 1261
              ? 210
              : 100
            : checkTypeInfo.JCFS === 1024 && isCrosswise
            ? checkWidth
            : 200
        "
        align="center"
      >
        <template #header="{}">
          <div class="WSJContainer">
            <span style="padding-right: 10px">{{
              checkTypeInfo.JCFS !== 1024 ? '扣加分' : '结果'
            }}</span>
            <w-checkbox
              v-if="checkTypeInfo.JCFS === 1024"
              v-model="isCrosswise"
              @change="handleChangeCrosswise"
              >是否横排</w-checkbox
            >
          </div>
        </template>
        <template #default="{ row, $rowIndex }">
          <w-input
            v-if="
              checkTypeInfo.JCFS === 1022 &&
              (row.KFFS === 1016 || row.KFFS === 1261)
            "
            :style="row.KFFS === 1261 ? 'width:45%' : 'width:100%'"
            v-model="row.KFJG"
            :disabled="row.SFWSJ || !row.editAble"
            @change="
              (item) => {
                handleMark(item, $rowIndex, row, 'input')
              }
            "
          ></w-input>
          <w-select
            v-if="checkTypeInfo.JCFS === 1022 && row.KFFS === 1261"
            v-model="row.XXJGDM"
            style="width: 50%; margin-left: 5px"
            @change="
              (item) => {
                handleBfzJcjgChange(item, $rowIndex, row)
              }
            "
          >
            <w-option
              v-for="item in BfzJcjgData"
              :key="item.JGDM"
              :label="item.JGMC"
              :value="item.JGDM"
            >
            </w-option>
          </w-select>
          <!--1068 自由扣分扣分最大值为BZFZ,其他扣分类型最大扣分值为BZFZ -->
          <w-input-number
            v-else-if="
              checkTypeInfo.JCFS === 1022 &&
              (row.KFFS === 1018 || row.KFFS === 0 || row.KFFS === -1)
            "
            v-model="row.KFJG"
            :disabled="row.SFWSJ || !row.editAble"
            :increment="xtmj1195val"
            :min="0"
            :max="
              row.JFFS === 1068
                ? row.XMFZ
                : row.JFFS === 1183
                ? row.BZFZ
                : row.JFFS === 1184
                ? row.BDZF
                : Number(row.KFFZ)
            "
            size="small"
            style="min-width: 100%"
            @change="
              (item) => {
                handleMark(item, $rowIndex, row)
              }
            "
          ></w-input-number>
          <!--1017 百分制表单用下拉控件展示-->

          <w-select
            v-else-if="checkTypeInfo.JCFS === 1022 && row.KFFS === 1017"
            v-model="row.KFJG"
            :disabled="row.SFWSJ || !row.editAble"
            popper-append-body
            style="min-width: 100%"
            placeholder=""
            @change="
              (val) => {
                handleScoreChange(val, row)
              }
            "
          >
            <w-option
              v-for="item in row.KFXXList"
              :key="item"
              :label="item"
              :value="item"
            ></w-option>
          </w-select>
          <w-radio-group
            v-else
            v-model="row.KFJG"
            :disabled="row.SFWSJ || !row.editAble"
            :class="isCrosswise ? 'flex-content' : ''"
            @change="
              (val) => {
                handleScoreChange(val, row, 'radio')
              }
            "
          >
            <w-radio
              v-for="ck in checkResultList"
              :key="ck.JGDM"
              style="display: block; text-align: left; margin: 5px 5px"
              size="small"
              :label="ck.JGDM.toString()"
              ><span :style="{ color: `${ck.Color} !important` }">{{
                ck.JGMC
              }}</span></w-radio
            >
          </w-radio-group>
        </template>
      </vxe-column>
      <!-- 特殊核查表检查 -->
      <vxe-column
        v-if="
          xtmj1146 == '1' && xtmj1250 == '1' && checkTypeInfo.JCFS == '1024'
        "
        title="受检人/次数"
        width="100"
      >
        <template slot-scope="scope">
          <w-input-number
            :disabled="scope.row.SFWSJ || !scope.row.editAble"
            @change="testedPerson(scope)"
            class="input-number"
            v-model="scope.row.SJRCS"
            :max="100"
            :min="1"
          ></w-input-number>
        </template>
      </vxe-column>
      <vxe-column
        v-if="TSHCB === '1' || (isHGL === '1' && JFFS !== 1132)"
        key="JGDM"
        :width="
          isShowPercentage == '1'
            ? 150
            : HCBJGListLength && isCrosswise
            ? 150 + HCBJGListLength * 70
            : 280
        "
        align="center"
      >
        <template #header="{}">
          <div class="WSJContainer">
            <span style="padding-right: 10px">{{
              isShowPercentage == '1' ? '结果&样本' : '结果&样本&占比情况'
            }}</span>
            <w-checkbox v-model="isCrosswise" @change="handleChangeCrosswise"
              >是否横排</w-checkbox
            >
          </div>
        </template>
        <template slot-scope="scope">
          <div v-if="!isCrosswise" :class="scope.row.isError ? 'showRed' : ''">
            <div
              v-for="list in scope.row.HCBJGList"
              :key="list.JGDM"
              class="flex"
            >
              <span class="w50" :style="{ color: list.Color }">{{
                list.JGMC
              }}</span>
              <w-input
                v-model.number="list.YBSL"
                class="w30"
                :maxlength="3"
                :disabled="scope.row.SFWSJ || !scope.row.editAble"
                @change="getHGL(list, scope.$rowIndex, scope.row, true)"
              ></w-input>
              <span v-if="isShowPercentage != '1'" class="w20">
                {{
                  bsySfcyjs
                    ? Number((list.YBZB * 100).toFixed(2)) + '%'
                    : list.ISNRFM === '0' && list.ISNRJS === '0'
                    ? '0%'
                    : Number((list.YBZB * 100).toFixed(2)) + '%'
                }}
              </span>
            </div>
          </div>
          <div v-else :class="[scope.row.isError ? 'showRed' : '', 'flex']">
            <div v-for="list in scope.row.HCBJGList" :key="list.JGDM">
              <div class="w100" :style="{ color: list.Color }">
                {{ list.JGMC }}
              </div>
              <div class="flex-center">
                <w-input
                  v-model.number="list.YBSL"
                  class="w50"
                  :maxlength="3"
                  :disabled="scope.row.SFWSJ || !scope.row.editAble"
                  @change="getHGL(list, scope.$rowIndex, scope.row, true)"
                ></w-input>
                <span
                  v-if="isShowPercentage != '1'"
                  class="w50"
                  style="padding-left: 5px"
                >
                  {{
                    bsySfcyjs
                      ? Number((list.YBZB * 100).toFixed(2)) + '%'
                      : list.ISNRFM === '0' && list.ISNRJS === '0'
                      ? '0%'
                      : Number((list.YBZB * 100).toFixed(2)) + '%'
                  }}
                </span>
              </div>
            </div>
          </div>
        </template>
      </vxe-column>
      <vxe-column
        v-if="TSHCB === '1' || (isHGL === '1' && JFFS !== 1132)"
        key="KGL"
        field="KGL"
        title="合格率"
        width="70"
        align="center"
      >
        <template #default="{ row }">
          <span>{{ Number((row.HGL * 100).toFixed(2)) + '%' }}</span>
        </template>
      </vxe-column>
      <!-- 1146关闭  计分方式为1032合格率检查 -->
      <vxe-column
        v-if="isQualifiedRateCheck"
        key="JG"
        title="结果"
        :width="isCrosswise ? 180 + HCBJGListLength * 60 : '180'"
        align="center"
      >
        <template #header="{}">
          <div class="WSJContainer">
            <span style="padding-right: 10px">结果</span>
            <w-checkbox v-model="isCrosswise" @change="handleChangeCrosswise"
              >是否横排</w-checkbox
            >
          </div>
        </template>
        <template slot-scope="scope">
          <div v-if="isCrosswise" class="flex">
            <div v-for="list in scope.row.HCBJGList" :key="list.JGDM">
              <div class="w100" :style="{ color: list.Color }">
                {{ list.JGMC }}
              </div>
              <div class="flex-center">
                <w-input-number
                  v-model="list.YBSL"
                  size="small"
                  class="w100"
                  style="margin-right: 5px"
                  :maxlength="3"
                  :min="0"
                  :disabled="scope.row.SFWSJ || !scope.row.editAble"
                  @change="getHGL(list, scope.$rowIndex, scope.row)"
                ></w-input-number>
              </div>
            </div>
          </div>
          <template v-else>
            <div
              v-for="list in scope.row.HCBJGList"
              :key="list.JGDM"
              class="flex"
            >
              <span class="w50" :style="{ color: list.Color }">{{
                list.JGMC
              }}</span>
              <w-input-number
                v-model="list.YBSL"
                size="small"
                style="min-width: 30%"
                :maxlength="3"
                :min="0"
                :disabled="scope.row.SFWSJ || !scope.row.editAble"
                @change="getHGL(list, scope.$rowIndex, scope.row)"
              ></w-input-number>
            </div>
          </template>
        </template>
      </vxe-column>
      <vxe-column
        v-if="isQualifiedRateCheck"
        key="KGL"
        field="KGL"
        title="合格率"
        width="80"
        align="center"
      >
        <template #default="{ row }">
          <span>{{ Number((row.HGL * 100).toFixed(2)) + '%' }}</span>
        </template>
      </vxe-column>
      <vxe-column
        v-if="isInclude('SFWSJ')"
        key="SFWSJ"
        field="SFWSJ"
        width="100"
        align="center"
      >
        <template #header="{}">
          <div class="WSJContainer">
            <span>未涉及</span>
            <w-checkbox
              v-if="ifShowAllCheck"
              v-model="allSFWSJ"
              :indeterminate="indeterminate"
              @change="handleAllSFWSJ"
            ></w-checkbox>
          </div>
        </template>
        <template #default="{ row }">
          <w-checkbox
            v-model="row.SFWSJ"
            :disabled="!!rowData.KFXDM"
            @change="(val) => handleSFWSJ(val, row)"
          ></w-checkbox>
        </template>
      </vxe-column>
      <vxe-column
        v-if="isInclude('KFYYSM')"
        key="KFYYSM"
        field="KFYYSM"
        title="扣分原因说明"
        width="230"
        align="center"
        class="kfyy"
      >
        <template #default="{ row }">
          <w-input
            v-model="row.KFYYSM"
            type="textarea"
            :disabled="row.SFWSJ || !row.editAble"
            placeholder="请选择扣分原因说明"
            style="float: left; width: 80%"
            :class="validClass('KFYYSM', row) ? 'showRedBorder' : ''"
            :maxlength="1000"
            @change="kfyysmChange(row)"
          >
          </w-input>
          <w-popover
            ref="popoverReason"
            trigger="click"
            :visible-arrow="false"
            :open-delay="0"
            :close-delay="0"
            popper-class="padd0 w_popover_container"
            :append-to-body="false"
            style="float: left"
            @hidden="hide"
          >
            <popover-reason
              v-if="isShowReason"
              :reason-list="reasonList"
              :self-reason="row.selfReason ? row.selfReason : ''"
              @hide="hide"
              @selfReason="
                (val) => {
                  addSelfReason(val, row)
                }
              "
              @deleteSelfReason="
                (val) => {
                  deleteSelfReason(val, row)
                }
              "
            ></popover-reason>
            <template slot="reference">
              <w-button
                class="arrow-container"
                :disabled="row.SFWSJ || !row.editAble"
                @click="handleClickArrow(row)"
              >
                <i class="w-icon-triangle-bottom"></i>
              </w-button>
            </template>
          </w-popover>
        </template>
      </vxe-column>
      <vxe-column
        v-if="form.JCLX !== 1020 && isInclude('BCHSDM')"
        key="BCHS"
        field="BCHS"
        title="被查护士"
        width="220"
        align="center"
      >
        <template #default="{ row, $rowIndex }">
          <div v-if="!row.SFWSJ && row.editAble" style="display: flex">
            <w-select
              :ref="'bchs' + $rowIndex"
              v-model="row.BCHSDM"
              :class="validClass('BCHSDM', row) ? 'showRedBorder' : ''"
              multiple
              collapse-tags
              :tags-threshold="1"
              placeholder=""
              popper-append-body
              @visible-change="selectIndex = $rowIndex"
              @change="
                (val) => {
                  handleBchsChange(val, row)
                }
              "
            >
              <w-option
                v-for="item in bchsSelectList2"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></w-option>
            </w-select>
            <popover-nurse
              label-key="BCHSMC"
              value-key="BCHSDM"
              :index="$rowIndex"
              :row="{
                ...row,
                JCFW_DM: form.SJKS,
                type: 'checkForHs',
                title: '被查护士选择'
              }"
              @changeValue="changeBCHS"
            >
            </popover-nurse>
          </div>
          <w-input
            v-else-if="row.SFWSJ || !row.editAble"
            :disabled="row.SFWSJ || !row.editAble"
            :value="
              Array.isArray(row.BCHSMC) ? row.BCHSMC.join(',') : row.BCHSMC
            "
            placeholder="请选择"
            @change="handleChangeContent"
          >
            <template slot="suffix">
              <i class="w-icon-template" style="font-size: 16px" />
            </template>
          </w-input>
        </template>
      </vxe-column>
      <!-- 1020 病人表单 1019科室表单 -->
      <vxe-column
        v-if="form.JCLX === 1020 || (form.JCLX === 1019 && Mjdm === '1')"
        key="BCBRDM"
        field="BCBRDM"
        title="被查患者"
        width="220"
        align="center"
      >
        <template #default="{ row, $rowIndex }">
          <div v-if="!row.SFWSJ && row.editAble" style="display: flex">
            <w-select
              :ref="'bchz' + $rowIndex"
              v-model="row.BCBRDM"
              :class="validClass('BCBRDM', row) ? 'showRedBorder' : ''"
              placeholder=""
              multiple
              collapse-tags
              :tags-threshold="1"
              popper-append-body
              @visible-change="selectIndex = $rowIndex"
              @change="
                (val) => {
                  handleBcbrChange(val, row)
                }
              "
            >
              <w-option
                v-for="item in bchzSelectList"
                :key="item.ID"
                :label="item.Name"
                :value="item.ID"
              ></w-option>
            </w-select>
            <img
              class="pic-people left"
              src="@/common/assets/images/addpeople.png"
              alt="people"
              @click="addPatient(row, $rowIndex)"
            />
          </div>
          <w-input
            v-else-if="row.SFWSJ || !row.editAble"
            :disabled="row.SFWSJ || !row.editAble"
            :value="
              Array.isArray(row.BCBRMC) ? row.BCBRMC.join(',') : row.BCBRMC
            "
            placeholder="请选择"
          >
            <template slot="suffix">
              <img
                class="pic-people left"
                src="@/common/assets/images/addpeople.png"
                alt="people"
              />
            </template>
          </w-input>
        </template>
      </vxe-column>
      <vxe-column
        v-if="isInclude('ZRRDM')"
        key="ZRR"
        field="ZRR"
        :title="xtmj1113"
        width="220"
        align="center"
      >
        <template #default="{ row, $rowIndex }">
          <div v-if="!row.SFWSJ && row.editAble" style="display: flex">
            <w-select
              :ref="'zrr' + $rowIndex"
              v-model="row.ZRRDM"
              :class="validClass('ZRRDM', row) ? 'showRedBorder' : ''"
              placeholder=""
              multiple
              collapse-tags
              :tags-threshold="1"
              popper-append-body
              @visible-change="selectIndex = $rowIndex"
              @change="
                (val) => {
                  handleZrrChange(val, row, $rowIndex)
                }
              "
            >
              <w-option
                v-for="item in zrrSelectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></w-option>
            </w-select>
            <popover-nurse
              label-key="ZRRMC"
              value-key="ZRRDM"
              :index="$rowIndex"
              :row="{
                JCFW_DM: form.SJKS,
                ...row,
                type: 'checkForHs',
                title: '责任人选择'
              }"
              :form="form"
              @changeValue="changePerson"
            >
            </popover-nurse>
          </div>
          <w-input
            v-else-if="row.SFWSJ || !row.editAble"
            :disabled="row.SFWSJ || !row.editAble"
            :value="Array.isArray(row.ZRRMC) ? row.ZRRMC.join(',') : row.ZRRMC"
            placeholder="请选择"
          >
            <template slot="suffix">
              <i class="w-icon-template" style="font-size: 16px" />
            </template>
          </w-input>
        </template>
      </vxe-column>
      <vxe-column
        v-if="isInclude('MEMO')"
        key="MEMO"
        field="MEMO"
        title="备注"
        width="160"
      >
        <template #default="{ row }">
          <w-input
            v-model="row.MEMO"
            type="textarea"
            placeholder="请输入备注"
          ></w-input>
        </template>
      </vxe-column>
      <vxe-column
        v-if="isInclude('FJ')"
        key="FJ"
        field="FJ"
        title="附件"
        width="60"
        align="center"
      >
        <template #default="{ row }">
          <i
            class="w-icon-picture add-img"
            style="color: #0c93b1"
            @click="handleOpenUpload(row)"
          />
          <span class="imgNum">{{ row.TPSL ? row.TPSL : '' }}</span>
        </template>
      </vxe-column>
    </vxe-table>
    <vxe-table
      v-if="hasOther"
      ref="checkTableOther"
      key="checkTableOther"
      v-win-loading="tableLoading"
      class="checkTableOther"
      border
      :height="200"
      :scroll-y="{ enabled: false }"
      :data="otherData"
      show-overflow-tooltip
    >
      <vxe-colgroup key="FJDM" field="FJMC" align="left" title="附加项目">
        <vxe-column
          key="FJMC"
          width="600"
          field="FJMC"
          title="项目名称"
          align="left"
        >
          <!-- <template #default="{ row }" align="left">
                <w-input
                  v-model="row.XMFZ"
                  :disabled="type === '查看'"
                  type="textarea"
                  @change="calcZf(row)"
                ></w-input>
              </template> -->
        </vxe-column>
        <vxe-column
          key="FJSM"
          field="FJSM"
          title="项目说明"
          width="600"
          align="left"
        >
          <!-- <template #default="{ row, $rowIndex }" align="left">
                <w-input
                  v-model="row.BZMC"
                  :disabled="type === '查看'"
                  type="textarea"
                  @change="handleChangeBZMC(row)"
                ></w-input>
              </template> -->
        </vxe-column>
        <vxe-column key="FJVal" field="FJVal" title="项目输入" align="left">
          <template #default="{ row }">
            <!-- 文本框 -->
            <w-input
              v-if="row.FJFS == 1210"
              v-model="row.FJVal"
              placeholder="请输入内容"
              :maxlength="1000"
              show-counter
            ></w-input>
            <!-- 文本域 -->
            <w-input
              v-if="row.FJFS == 1211"
              v-model="row.FJVal"
              type="textarea"
              placeholder="请输入内容"
              :maxlength="1000"
              show-counter
            ></w-input>
            <!-- 数字输入框 -->
            <w-input-number
              v-if="row.FJFS == 1212"
              v-model="row.FJVal"
              :controls="false"
              :maxlength="1000"
              show-counter
            ></w-input-number>

            <!-- 单选 -->
            <w-select
              v-if="row.FJFS == 1213"
              v-model="row.FJVal"
              style="margin-right: 20px; width: 100%"
            >
              <w-option
                v-for="item in FJOption(row)"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></w-option>
            </w-select>
            <!-- 多选 -->
            <w-select
              v-if="row.FJFS == 1214"
              v-model="row.valArr"
              multiple
              style="margin-right: 20px; width: 100%"
            >
              <w-option
                v-for="item in FJOption(row)"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></w-option>
            </w-select>
            <!-- 日期 -->
            <w-date-picker
              v-if="row.FJFS == 1215"
              v-model="row.FJVal"
              size="small"
              type="date"
              placeholder="请选择日期"
            ></w-date-picker>
            <!-- 时间 -->
            <w-time-picker
              v-if="row.FJFS == 1216"
              v-model="row.FJVal"
              trigger-suffix
              placeholder="选择时间"
            ></w-time-picker>
            <!-- 日期时间 -->
            <w-date-picker
              v-if="row.FJFS == 1217"
              v-model="row.FJVal"
              type="datetime"
              placeholder="请选择日期"
            ></w-date-picker>
          </template>
        </vxe-column>
      </vxe-colgroup>
    </vxe-table>
    <div class="modal-window-footer">
      <div style="float: left; padding: 10px 20px" v-if="form.CFXH">
        <w-button
          v-if="type === 'check' && changeNumber !== 0 && showChange"
          type="text"
          @click="handleShowBGCS()"
          >{{ '变更次数(' + changeNumber + ')' }}</w-button
        >
      </div>
      <div v-show="!tableLoading" class="window-footer-btns">
        <w-button :disabled="loading" @click="exit()"> 取消 </w-button>
        <w-tooltip
          v-if="showUpdateCheckContent && !rowData.KFXDM"
          content="根据被检查者数同步每一个核查内容数量及被查人信息"
          placement="top-start"
        >
          <w-button
            v-if="showUpdateCheckContent && xtmj1146 != '1'"
            slot="reference"
            :disabled="loading"
            @click="updateCheckContent()"
            >更新核查内容数</w-button
          >
        </w-tooltip>

        <w-dropdown
          v-if="
            checkTypeInfo.JCFS === 1024 &&
            TSHCB === '0' &&
            !isQualifiedRateCheck &&
            !rowData.KFXDM
          "
          trigger="click"
          style="margin: 0px 10px"
          size="medium"
        >
          <w-button size="medium" :disabled="loading">
            将所有结果选择为
            <i class="w-icon-arrow-bottom"></i>
          </w-button>
          <w-dropdown-menu slot="dropdown-menu">
            <w-dropdown-menu-item
              v-for="ck in checkResultList"
              :key="ck.JGDM"
              @click="saveResultForOther(ck)"
              >{{ ck.JGMC }}</w-dropdown-menu-item
            >
          </w-dropdown-menu>
        </w-dropdown>
        <w-button :disabled="loading" @click="save('1', true)"> 保存 </w-button>
        <!-- 提交 -->
        <w-button
          v-if="!rowData.KFXDM && !isDRJC"
          class="mr-15"
          type="primary"
          :disabled="loading"
          @click="submit(true)"
        >
          完成</w-button
        >
        <w-button
          v-if="!rowData.KFXDM && isGroupLeader"
          class="mr-15"
          type="primary"
          :disabled="loading"
          @click="submit()"
        >
          完成</w-button
        >
        <w-button
          v-if="!!rowData.KFXDM"
          class="mr-15"
          type="primary"
          :disabled="loading"
          @click="submit(true)"
        >
          提交</w-button
        >
        <w-button
          v-if="showExportColumns"
          :disabled="loading"
          @click="exportConfig()"
        >
          配置导出列
        </w-button>

        <w-button
          v-if="showExportColumns"
          class="mr-15"
          :disabled="loading"
          @click="print()"
        >
          打印
        </w-button>
        <w-modal
          :visible.sync="showExportConfig"
          :append-to-body="true"
          title="导出列名:"
          width="30%"
        >
          <w-checkbox-group v-model="columnArr">
            <w-checkbox
              v-for="item in exportColumns"
              :key="item.key"
              :disabled="item.disabled"
              :label="item.key"
              style="width: 30%; margin: 5px !important"
              >{{ item.name }}</w-checkbox
            >
          </w-checkbox-group>
          <span slot="footer" class="dialog-footer">
            <w-button @click="exitExport">取 消</w-button>
            <w-button type="primary" @click="confirmExport">确 定</w-button>
          </span>
        </w-modal>
      </div>
    </div>

    <!-- 明细被查患者 -->
    <checked-patients-dialog
      v-if="dialogVisible"
      :dialog-visible="dialogVisible"
      :basic-infor="row"
      :dialog-close="dialogClose"
      :zzjgdm="form.SJKS"
      title="被查患者选择"
    ></checked-patients-dialog>
    <!-- 任务被查患者 -->
    <checked-patients-dialog
      v-if="patientDialogVisible"
      :dialog-visible="patientDialogVisible"
      :dialog-close="patientDialogClose"
      :zzjgdm="form.SJKS"
      title="被查患者选择"
    ></checked-patients-dialog>
    <!-- 上传附件 -->
    <upload-list
      v-if="upVisible"
      :dialog-visible="upVisible"
      :upload-info="uploadInfo"
      :dialog-close="uploadDialogClose"
      :is-multiple="isDRJC"
      is-result="0"
      @updateNum="updateNum"
    />
    <multiple-inspect
      v-if="inspectVisible"
      :dialog-visible="inspectVisible"
      :dialog-close="inspectDialogClose"
      :row="inspectRow"
      :show-field="showCondition"
      :form-data="form"
      @conflictData="conflictData"
    ></multiple-inspect>
    <div
      v-show="tableData.length <= 200"
      class="arrow-tree-container"
      @click.stop="handleClickTree"
    >
      <i v-if="showTree" class="w-icon-triangle-left"></i>
      <i v-if="!showTree" class="w-icon-triangle-right"></i>
    </div>
    <!-- <div class="tree-container-hide" :class="showTree ? 'tree-container' : ''"> -->
    <div
      v-show="showTree && tableData.length <= 200"
      class="tree-container-hide"
    >
      <div class="tree-header">
        <i class="icon-close w-icon-close" @click.stop="handleClickTree"></i>
      </div>
      <w-input
        v-model="filterText"
        placeholder="请输入内容"
        suffix-icon="w-icon-search"
        class="tree-input"
        @input="handleInputChange"
      ></w-input>
      <w-tree
        ref="filterTree"
        :data="anchorArr"
        node-key="id"
        :expand-on-click-node="false"
        :props="defaultProps"
        highlight-current
        :filter-node-method="filterNode"
        @current-change="handleCheckChange"
      ></w-tree>
    </div>
  </div>
</template>

<script>
import {
  CANNOT_MODIFY_CHECK_DATE_DICT_CODE,
  FORBIDDEN_LATERUSE_STATE_CODE
} from '@/apps/modules/common/constants/dictKeys'
import { GetXTMJList } from '@/apps/modules/qc-plan/plan/_api/index'
import PdfDialog from '@/common/components/Dialog/pdfDialog.vue'
import MoreCols from '@/common/components/MoreCols'
import PopoverInput from '@/common/components/Popover/Input.vue'
import PopoverCheck from '@/common/components/PopoverCheck'
import PopoverNurse from '@/common/components/PopoverNurse'
import '@/common/directive/throttle'
import { getTableCheckColumns } from '@/common/utils'
import { Print } from '@/common/utils/download'
import { formatInput, formatInput1 } from '@/common/utils/index.js'
import TreeHelp from '@/common/utils/treeHelp'
import _, { cloneDeep, isEqual } from 'lodash'
import moment from 'moment'
import { mapMutations, mapState } from 'vuex'
import { isNumber } from 'xe-utils'
import { CalcZKJCData, GetZKJCInfo } from '../../_api/index'
import PopoverReason from '../Popover'
import BgcsDialog from './BgcsDialog.vue'
import CheckedPatientsDialog from './CheckedPatientsDialog'
import UploadList from './UploadList.vue'
import MultipleInspect from './MultipleInspect.vue' //检查结果合并
import { RowColumnDefinition } from 'gojs'
import TaskDetailDialog from '../dialog/TaskDetailDialog.vue'
import AddTaskDialog from '../dialog/AddTaskDialog.vue'

export default {
  name: 'AddTaskDialog',
  components: {
    PopoverInput,
    PopoverNurse,
    PopoverCheck,
    CheckedPatientsDialog,
    UploadList,
    PopoverReason,
    MoreCols,
    MultipleInspect
  },
  props: {
    checkType: {
      type: [Number, String],
      default: 1022
    },
    checkDetailInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    listQuery: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 新增还是开始检查
    type: {
      type: String,
      default: ''
    },
    // 复制
    isCopy: {
      type: Boolean,
      default: false
    },
    showChange: {
      type: Boolean,
      default: true
    },
    rowData: {
      type: Object,
      default: () => {
        return {
          KFXDM: false
        }
      }
    },
    selectZkjb: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      typeOptions: [
        { label: '文本框', id: 1210 },
        { label: '文本域', id: 1211 },
        { label: '数字框', id: 1212 },
        { label: '下拉单选', id: 1213 },
        { label: '下拉复选', id: 1214 },
        { label: '日期', id: 1215 },
        { label: '时间', id: 1216 },
        { label: '日期时间', id: 1217 }
      ],
      zkjbOptions: [],
      orgIdArr: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      UserId: '00',
      row: {},
      tableIndex: 0,
      dialogVisible: false,
      patientDialogVisible: false,
      form: {
        SJKS: '',
        SJKSMC: '',
        JCBD: '',
        JCBDMC: '',
        DCSJ: new Date(),
        JCZ: '',
        CFXH: '', // 新增时暂时没有该字段值。 需后面对接后修改赋值
        QTJCZID: [],
        BJCZDM: [],
        BJCZMC: [],
        BJCZXX: [],
        // 把被检查者信息拆分为被查护士，被查患者
        BCHSDM: [],
        BCHSMC: [],
        BCHZDM: [],
        BCHZMC: [],
        JCFS: null,
        JCLX: '',
        JCFW: '',
        JCFWMC: '',
        MEMO: '',
        BBH: '',
        HCB_QZ: this.rowData.HCB_QZ ? this.rowData.HCB_QZ : 100,
        BFZSLJC_CJS: '',
        BFZSLJC_HGS: '',
        BFZSLJC_HGL: '',
        ZKJB: '',
        ORGID: '',
        SFBXZG: false,
        TaskToPlan: false,
        ZXH: null
      },
      tableData: [],
      otherData: [],
      BfzJcjgData: [],
      fristBfzJcjg: null,
      sjksDataList: [],
      bjczOptions: [],
      bjczOptionsHs: [],
      jczOptions: [],
      otherJczOptions: [],
      moreVisiable: true,
      showAll: true,
      deptId: '',
      selectedId: '',
      anchorArr: [],
      treeSelectParams: {
        multiple: false,
        clearable: true,
        placeholder: '请选择表格数据',
        filterable: true,
        'check-strictly': true,
        'default-expand-all': true,
        'expand-on-click-node': false,
        treeClickParent: false,
        treeData: [],
        treeProps: {
          children: 'Child',
          label: 'name',
          disabled: 'disabled',
          value: 'id'
        }
      },
      reasonList: [],
      styles: {
        width: '240px'
      },
      styleSelect: {
        width: '120%',
        'max-width': '240px'
      },
      upVisible: false,
      uploadInfo: {},
      loading: false,
      tableLoading: false,
      value: '',
      scoreInfo: {
        DFL: 0,
        LSL: 0,
        WCL: 0,
        ZDF: 0,
        ZKF: 0,
        WSJF: 0,
        XXZBQK: '',
        ItemPrecentList: []
      },
      BDZF: 0,
      checkResultList: [],
      checkTypeInfo: {
        JCFS: '', // id
        JCFSMC: '', // 名称
        KFFS: ''
      },
      Mjdm: '0',
      TSHCB: '0', // 默认不是特殊核查表
      isHGL: '0',
      JFFS: 0,
      isToZRRY: '0',
      HSZinfo: [],
      isRemindSaveAfterPlanDate: false,
      isShowKFBZColumn: true,
      isSettingDefaultBJCZ: false,
      canNotModifyCheckDate: false,
      xtmj1111: false,
      xtmj1256: false,
      xtmj1120: false,
      xtmj1113: '责任人',
      xtmj1157: ['0', '0', '0'], // 序号0 是扣分原因是否必填，序号1是被查护士 / 病人必填  序号2 责任人必填
      xtmj1179: '0',
      xtmj1186: false,
      bd1186: false, // 原参数1186控制所有百分制表单，现在改为表单单独设置
      xtmj1190: false, //是否禁用延用
      xtmj1198: '200',
      xtmj1147: '',
      laterUse: false,
      isShowHGSCheck: false, //是否合格数检查
      lastSnapshot: '', //最后的快照,方便比较当前用户是否进行了操作
      lastJCLX: null,
      isSaved: false,
      isRecordSimple: false, //是否打开1146记录样本数
      isQualifiedRateCheck: false, //是否合格率计分1032
      isShowReason: false,
      showTree: false,
      filterText: '',
      anchorId: '',
      SXTQBR: false,
      selectedBjczOptions: [],
      isNeedComfirm: true,
      SHNR: '', // 审核内容logo显示的文字
      allSFWSJ: false, //未涉及值
      canSelectZkjb: false,
      canSelectDcbm: false,
      tableColumns: [
        {
          name: '未涉及',
          key: 'SFWSJ',
          keepChoosing: false,
          checked: true
        },
        {
          name: '扣分原因说明',
          key: 'KFYYSM',
          keepChoosing: false,
          checked: true
        },
        {
          name: '被查护士',
          key: 'BCHSDM',
          keepChoosing: false,
          checked: true
        },
        {
          name: '责任人',
          key: 'ZRRDM',
          keepChoosing: false,
          checked: true
        },
        {
          name: '备注',
          key: 'MEMO',
          keepChoosing: false,
          checked: false
        },
        {
          name: '附件',
          key: 'FJ',
          keepChoosing: false,
          checked: true
        }
      ],
      showTableCheckList: [],
      showExportConfig: false,
      showExportColumns: false,
      exportColumns: [
        {
          name: '项目',
          key: 'XMMC',
          disabled: true
        },
        {
          name: '质量标准',
          key: 'BZMC',
          disabled: true
        },
        {
          name: '扣分标准',
          key: 'KFMC',
          disabled: true
        },
        {
          name: '分值',
          key: 'KFFZ',
          disabled: true
        },
        {
          name: '扣加分',
          key: 'JGMC',
          disabled: true
        },
        {
          name: '合格率',
          key: 'HGL'
        },
        {
          name: '未涉及',
          key: 'SFWSJ'
        },
        {
          name: '扣分原因说明',
          key: 'KFYYSM'
        },
        {
          name: '被查护士',
          key: 'BCHSMC'
        },
        {
          name: '责任人',
          key: 'ZRRMC'
        },
        {
          name: '被查患者',
          key: 'BCBRMC'
        },
        {
          name: '备注',
          key: 'MEMO'
        }
      ],
      resultItemColumns: [
        {
          name: '总得分',
          key: 'ZDF',
          keepChoosing: true,
          checked: true
        },
        {
          name: '得分率',
          key: 'DFL',
          keepChoosing: false,
          checked: false
        },
        {
          name: '落实率',
          key: 'LSL',
          keepChoosing: false,
          checked: false
        },
        {
          name: '完成率',
          key: 'WCL',
          keepChoosing: false,
          checked: false
        },
        {
          name: '表单总分',
          key: 'BDZF',
          keepChoosing: false,
          checked: false
        },
        {
          name: '总扣分',
          key: 'ZKF',
          keepChoosing: false,
          checked: false
        },
        {
          name: '未涉及分',
          key: 'WSJF',
          keepChoosing: false,
          checked: false
        }
      ],
      resultCheckList: [],
      columnArr: [],
      ifShowAllCheck: false,
      indeterminate: false, //未涉及全选是否为半勾选状态
      xtmj1195val: 1,
      selectIndex: 0,
      dialogZrrArr: [],
      hasOther: false,
      timer: null,
      paramTime: null, // 获取的SESSION 时间 （分钟）
      cloneTableData: [], //克隆查询的表格数据
      cloneFormData: {}, // 克隆查询的表单数据
      isMustReform: true, //表单必须整改
      bsySfcyjs: false,
      KF_JGDM_INDEX: '', //扣分项  HCBJGList数组用inde
      loadingcheck: true, //其他选择者 有前置条件，但还没搞清业务逻辑先加延迟，zj
      inspectVisible: false,
      inspectRow: [],
      groupLeader: '',
      isGroupLeader: false, //是否组长
      isGroups: false,
      showCondition: {
        TSHCB: '0',
        isHGL: '0',
        JCFS: 0,
        checkResultList: [],
        xtmj1195: 1,
        Mjdm: '0', // 1127参数
        ORGID: '',
        xtmj1113: '责任人',
        bsySfcyjs: false, // 1228 参数
        KFXDM: false,
        JCLX: '',
        isToZRRY: '-1',
        bjczOptions: [],
        jczOptions: [],
        bjczOptionsHs: [],
        HSZinfo: [],
        markData: [],
        isSave: false,
        isShowKFBZColumn: true
      },
      groupJCZ: '',
      isDRJC: false,
      isRevoke: false,
      isShowPercentage: 0, //是否展示占比情况
      zkjbJudeg: '3级',
      qtjczSourceList: [],
      isAllSelected: false,
      frequency: 5,
      xtmj1250: '0',
      xtmj1146: '0',
      showTaskToPlan: false,
      bchsSelectList: [], // 被查护士下拉框数据
      bchsSelectList2: [], //被查护士头部选择后的数据
      bchzSelectList: [], //被查患者下拉框数据
      zrrSelectList: [], // 责任人下拉框数据
      batchList: [],
      currentCfxh: 0,
      jdxx: '',
      showBatchInfo: false,
      showNext: true,
      showPrevious: true,
      checkTableKey: Math.random(),
      HCBJGListLength: 0,
      isCrosswise: false // 是否横排
    }
  },
  computed: {
    ...mapState('check', ['beforeClose']),
    //计算表格高度
    tableHeight() {
      // 150  展开时更多时。  80 得分信息  60  底部按钮高度
      if (
        this.xtmj1250 == '1' &&
        this.xtmj1250 == '1' &&
        this.checkTypeInfo.JCFS == '1024'
      ) {
        return (
          window.innerHeight -
          (this.moreVisiable ? 184 : 90) -
          80 -
          62 -
          (this.hasOther ? 200 : 0) -
          34
        )
      } else {
        return (
          window.innerHeight -
          (this.moreVisiable ? 184 : 90) -
          80 -
          62 -
          (this.hasOther ? 200 : 0)
        )
      }
    },
    // 展示计算方式
    calculationFuc() {
      let strs = ''
      if (this.type === 'add') {
        strs = this.checkTypeInfo.JCFSMC
      } else {
        strs = this.rowData.JCFS_MC ? this.rowData.JCFS_MC : ''
      }
      return strs
    },
    // 项目添加扣分项时
    showAddBtns() {
      return function (row, index) {
        let next = this.tableData[index + 1]
        if (this.TSHCB === '1') {
          return false
        }
        // 无下一行数据  根据是否是新增的判断
        if (!next && row.ISADD) {
          return false
        } else if (!next && !row.ISADD) {
          return true
        }
        if (next && row.BZDM == next.BZDM && !row.ISADD) {
          return true
        }
        if (next && row.KFDM !== next.KFDM && !row.ISADD) {
          return true
        }
        if (next && !row.ISADD) {
          return false
        }
      }
    },
    showUpdateCheckContent() {
      let dcjc = false
      if (this.tableData && this.tableData.length > 0) {
        dcjc = this.tableData[0].DCJC === 1
      }
      const isMutipleSimple = this.form.BJCZDM && this.form.BJCZDM.length >= 2
      let notValid = true
      this.form.BJCZDM.forEach((item) => {
        if (
          (!this.bjczOptions.find((i) => i.id == item)?.isPatient &&
            this.form.JCLX === 1019) ||
          this.form.JCLX !== 1019
        ) {
          notValid = false
        }
      })
      return dcjc && isMutipleSimple && !notValid
    },
    changeNumber: {
      get() {
        return this.rowData && this.rowData.BGCS ? this.rowData.BGCS : 0
      },
      set(newValue) {
        this.rowData.BGCS = newValue
      }
    },
    checkWidth() {
      return 150 + this.checkResultList.length * 50
    }
  },
  watch: {
    'form.BJCZDM': {
      handler(newVal, oldVal) {
        let that = this
        if (this.form.BJCZMC.length !== this.form.BJCZDM.length) {
          this.form.BJCZMC = []
          this.form.BJCZDM.forEach((item) => {
            //被检查者名称和代码一定要对应一致
            if (this.bjczOptions.find((i) => i.id == item)) {
              let bjczInfo = this.bjczOptions
                .find((i) => i.id == item)
                .name.includes(')')
                ? this.bjczOptions.find((i) => i.id == item).name
                : this.bjczOptions.find((i) => i.id == item).name +
                  '(' +
                  item +
                  ')'
              if (bjczInfo != null && bjczInfo.length > 0) {
                this.form.BJCZMC.push(bjczInfo)
              }
            }
          })
        }
        let removeFlag = false //被查护士或者被查患者有要移除的角色才弹框
        let removeArr =
          oldVal && newVal.length < oldVal.length
            ? _.difference(oldVal, newVal)
            : []
        this.tableData.forEach((item) => {
          for (let i = 0; i < removeArr.length; i++) {
            if (
              item.BCHSDM.includes(removeArr[i]) ||
              item.BCBRDM.includes(removeArr[i])
            ) {
              removeFlag = true
            }
          }
        })
        if (
          oldVal &&
          newVal.length < oldVal.length &&
          removeFlag &&
          this.isNeedComfirm
        ) {
          this.$Confirm('是否同步移除被查护士和被查患者中的角色？', '提示', {
            showCancelButton: true,
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            type: 'warning'
          })
            .then(() => {
              let reduceArr = oldVal.filter((item) => {
                return newVal.indexOf(item) == -1
              })
              this.tableData.forEach((item) => {
                item.BCHSMC = []
                item.BCHSDM = item.BCHSDM.filter((i) => {
                  return reduceArr.findIndex((o) => o === i) == -1
                })
                item.BCHSDM.forEach((i) => {
                  that.bchsSelectList.find((j) => j.id == i).name
                })
                item.ZRRMC = []
                item.ZRRDM = item.ZRRDM.filter((i) => {
                  return reduceArr.findIndex((o) => o === i) == -1
                })
                item.ZRRDM.forEach((i) => {
                  that.zrrSelectList.find((j) => j.id == i).name
                })
                item.BCBRMC = []
                item.BCBRDM = item.BCBRDM.filter((i) => {
                  return reduceArr.findIndex((o) => o === i) == -1
                })
                item.BCBRDM.forEach((i) => {
                  that.bchzSelectList.find((j) => j.ID == i).Name
                })
              })
              setBchsOption()
            })
            .catch(() => {
              this.form.BJCZDM = oldVal
            })
        } else {
          setBchsOption()
        }
        function setBchsOption() {
          // 原有方法每行都增加了数据，导致数据量过大
          that.form.BCHSDM.forEach((m, index) => {
            if (!that.bchsSelectList.some((k) => k.id == m)) {
              that.bchsSelectList.push({
                id: m,
                name: that.form.BCHSMC[index]
              })
            }
            if (!that.bchsSelectList2.some((k) => k.id == m)) {
              that.bchsSelectList2.push({
                id: m,
                name: that.form.BCHSMC[index]
              })
            }
            if (!that.zrrSelectList.some((k) => k.id == m)) {
              that.zrrSelectList.push({
                id: m,
                name: that.form.BCHSMC[index]
              })
            }
          })
          that.form.BCHZDM.forEach((m, index) => {
            if (!that.bchzSelectList.some((k) => k.id == m)) {
              that.bchzSelectList.push({
                id: m,
                name: that.form.BCHZMC[index],
                ID: m,
                Name: that.form.BCHZMC[index]
              })
            }
          })
        }
      },
      immediate: true
    },
    'form.JCLX': {
      handler(val) {
        if (val == 1020) {
          this.tableColumns.splice(2, 1)
        } else if (this.tableColumns.length == 4) {
          this.tableColumns.splice(2, 0, {
            name: '被查护士',
            key: 'BCHSDM',
            keepChoosing: false,
            checked: true
          })
        }
      },
      immediate: false
    },
    'form.SJKS': {
      handler(val) {
        this.GetHsByZZJG()
      }
    }
  },
  created() {
    if (this.selectZkjb) {
      this.getZKJB()
    }

    switch (`${this.listQuery.ZKJB}`) {
      case '1001':
        this.zkjbJudeg = '3级'
        break
      case '1002':
        this.zkjbJudeg = '2级'
        break
      case '1003':
        this.zkjbJudeg = '1级'
        break
    }

    // 一级新增检查特殊处理（默认受检科室）
    if (this.listQuery.ZKJB == '1003' && this.type !== 'check') {
      this.initZZJG()
      this.form.SJKS = this.listQuery.ORGID
    }
    this.$requestApi('GetSessionTimeout', {}).then((res) => {
      // 判断一下sessionT 时间存在且T-60 需有合理值。
      if (res.data && Number(res.data) > 1) {
        this.paramTime = (Number(res.data) - 1) * 60 * 1000
        this.setInterVal()
      }
    })
    this.isCrosswise =
      sessionStorage.getItem('IS_CROSSWISE') === 'true' || false
  },
  async mounted() {
    let that = this
    this.handleScroll()
    await that.getSysTemSetting(() => {
      // 设置督查时间
      that.settingDCSJ()

      // 从开始检查中跳转过来
      if (that.type === 'check') {
        that.BDZF = that.rowData.BDZF
        const {
          JCFW_DM,
          JCFW_MC,
          ZZ,
          ZZMC,
          ZY,
          ZYMC,
          JCXM_MC,
          JCXM_DM,
          CJSJ,
          BJCZMC,
          BJCZDM,
          BJCZXX,
          CFXH,
          JCFS,
          JCFS_MC,
          KFFS,
          JCLX,
          MEMO,
          BBH,
          JLJCSJ,
          SHNR
        } = that.rowData
        that.SHNR = SHNR
        that.form.SJKS = String(JCFW_DM)
        that.form.SJKSMC = JCFW_MC
        that.form.JCBD = JCXM_DM
        that.form.JCBDMC = JCXM_MC
        let userInfo = that.$store.state.user.loginUserInfo
        that.form.JCZ = ZZ || userInfo.UserId
        that.form.ZYMC = ZZMC || userInfo.UserName + '(' + userInfo.UserId + ')'
        that.form.BJCZMC = BJCZMC && !that.isCopy ? BJCZMC.split(',') : []
        that.form.BJCZDM =
          BJCZDM && !that.isCopy
            ? _.compact(BJCZDM.split(',')).filter(function (item) {
                return item != '-1'
              })
            : [] // 被检查护士
        that.form.BJCZXX = BJCZXX && !that.isCopy ? BJCZXX.split(',') : []
        let { bchs, bchz } = that.splitToBchsAndBchz(
          that.form.BJCZDM,
          that.form.BJCZMC,
          that.form.BJCZXX
        )
        that.form.BCHSDM = bchs.map((m) => m.id)
        that.form.BCHSMC = bchs.map((m) => m.name)
        that.form.BCHZDM = bchz.map((m) => m.id)
        that.form.BCHZMC = bchz.map((m) => m.name)

        that.bchsSelectList = bchs
        that.bchzSelectList = bchz.map((m) => {
          return { ...m, ID: m.id, Name: name }
        })

        that.form.CFXH = CFXH ? CFXH : ''
        that.form.JCFS = JCFS
        that.form.JCLX = JCLX
        that.form.MEMO = MEMO
        that.form.BBH = BBH
        that.laterUse = JLJCSJ === '1' ? true : false
        that.checkTypeInfo = {
          JCFS,
          JCFSMC: JCFS_MC,
          KFFS: KFFS
        }
        that.getZkjcinfo()
        if (that.selectZkjb) {
          that.form.ZKJB = `${that.rowData.ZKJB}`
          that.form.ORGID = that.rowData.ORGID ? that.rowData.ORGID + '' : ''
        }
        that.getSJKS(JCFW_DM)
        that.getBJCZ()
        if (that.form.JCFS == 1024) {
          that
            .$requestApi('GetHCBCheckResult', {
              Bddm: that.form.JCBD
            })
            .then((res) => {
              that.checkResultList = res.data
              if (that.TSHCB === '1') {
                that.checkResultList.forEach((item) => {
                  that.$set(item, 'YBSL', '')
                  that.$set(item, 'DXZB', '')
                })
              }
              if (this.scoreInfo.XXZBQK && this.scoreInfo.XXZBQK != '') {
                this.scoreInfo.ItemPrecentList = this.scoreInfo.XXZBQK.split(
                  ';'
                ).map((i) => {
                  let item = i.split(':')
                  let xxObj = new Object()
                  let hcbjg = that.checkResultList.find(
                    (j) => j.JGMC == item[0]
                  )

                  xxObj.JGDM = hcbjg.JGDM
                  xxObj.JGMC = item[0]
                  xxObj.YBZB = item[1]
                  return xxObj
                })
              }
              this.genResultOptions('1024')
            })
        } else {
          this.genResultOptions('1022')
        }
        if (!that.isCopy) {
          that.getExportColumns()
        }
      } else {
        that.form.JCZ = that.$store.state.user.loginUserInfo.UserId
        // that.form.JCZ = '' //检查者暂时不默认当前用户
        that.form.ZYMC =
          that.$store.state.user.loginUserInfo.username +
          '(' +
          that.form.JCZ +
          ')'
        // that.form.ZYMC = ''
        // 检查表单类型为核查表时查询获取结果另存为信息
        that.checkTypeInfo.JCFSMC =
          that.checkType === 1022 ? '百分制' : '核查表'
        that.checkTypeInfo.JCFS = that.checkType
        that.form.JCFS = that.checkType
        if (!that.selectZkjb) {
          that.getSJKS(that.listQuery.ORGID)
        }

        that.$nextTick(() => {
          that.loadingcheck = false
        })
      }
      that.showTableCheckList =
        that.type === 'add'
          ? that.tableColumns
          : getTableCheckColumns(
              `addDialog${that.rowData.CFXH}`,
              that.tableColumns
            )
      // 复制时需要清除掉CFXH和被查护士
      if (that.isCopy) {
        that.form.CFXH = null
        that.form.DCSJ = moment().format('YYYY-MM-DD')
        that.form.SFMFJC = '0'
      }
      //获取检查者和其他检查者
      if (!that.selectZkjb) {
        that.getQTJCZ()
      }
    })
  },
  beforeDestroy() {
    this.SET_BEFORE_CLOSE(false)
    clearInterval(this.timer)
  },
  methods: {
    ...mapMutations('check', ['SET_BEFORE_CLOSE']),
    // 根据被查护士，被查患者，组装被检查者数据
    buildBJCZInfo() {
      let that = this
      let bjczdm = []
      let bjczmc = []
      let bjczxx = []
      if (
        that.form.BCHSDM &&
        that.form.BCHSMC &&
        that.form.BCHSDM.length == that.form.BCHSMC.length
      ) {
        that.form.BCHSDM.forEach((item, index) => {
          if (!bjczdm.some((m) => m == item)) {
            bjczdm.push(item)
            bjczmc.push(that.form.BCHSMC[index])
            bjczxx.push(item + '$1')
          }
        })
      }
      if (
        that.form.BCHZDM &&
        that.form.BCHZMC &&
        that.form.BCHZDM.length == that.form.BCHZMC.length
      ) {
        that.form.BCHZDM.forEach((item, index) => {
          if (!bjczdm.some((m) => m == item)) {
            bjczdm.push(item)
            bjczmc.push(that.form.BCHZMC[index])
            bjczxx.push(item + '$2')
          }
        })
      }
      that.form.BJCZDM = bjczdm
      that.form.BJCZMC = bjczmc
      that.form.BJCZXX = bjczxx
    },
    // 被查患者修改后，校对被检查者
    bchzChangeed() {
      this.form.BCHZMC = []
      this.form.BCHZDM.forEach((item) => {
        //被检查者名称和代码一定要对应一致
        if (this.bjczOptions.find((i) => i.id == item)) {
          this.form.BCHZMC.push(
            this.bjczOptions.find((i) => i.id == item).name.includes(')')
              ? this.bjczOptions.find((i) => i.id == item).name
              : this.bjczOptions.find((i) => i.id == item).name +
                  '(' +
                  item +
                  ')'
          )
        }
        if (!this.bchsSelectList2.some((m) => m.id == item.BCHSDM[i])) {
          this.bchsSelectList2.push({
            id: item.BCHSDM[i],
            name: item.BCHSMC[i]
          })
        }
      })
      // 更新被检查者信息
      this.buildBJCZInfo()
    },
    // 被查护士修改后，校对被检查者
    bchsChanged() {
      this.form.BCHSMC = []
      this.form.BCHSDM.forEach((item) => {
        //被检查者名称和代码一定要对应一致
        if (this.bjczOptions.find((i) => i.id == item)) {
          this.form.BCHSMC.push(
            this.bjczOptions.find((i) => i.id == item).name.includes(')')
              ? this.bjczOptions.find((i) => i.id == item).name
              : this.bjczOptions.find((i) => i.id == item).name +
                  '(' +
                  item +
                  ')'
          )
        }
      })
      // 更新被检查者信息
      this.buildBJCZInfo()
    },
    // 将被检查者拆分为被查护士和被查患者 lx：$1 护士 $2患者
    splitToBchsAndBchz(codeArr, nameArr, lxArr) {
      let result = {
        bchs: [],
        bchz: []
      }
      let lxDic = new Map()
      if (lxArr) {
        lxArr.forEach((element) => {
          let temp = element.split('$')
          if (temp.length == 2) {
            lxDic.set(temp[0], temp[1])
          }
        })
      }

      if (codeArr && nameArr && lxArr && codeArr.length == nameArr.length) {
        codeArr.forEach((m, index) => {
          if (lxDic.get(m) == '1') {
            result.bchs.push({
              id: m,
              name: nameArr[index]
            })
          } else {
            result.bchz.push({
              id: m,
              name: nameArr[index]
            })
          }
        })
      }
      return result
    },
    // 自动保存定时器
    setInterVal() {
      this.timer = setInterval(() => {
        this.handleAutoSave()
      }, this.paramTime)
    },
    validClass(val, row) {
      return (
        this.xtmj1157[
          val == 'KFYYSM' ? 0 : val == 'BCHSDM' || val == 'BCBRDM' ? 1 : 2
        ] == '1' &&
        (!row[val] || (Array.isArray(row[val]) && row[val].length == 0)) &&
        ((val != 'BCBRDM' && this.isInclude(val)) ||
          (val == 'BCBRDM' &&
            (this.form.JCLX === 1020 ||
              (this.form.JCLX === 1019 && this.Mjdm === '1')))) &&
        !row.SFWSJ &&
        ((this.form.JCFS == 1022 &&
          row.KFJG &&
          row.KFJG.toString().indexOf('+') == -1) ||
          (this.isQualifiedRateCheck && row.HGL != 1) ||
          (this.form.JCFS == 1024 &&
            row.HCBJGList.find((m) => m.JGDM == row.KFJG).ISNRFM !== '0' &&
            row.HCBJGList.find((m) => m.JGDM == row.KFJG).ISNRJS === '0')) // 如果没有纳入分母，且没有纳入分子，是不需要标红的
      )
    },
    handleScroll() {
      document
        .querySelector('.vxe-table--body-wrapper')
        .addEventListener('scroll', () => {
          if (this.$refs['bchs' + this.selectIndex]) {
            this.$refs['bchs' + this.selectIndex].blur()
          }
          if (this.$refs['zrr' + this.selectIndex]) {
            this.$refs['zrr' + this.selectIndex].blur()
          }
          if (this.$refs['bchz' + this.selectIndex]) {
            this.$refs['bchz' + this.selectIndex].blur()
          }
        })
    },
    isInclude(str) {
      return this.showTableCheckList.find((i) => i.key == str) ? true : false
    },
    getLastCheckList(val) {
      if (this.type === 'add') {
        return
      }
      if (val.length > 0) {
        localStorage.setItem(
          `addDialog${this.rowData.CFXH}`,
          JSON.stringify({
            showTableCheckList: val
          })
        )
      } else {
        localStorage.removeItem(`addDialog${this.rowData.CFXH}`)
      }
    },
    getZKJB() {
      this.$requestApi('GetZkjbByUserId').then((res) => {
        if (res.success) {
          this.zkjbOptions = res.data.map((item) => {
            return {
              label: item.name,
              value: item.id
            }
          })
          this.canSelectZkjb = true
          this.form.ZKJB = this.listQuery.ZKJB
            ? this.listQuery.ZKJB + ''
            : this.zkjbOptions.length > 0
            ? `${this.zkjbOptions[0].value}`
            : ''
          this.getCheckDepartInfo(this.form.ZKJB)
        }
      })
    },
    // 获取督查部门
    getCheckDepartInfo(Zkjb) {
      let that = this
      this.$requestApi('GetOrg', {
        UserId: that.$store.state.user.loginUserInfo.UserId,
        HospitalCode: that.listQuery.HospitalCode,
        Zkjb: Zkjb,
        BusinessType: that.rowData.CZLX
      }).then((res) => {
        if (res.success) {
          that.orgIdArr = []
          res.data.forEach((item) => {
            let child = item.Child
            if (child) {
              child.forEach((i) => {
                that.orgIdArr.push({
                  name: i.name,
                  id: i.id,
                  QYZT: i.customAttr || i.QYZT
                })
              })
            } else {
              that.orgIdArr.push({
                name: item.name,
                id: item.id,
                QYZT: item.customAttr || item.QYZT
              })
            }
          })

          if (that.type == 'add') {
            that.orgIdArr = that.orgIdArr.filter(
              (item) => item.id.indexOf('-1112') == -1
            )
          }
          that.canSelectDcbm = true
          let canSelectOrgIdArr = that.orgIdArr.filter(
            (item) => item.QYZT === '1'
          )

          if (!that.form.ORGID) {
            that.form.ORGID =
              (that.listQuery.ORGID || Array.isArray(that.listQuery.ORGID)) &&
              !that.listQuery.ORGID.toString().includes('-1112')
                ? that.listQuery.ORGID + ''
                : canSelectOrgIdArr.length > 0
                ? canSelectOrgIdArr[0].id
                : ''
          }
          if (that.form.ORGID && that.form.ORGID.toString().includes('-1112')) {
            var zkzObj = canSelectOrgIdArr.find((item) =>
              item.id.includes('-1112')
            )
            if (zkzObj) {
              that.form.ORGID = zkzObj.id
            }
          }
          this.getSJKS(this.form.ORGID)
          this.getQTJCZ()
        }
      })
    },
    handleDcbmChange() {
      this.form.SJKS = ''
      this.form.SJKSMC = ''
      this.form.JCBD = ''
      this.form.JCBDMC = ''
      this.tableData = []
      this.getSJKS(this.form.ORGID)
      this.getQTJCZ()
    },
    handleAllSFWSJ() {
      if (this.allSFWSJ) {
        this.$Confirm(
          '全选未涉及将清空所有的质量检查打分，确认该操作吗？',
          '提示',
          {
            showCancelButton: true,
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            type: 'warning'
          }
        )
          .then(() => {
            this.handleCheckAll()
          })
          .catch(() => {
            this.allSFWSJ = !this.allSFWSJ
          })
      } else {
        this.handleCheckAll()
      }
    },
    getExportColumns() {
      this.showExportColumns = true
      if (!this.isShowKFBZColumn) {
        let index = this.exportColumns.findIndex((i) => i.key == 'KFMC')
        this.exportColumns.splice(index, 1)
      }
      if (this.checkTypeInfo.JCFS === 1024) {
        let index = this.exportColumns.findIndex((i) => i.key == 'KFFZ')
        this.exportColumns.splice(index, 1)
      }

      if (
        !(
          this.checkTypeInfo.JCFS === 1024 &&
          this.TSHCB == '1' &&
          this.xtmj1147 == '1'
        )
      ) {
        let index = this.exportColumns.findIndex((i) => i.key == 'HGL')
        this.exportColumns.splice(index, 1)
      }

      if (this.TSHCB !== '0' || this.isQualifiedRateCheck) {
        this.exportColumns.find((i) => i.key == 'JGMC').name =
          this.isShowPercentage == '1' ? '结果&样本' : '结果&样本&占比情况'
      } else {
        if (this.exportColumns.find((i) => i.key == 'JGMC')) {
          this.exportColumns.find((i) => i.key == 'JGMC').name =
            this.checkTypeInfo.JCFS !== 1024 ? '扣加分' : '结果'
        }
      }
      if (this.form.JCLX === 1020) {
        let index = this.exportColumns.findIndex((i) => i.key == 'BCHSMC')
        this.exportColumns.splice(index, 1)
      }

      if (this.exportColumns.find((i) => i.key == 'ZRRMC')) {
        this.exportColumns.find((i) => i.key == 'ZRRMC').name = this.xtmj1113
      }
      this.columnArr = this.exportColumns.map((item) => {
        return item.key
      })
      if (
        this.form.JCLX !== 1020 &&
        (this.form.JCLX !== 1019 || this.Mjdm !== '1')
      ) {
        let index = this.exportColumns.findIndex((i) => i.key == 'BCBRMC')
        this.exportColumns.splice(index, 1)
      }
    },
    kfyysmChange(row) {
      row['changeKFYYSM'] = 1
      this.handleChangeContent()
    },
    // 一级部门新增默认传入的orgid
    handleChangeContent() {
      this.SET_BEFORE_CLOSE(true)
    },
    handleChangeJCZ(detail) {
      console.log('detail1212', detail)
      this.form.JCZ = detail.JCZ.join(',')
      this.form.ZYMC = detail.ZYMC.join(',')
      this.SET_BEFORE_CLOSE(true)
    },
    handleChangeQTJCZ(detail) {
      this.form.QTJCZID = detail.QTJCZID.join(',')
      this.form.QTJCZMC = detail.QTJCZMC.join(',')
      this.SET_BEFORE_CLOSE(true)
    },
    initZZJG() {
      let that = this
      this.$requestApi('GetAllZzjgTreeByOrgid', {
        orgid:
          this.selectZkjb && this.type != 'check'
            ? this.form.ORGID
            : this.listQuery.ORGID,
        HospitalCode: this.listQuery.HospitalCode
      }).then((res) => {
        let data = res.data
        if (data && data.length > 0) {
          let flag = data.find((m) => m.id == that.listQuery.ORGID)
          if (flag) {
            that.form.SJKS = flag.id
            that.form.SJKSMC = flag.name
          }
        }
      })
    },
    initQTJCZ() {
      //type check时 其他检查者列表加载结束后，显示组件块  其他mouted里处理
      if (this.type == 'check') {
        this.$nextTick(() => {
          this.loadingcheck = false
        })
      }

      // 不是复制或开始检查时不需要处理
      if (!(this.isCopy || this.type == 'check')) {
        return
      }
      const { ZY, ZYMC } = this.rowData
      //处理组员不在本组的情况
      let zyArr = ZY
        ? _.compact(ZY.split(',')).filter(function (item) {
            return item != '-1'
          })
        : []
      let zyMcArr = ZYMC
        ? _.compact(ZYMC.split(',')).filter(function (item) {
            return item != '-1'
          })
        : []
      if (zyArr.length <= 0 || this.jczOptions.length === 0) {
        this.form.QTJCZID = zyArr
        this.form.QTJCZMC = ZYMC
        return
      }
      const idArr = this.jczOptions.map((item) => item.ID)
      // 找出当前不在的组员（去掉该部分逻辑）
      // let notInZy = zyArr.filter((item) => !idArr.includes(item))
      // let notInZyMc = []
      // if (notInZy.length > 0) {
      //   // 如果有把它删除掉
      //   notInZy.forEach((item) => {
      //     const index = zyArr.indexOf(item)
      //     notInZyMc.push(zyMcArr[index])
      //     zyArr.splice(index, 1)
      //     zyMcArr.splice(index, 1)
      //   })
      //   this.form.QTJCZID = zyArr
      //   this.form.QTJCZMC = zyMcArr.join(',')

      //   const unInZyMC = notInZyMc.join(',')

      //   if (unInZyMC) {
      //     this.$Message({
      //       type: ' info',
      //       message: '【其他检查者】部分人员不在检查任务的督查部门',
      //       detail: `${unInZyMC}已经不在检查任务的督查部门，因此没有显示`,
      //       duration: 5000
      //     })
      //     // this.$msg(
      //     //   `其他检查者：${unInZyMC}已经不在检查任务的督查部门，因此没有显示`,
      //     //   'info'
      //     // )
      //   }
      //   return
      // }
      this.form.QTJCZID = zyArr // 其他检查者
      this.form.QTJCZMC = ZYMC
      this.cloneFormData = cloneDeep(this.form)
    },
    //获取系统配置相关
    getSysTemSetting(callback) {
      let JCFS = this.rowData.JCFS ? this.rowData.JCFS : this.checkType
      let Mjdm =
        '1127,1077,1115,1090,1111,1181,1157,1113,1179,1186,1190,1195,1198,1203,1120,1226,1228,1147,1146,1134,1248,1250,1256'

      let params = GetXTMJList({ Mjdm }).then((res) => {
        if (res.success) {
          let data = res.data
          this.ifShowAllCheck =
            data.find((item) => item.MJDM == 1203).JLZT == '1'
          this.xtmj1111 = data.find((item) => item.MJDM == 1111).JLZT == '1'
          this.xtmj1256 = data.find((item) => item.MJDM == 1256)?.JLZT == '1'
          this.xtmj1120 = data.find((item) => item.MJDM == 1120).JLZT == '1'
          this.isMustReform = data.find((item) => item.MJDM == 1226).JLZT == '1'
          this.bsySfcyjs = data.find((item) => item.MJDM == 1228).JLZT == '1'
          this.xtmj1147 = data.find((item) => item.MJDM == 1147).JLZT
          this.xtmj1198 = data.find((item) => item.MJDM == 1198)?.BZ
          this.Mjdm = data.filter((item) => item.MJDM === 1127)[0].JLZT
          let xtmj1195 = data.find((item) => item.MJDM == 1195)
          this.isShowPercentage = data.find((item) => item.MJDM == 1248)?.JLZT
          // 1146
          this.xtmj1146 = data.find((item) => item.MJDM == 1146).JLZT
          // 1250参数
          this.xtmj1250 = data.find((item) => item.MJDM == 1250).JLZT
          if (this.xtmj1250 == '1') {
            this.frequency = data.find((item) => item.MJDM == 1250).BZ
          }
          if (xtmj1195.JLZT == '1') {
            this.xtmj1195val = parseFloat(xtmj1195.BZ)
          }

          // 与产品沟通，如果打开1146，就按特殊核查表来，TODO如果1146先关闭，产生的历史数据需要处理下
          if (JCFS === 1024) {
            this.TSHCB = data.filter((item) => item.MJDM === 1146)[0].JLZT
          }
          // 1157参数开启，提示： 存在【扣分原因】, 【被查护士 / 病人】, 【责任人】未录入内容，是否继续保存？
          var value1157 = data.find((item) => item.MJDM == 1157).JLZT
          if (
            value1157 == '1' ||
            value1157 == '4' ||
            value1157 == '5' ||
            value1157 == '7'
          ) {
            this.xtmj1157[0] = '1' //扣分原因必填
          }
          if (
            value1157 == '2' ||
            value1157 == '4' ||
            value1157 == '6' ||
            value1157 == '7'
          ) {
            this.xtmj1157[2] = '1' //责任人必填
          }
          if (
            value1157 == '3' ||
            value1157 == '5' ||
            value1157 == '6' ||
            value1157 == '7'
          ) {
            this.xtmj1157[1] = '1' //被查护士必填
          }
          // 1179参数开启，扣分标准填充至扣分原因
          if (data.some((item) => item.MJDM == 1179)) {
            this.xtmj1179 = data.find((item) => item.MJDM == 1179).JLZT || '0'
          }
          // 1186参数开启，百分制新增总数、合格数、不合格数和合格率四列
          if (data.some((item) => item.MJDM == 1186)) {
            this.xtmj1186 = data.find((item) => item.MJDM == 1186).JLZT == '1'
          }
          // 1113参数开启
          this.xtmj1113 =
            data.find((item) => item.MJDM == 1113).JLZT == '1'
              ? data.filter((item) => item.MJDM === 1113)[0].MJMC
              : '责任人'

          //根据等级设置,前提条件是1077 已经开启
          if (data.filter((item) => item.MJDM === 1077)[0].JLZT != '0') {
            let BZ_1077 = data.filter((item) => item.MJDM === 1077)[0].BZ
            let targetStringIndex = BZ_1077.indexOf(this.zkjbJudeg)
            //找一下指定字符&的位置,截取&后面的设定的数值
            let targetIndex = BZ_1077.indexOf('&', targetStringIndex)
            this.isToZRRY = BZ_1077.slice(targetIndex + 1, targetIndex + 2)
          }

          // this.isToZRRY = data.filter((item) => item.MJDM === 1077)[0].JLZT
          // 当检查时间大于计划结束时间是,是否开启提醒
          this.isRemindSaveAfterPlanDate =
            data.filter((item) => item.MJDM === 1115)[0].JLZT === '1'
          // 核查表是否显示扣分标准列
          if (JCFS === 1024) {
            this.isShowKFBZColumn =
              data.filter((item) => item.MJDM === 1134)[0].JLZT === '1'
          }
          // 是否能修改质控检查时间 1090
          this.canNotModifyCheckDate =
            data.filter(
              (item) => item.MJDM === CANNOT_MODIFY_CHECK_DATE_DICT_CODE
            )[0].JLZT === '1'
          //是否禁用延用
          this.xtmj1190 =
            data.filter(
              (item) => item.MJDM === FORBIDDEN_LATERUSE_STATE_CODE
            )[0].JLZT === '0'

          // 是否默认选择被查人 1181
          this.isSettingDefaultBJCZ =
            data.filter((item) => item.MJDM === 1181)[0].JLZT === '1'
          callback && callback()
        }
      })
    },
    // 获取受检科室
    getSJKS(orgid) {
      if (this.type == 'check') return
      this.$requestApi('GetAllZzjgTreeByOrgid', {
        orgid,
        HospitalCode: this.listQuery.HospitalCode
      }).then((res) => {
        let data = res.data
        this.sjksDataList = []
        if (!data || data.length === 0) return false
        const list = TreeHelp.treeToArray(data, 'Child', 'id')
        for (let i = 0; i < list.length; i++) {
          if (list[i].JBDM == 1003 && list[i].QYZT == '1') {
            this.form.SJKS = list[i].id
            this.form.SJKSMC = list[i].name
            break
          }
        }
        this.sjksDataList = data
        this.cloneFormData = cloneDeep(this.form)
      })
    },
    // 获取被检查者
    getBJCZ() {
      let that = this
      this.$requestApi('GetBJCZ', {
        zzjg: this.form.SJKS,
        bddm: this.form.JCBD,
        cfxh: this.form.CFXH
      }).then((res) => {
        if (res.success) {
          this.bjczOptionsHs =
            res.data && res.data.length > 0
              ? res.data.filter((m) => {
                  return m.type == 1
                })
              : []
          this.bjczOptions = res.data.map((item) => {
            return {
              id: item.id,
              name: item.name,
              type: item.type,
              isPatient: item.type == '2'
            }
          })
          // 假如被检查者，不在接口内部，需要手动加入这些人员
          if (this.form.BJCZDM.length > 0) {
            let codeArr = this.form.BJCZDM
            let nameArr = this.form.BJCZMC
            codeArr.map((m, index) => {
              let isPatient =
                this.form.BJCZXX.length > 0
                  ? this.form.BJCZXX.find((i) => i.split('$')[0] == m)?.split(
                      '$'
                    )[1] == '2'
                  : false
              if (
                !that.bjczOptions.some((item) => {
                  return item.id == m
                })
              ) {
                that.bjczOptions.push({
                  id: m,
                  name: nameArr[index],
                  isPatient: isPatient
                })
              }
              // 拆分成被查护士和被查患者
              if (isPatient && !that.bchzSelectList.some((k) => k.ID == m)) {
                that.bchzSelectList.push({
                  id: m,
                  ID: m,
                  name: nameArr[index],
                  Name: nameArr[index],
                  isPatient: isPatient
                })
              }
              if (!isPatient && !that.bchsSelectList.some((k) => k.id == m)) {
                that.bchsSelectList.push({
                  id: m,
                  name: nameArr[index],
                  isPatient: isPatient
                })
              }

              if (!isPatient && !that.zrrSelectList.some((k) => k.id == m)) {
                that.zrrSelectList.push({
                  id: m,
                  name: nameArr[index],
                  isPatient: isPatient
                })
              }
            })
          } else {
            this.bchsSelectList =
              res.data && res.data.length > 0
                ? res.data.filter((m) => {
                    return m.type == 1
                  })
                : []
            this.bchzSelectList =
              res.data && res.data.length > 0
                ? res.data
                    .filter((m) => {
                      return m.type == 2
                    })
                    .map((item) => {
                      return {
                        id: item.id,
                        name: item.name,
                        ID: item.id,
                        Name: item.name,
                        type: item.type,
                        isPatient: item.type == '2'
                      }
                    })
                : []
          }
          this.cloneFormData = cloneDeep(this.form)
          this.cloneTableData = cloneDeep(this.tableData)
        }
      })
    },
    //获取其他检查者
    getQTJCZ() {
      let dcbmdm =
        this.type === 'check'
          ? this.rowData.ORGID || this.listQuery.ORGID
          : this.selectZkjb
          ? this.form.ORGID
          : this.listQuery.ORGID
      this.$requestApi('GetCheckUser', {
        defaultId: this.type === 'check' ? this.rowData.ZZ : '',
        defaultName: this.type === 'check' ? this.rowData.ZZMC : '',
        OrgId: dcbmdm,
        CFXH:
          this.rowData && this.rowData.CFXH ? this.rowData.CFXH.toString() : ''
      }).then((res) => {
        res.data = res.data.map((item) => {
          return {
            Name: item.NAME,
            ID: item.ID,
            BQName: item.BQ_MC,
            KSName: item.KS_MC
          }
        })
        this.jczOptions = JSON.parse(JSON.stringify(res.data ? res.data : []))
        if (this.form.QTJCZID.length !== 0) {
          this.jczOptions.forEach((item) => {
            if (this.form.QTJCZID.some((i) => i.UserId == item.UserId)) {
              item.disabled = flag
            }
          })
        }
        this.otherJczOptions = JSON.parse(
          JSON.stringify(res.data ? res.data : [])
        )
        this.otherJczOptions.forEach((item) => {
          item.UserId == this.form.JCZ
            ? (item.disabled = true)
            : (item.disabled = false)
        })
        this.initQTJCZ()
      })
    },
    GetHsByZZJG() {
      let param = {
        zzjg: this.form.SJKS,
        type: '2'
      }
      this.$requestApi('GetHsByZZJG', param).then((res) => {
        this.HSZinfo = res.data
      })
    },
    toChildrenStruct(pidArray) {
      // 将数据转换成children结构
      let childrenArray = []
      let XMArr = []
      const itemMap = {}
      if (!pidArray) {
        return childrenArray
      } else {
        for (const item of pidArray) {
          var firstItem = {
            id: item.XMDM,
            label: item.XMMC,
            children: []
          }
          if (!XMArr.includes(item.XMDM)) {
            childrenArray.push(firstItem)
          }
          XMArr.push(item.XMDM)
        }
        for (const i of childrenArray) {
          let BZArr = []
          for (const j of pidArray) {
            if (j.XMDM == i.id) {
              if (!BZArr.includes(j.BZDM)) {
                i.children.push({
                  id: j.BZDM,
                  label: j.BZMC,
                  children: []
                })
              }
              BZArr.push(j.BZDM)
            }
          }
          for (const k of i.children) {
            if (this.isShowKFBZColumn) {
              let KFArr = []
              for (const l of pidArray) {
                if (l.BZDM == k.id) {
                  if (!KFArr.includes(l.KFDM)) {
                    k.children.push({
                      id: l.KFDM,
                      label: l.KFMC
                    })
                  }
                  KFArr.push(l.KFDM)
                }
              }
            }
          }
        }
      }
      return childrenArray
    },
    // 新增时获取检查列表
    queryListByAdd() {
      const obj = {
        Bddm: this.form.JCBD,
        Jcfw: this.form.SJKS,
        Zkjb: this.selectZkjb ? `${this.form.ZKJB}` : `${this.listQuery.ZKJB}`
      }
      this.tableLoading = true
      this.$requestApi('AddZKJCInfo', obj).then((res) => {
        this.hasOther = res.data.FJState || false
        this.otherData =
          res.data.FJXMList && res.data.FJXMList.length > 0
            ? res.data.FJXMList.map((m) => {
                m.FJVal = ''
                m.valArr = m.FJVal ? m.FJVal.split(';') : []
                return m
              })
            : []
        this.BfzJcjgData = res.data.BfzJcjgList
        this.checkTypeInfo.KFFS = res.data.KFFS
        this.anchorArr = this.toChildrenStruct(res.data.CheckList)
        this.tableLoading = false
        this.bd1186 = res.data.SFJL_JCRS_HGL
        const respData = res.data
        this.form.BBH = respData && respData.BBH
        if (respData.CheckList && respData.CheckList.length > 0) {
          this.SXTQBR = respData && respData.SXTQBR === '1' ? true : false
          this.tableData = respData.CheckList
          this.HCBJGListLength =
            this.tableData[0] && this.tableData[0].HCBJGList.length
          // 初始赋值
          this.tableData.forEach((item, index) => {
            //第一个取 判断未达标等扣分项id
            if (index === 0 && item.HCBJGList && item.HCBJGList.length > 0) {
              this.KF_JGDM_INDEX = item.HCBJGList.findIndex(
                (v) => v.ISNRFM === '1' && v.ISNRJS === '0'
              )
            }

            let totalYBS = eval(
              item.HCBJGList.map((item) => (item.YBSL ? item.YBSL : 0)).join(
                '+'
              )
            )
            if (item.HGL === 0 && totalYBS === 0) {
              if (this.xtmj1256) {
                item.HGL = 0
              } else {
                item.HGL = 1
              }
            }
          })

          // 关闭1146 记录样本数，同时计分方式为合格率检查才能进入合格率检查模式
          this.isQualifiedRateCheck =
            this.TSHCB === '0' && respData.JFFS === 1132
          if (this.tableData.length > 0) {
            this.BDZF = this.tableData[0].BDZF //新增时，表单总分取第一条数据的表单总分即可
          }

          this.tableData.forEach((item, index) => {
            item.editAble = true
            item.BCHSDM = item.BCHSDM ? item.BCHSDM.split(',') : []
            item.BCHSMC = item.BCHSMC ? item.BCHSMC.split(',') : []
            item.ZRRDM = item.ZRRDM ? item.ZRRDM.split(',') : []
            item.ZRRMC = item.ZRRMC ? item.ZRRMC.split(',') : []
            item.BCBRDM = item.BCBRDM ? item.BCBRDM.split(',') : []
            item.BCBRMC = item.BCBRMC ? item.BCBRMC.split(',') : []
            item.KFFS = item.KFFS ? item.KFFS : 1018
            item.BJCZDM = item.BJCZDM ? item.BJCZDM.split(',') : []
            item.BJCZMC = item.BJCZMC ? item.BJCZMC.split(',') : []
            item.DXHGL = item.DXHGL && item.DXHGL !== '0' ? item.DXHGL : ''
            item.Index = index
            item.SFWSJ = !!item.SFWSJ
            // 核查表默认选中第一个不扣分的项
            if (!item.KFJG && item.HCBJGList && item.HCBJGList.length > 0) {
              item.KFJG = item.HCBJGList.find((m) => m.ISNRJS == '1').JGDM
            }
            this.$set(item, 'KFJG', item.KFJG ? String(item.KFJG) : null)
            this.form.JCLX = this.tableData[0].JCLX
            this.isShowHGSCheck = this.tableData[0].BFZSLJC_ZT == 1
            if (this.xtmj1179 != '0') {
              item.firstHandle = 0
            }
            // 设置受检人/次数 默认值
            if (
              this.xtmj1146 == '1' &&
              this.xtmj1250 == '1' &&
              this.checkTypeInfo.JCFS == '1024'
            ) {
              item.SJRCS = this.frequency
              item.isError = false
              item.isChangeNum = false
              // 设置纳入结果技计算值
              let flag = true
              item.HCBJGList.forEach((items) => {
                if (items.ISNRJS == '1' && flag) {
                  items.YBSL = this.frequency
                  items.YBZB = 1
                  flag = false
                } else {
                  items.YBSL = 0
                  items.YBZB = 0
                }
              })
            }
          })
          this.$nextTick(() => {
            this.calcScore()
          })
          this.buildSnapshot()
        }
        // if (this.$refs.checkTable) {
        //   this.$refs.checkTable.doLayout()
        // }
      })
    },
    // 开始检查
    getZkjcinfo() {
      let that = this
      this.tableLoading = true
      GetZKJCInfo({
        Cfxh: this.rowData.CFXH,
        Bddm: this.rowData.JCXM_DM,
        IsCopy: this.isCopy ? '1' : '0',
        UserId: this.$store.state.user.loginUserInfo.UserId // 多人检查,传如当前用户,进行数据查询获取
      })
        .then((res) => {
          if (res.success) {
            const isSaved = res.data.IsSave
            this.isHGL = res.data.IsHGL
            this.JFFS = res.data.JFFS
            this.form.SFBXZG = res.data.SFBXZG == 1
            this.hasOther = res.data.FJState
            this.batchList = res.data.PCJCList
            this.currentCfxh = this.rowData.CFXH
            if (this.batchList.length > 1) {
              this.showBatchInfo = true
            }
            this.BfzJcjgData = res.data.BfzJcjgList
            this.otherData =
              res.data.FJXMList && res.data.FJXMList.length > 0
                ? res.data.FJXMList.map((m) => {
                    if (m.FJFS == 1214) {
                      m.valArr = m.FJVal ? m.FJVal.split(';') : []
                    }
                    return m
                  })
                : []
            if (this.isHGL === '1') this.TSHCB === '1'
            // 保存过的检查任务从后台获取督查时间
            if (isSaved === '1' && !this.isCopy) {
              this.form.DCSJ = res.data.DCSJ
            } else if (!localStorage.getItem('lastTime') && !this.isCopy) {
              this.form.DCSJ = res.data.DCSJ
            }
            if (this.isCopy) {
              this.form.ZXH = res.data.ZXH
              this.showTaskToPlan = res.data.ZXH > 0
            }
            this.SXTQBR =
              res.data.SXTQBR && res.data.SXTQBR === '1' ? true : false
            this.bd1186 = res.data.SFJL_JCRS_HGL
            this.tableData = res.data.CheckList
            this.HCBJGListLength =
              this.tableData[0] && this.tableData[0].HCBJGList.length
            // 多人检查需求
            let userInfoData = this.$store.state.user.loginUserInfo.UserId
            this.groupLeader = res.data.ZJCZMC
            this.groupJCZ = res.data.ZJCZ
            if (userInfoData === res.data.ZJCZ) {
              //是否组长
              this.isGroupLeader = true
            }
            //是否组员
            if (res.data.QTJCZ != null && res.data.QTJCZ.length > 0) {
              let targetGroup = res.data.QTJCZ.split(',')
              for (let i = 0; i < targetGroup.length; i++) {
                if (targetGroup[i] === userInfoData) {
                  this.isGroups = true
                }
              }
            }
            //多人检查赋值
            this.tableData =
              res.data.DRJCCheckList == null ? [] : res.data.DRJCCheckList
            this.isDRJC = res.data.DRJC == 1 ? true : false
            this.isRevoke = res.data.ISDRJCREVOKE == 1 ? true : false
            // 开始检查的人,既不是组长也不是组员(显示主数据)
            if (
              (!this.isGroupLeader && !this.isGroups) ||
              res.data.ISDRJCREVOKE == 1
            ) {
              this.tableData = res.data.CheckList
            }
            // 多人检查数据副本
            this.markData = JSON.parse(JSON.stringify(res.data.CheckList))
            // 初始赋值
            this.tableData.forEach((item, index) => {
              // 是否已经保存过数据
              if (item.SJRCS != 0) {
                item.isChangeNum = true
              } else {
                item.isChangeNum = false
              }

              // 设置受检人/次数 默认值
              if (
                this.xtmj1146 == '1' &&
                this.xtmj1250 == '1' &&
                this.checkTypeInfo.JCFS == '1024' &&
                item.SJRCS == 0
              ) {
                item.SJRCS = this.frequency
                item.isError = false
                // 设置纳入结果技计算值
                let flag = true
                item.HCBJGList.forEach((items) => {
                  if (items.ISNRJS == '1' && flag) {
                    items.YBSL = this.frequency
                    items.YBZB = 1
                    flag = false
                  }
                })
              }
              let totalYBS = eval(
                item.HCBJGList.map((item) => (item.YBSL ? item.YBSL : 0)).join(
                  '+'
                )
              )
              if (item.HGL === 0 && totalYBS === 0) {
                if (this.xtmj1256) item.HGL = 0
                else item.HGL = 1
              }
              //第一个取 判断未达标等扣分项id
              if (index === 0 && item.HCBJGList && item.HCBJGList.length > 0) {
                this.KF_JGDM_INDEX = item.HCBJGList.findIndex(
                  (v) => v.ISNRFM === '1' && v.ISNRJS === '0'
                )
              }
            })
            this.anchorArr = this.toChildrenStruct(res.data.CheckList)
            let redXM = ''
            let redZLBZ = ''
            if (this.rowData.KFXDM) {
              redXM = this.tableData.find((i) =>
                this.rowData.KFXDM.includes(i.KFDM)
              ).XMDM
              redZLBZ = this.tableData.find((i) =>
                this.rowData.KFXDM.includes(i.KFDM)
              ).BZDM
            }
            this.tableData.forEach((item, index) => {
              if (this.rowData.KFXDM) {
                item.editAble =
                  this.rowData.KFXDM.split(',').indexOf(item.KFDM + '') > -1
                item.redXM = item.XMDM == redXM
                item.redZLBZ = item.BZDM == redZLBZ
              } else {
                item.editAble = true
                this.rowData.KFXDM = false
              }
              item.BCHSDM = item.BCHSDM ? item.BCHSDM.split(',') : []
              item.BCHSMC = item.BCHSMC ? item.BCHSMC.split(',') : []
              for (let i = 0; i < item.BCHSDM.length; i++) {
                if (!this.bchsSelectList.some((m) => m.id == item.BCHSDM[i])) {
                  this.bchsSelectList.push({
                    id: item.BCHSDM[i],
                    name: item.BCHSMC[i]
                  })
                }
                if (!this.bchsSelectList2.some((m) => m.id == item.BCHSDM[i])) {
                  this.bchsSelectList2.push({
                    id: item.BCHSDM[i],
                    name: item.BCHSMC[i]
                  })
                }
              }
              item.ZRRDM = item.ZRRDM ? item.ZRRDM.split(',') : []
              item.ZRRMC = item.ZRRMC ? item.ZRRMC.split(',') : []
              for (let i = 0; i < item.ZRRDM.length; i++) {
                if (!this.zrrSelectList.some((m) => m.id == item.ZRRDM[i])) {
                  this.zrrSelectList.push({
                    id: item.ZRRDM[i],
                    name: item.ZRRMC[i]
                  })
                }
              }
              this.bchzSelectList.forEach((item) => {
                item.Name = item.name
              })
              item.BCBRDM = item.BCBRDM ? item.BCBRDM.split(',') : []
              item.BCBRMC = item.BCBRMC ? item.BCBRMC.split(',') : []
              for (let i = 0; i < item.BCBRDM.length; i++) {
                if (!this.bchzSelectList.some((m) => m.ID == item.BCBRDM[i])) {
                  this.bchzSelectList.push({
                    id: item.BCBRDM[i],
                    name: item.BCBRMC[i],
                    ID: item.BCBRDM[i],
                    Name: item.BCBRMC[i]
                  })
                }
              }
              for (let i = 0; i < this.form.BJCZXX.length; i++) {
                if (
                  !item.BCHSDM.includes(this.form.BJCZXX[i].split('$')[0]) &&
                  this.form.BJCZXX[i].split('$')[1] == '1'
                ) {
                  if (
                    that.form.BJCZDM[i] &&
                    !that.bchsSelectList.some(
                      (m) => m.id == that.form.BJCZDM[i]
                    )
                  ) {
                    that.bchsSelectList.push({
                      id: that.form.BJCZDM[i],
                      name: that.form.BJCZMC[i]
                    })
                  }
                }
                if (
                  !item.ZRRDM.includes(this.form.BJCZXX[i].split('$')[0]) &&
                  this.form.BJCZXX[i].split('$')[1] == '1'
                ) {
                  if (
                    that.form.BJCZDM[i] &&
                    !that.zrrSelectList.some((m) => m.id == that.form.BJCZDM[i])
                  ) {
                    that.zrrSelectList.push({
                      id: that.form.BJCZDM[i],
                      name: that.form.BJCZMC[i]
                    })
                  }
                }
                if (
                  !item.BCBRDM.includes(this.form.BJCZXX[i].split('$')[0]) &&
                  that.form.BJCZXX[i].split('$')[1] == '2'
                ) {
                  if (
                    that.form.BJCZDM[i] &&
                    !that.bchzSelectList.some(
                      (m) => m.id == that.form.BJCZDM[i]
                    )
                  ) {
                    that.bchzSelectList.push({
                      id: that.form.BJCZDM[i],
                      name: that.form.BJCZMC[i],
                      ID: that.form.BJCZDM[i],
                      Name: that.form.BJCZMC[i]
                    })
                  }
                }
              }
              item.KFFS = item.KFFS ? item.KFFS : 1018
              item.BJCZDM = item.BJCZDM ? item.BJCZDM.split(',') : []
              item.BJCZMC = item.BJCZMC ? item.BJCZMC.split(',') : []
              item.DXHGL = item.DXHGL && item.DXHGL !== '0' ? item.DXHGL : ''
              item.Index = index
              item.SFWSJ = item.SFWSJ == '1'
              // 核查表默认选中第一个不扣分的项
              if (!item.KFJG && item.HCBJGList && item.HCBJGList.length > 0) {
                item.KFJG = item.HCBJGList.find((m) => m.ISNRJS == '1').JGDM
              }
              this.$set(item, 'KFJG', item.KFJG ? String(item.KFJG) : null)
              if (this.xtmj1179 != '0') {
                item.firstHandle = 0
              }
            })
            if (this.tableData && this.tableData.length > 0) {
              // 判断是否为合格率检查 与产品沟通，如果打开1146，就按特殊核查表来，TODO如果1146先关闭，产生的历史数据需要处理下
              this.isQualifiedRateCheck =
                this.TSHCB === '0' && res.data.JFFS === 1132

              this.form.JCLX = this.tableData[0].JCLX
              this.isShowHGSCheck = this.tableData[0].BFZSLJC_ZT == 1
              this.form.BFZSLJC_CJS = this.tableData[0].BFZSLJC_CJS
              this.form.BFZSLJC_HGS = this.tableData[0].BFZSLJC_HGS
              this.form.BFZSLJC_HGL = this.tableData[0].BFZSLJC_HGL
              this.cloneFormData = cloneDeep(this.form)
              this.cloneTableData = cloneDeep(this.tableData)
            }
            this.allSFWSJ = this.tableData.find((i) => !i.SFWSJ) ? false : true

            this.$nextTick(() => {
              this.calcScore()
            })
            this.buildSnapshot()
            this.showJdxx()
          }
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    showJdxx() {
      let batchList = this.batchList
      let total = this.batchList.length
      let currentNo =
        total && batchList.find((i) => i.CFXH == this.currentCfxh).XSXH
      var currentIndex = this.batchList.findIndex(
        (i) => i.CFXH == this.currentCfxh
      )
      this.jdxx = currentNo + '/' + total
      this.setChangeBtn(currentIndex)
    },
    previousCheck() {
      var currentIndex = this.batchList.findIndex(
        (i) => i.CFXH == this.currentCfxh
      )
      if (currentIndex >= 1) {
        if (!this.beforeClose) {
          this.gotoPreviousCheck(currentIndex)
        } else {
          this.$Confirm(
            '您填写的内容尚未保存，切换后将不会保存，确定要切换吗？',
            '提示',
            {
              showCancelButton: true,
              cancelButtonText: '取消',
              confirmButtonText: '确定',
              type: 'warning'
            }
          )
            .then(() => {
              this.gotoPreviousCheck(currentIndex)
            })
            .catch(() => {})
        }
      }
      this.setChangeBtn(currentIndex)
    },
    nextCheck() {
      var total = this.batchList.length
      var currentIndex = this.batchList.findIndex(
        (i) => i.CFXH == this.currentCfxh
      )
      if (currentIndex < total - 1) {
        if (!this.beforeClose) {
          this.gotoNextCheck(currentIndex)
        } else {
          this.$Confirm(
            '您填写的内容尚未保存，切换后将不会保存，确定要切换吗？',
            '提示',
            {
              showCancelButton: true,
              cancelButtonText: '取消',
              confirmButtonText: '确定',
              type: 'warning'
            }
          )
            .then(() => {
              this.gotoNextCheck(currentIndex)
            })
            .catch(() => {})
        }
      }
      this.setChangeBtn(currentIndex)
    },
    gotoNextCheck(currentIndex) {
      var nextCfxh = this.batchList[currentIndex + 1].CFXH
      var wcqk = this.batchList[currentIndex + 1].WCQK
      if (wcqk == '1') {
        this.type = 'check'
        this.$requestApi('GetZKJCList', {
          CFXH: nextCfxh
        }).then((res) => {
          if (res.success) {
            this.$emit('close', {})
            let checkData = res.data[0]
            this.onDetail(checkData)
          }
        })
      } else {
        this.type = 'check'
        this.$requestApi('GetZKJCList', {
          CFXH: nextCfxh
        }).then((res) => {
          if (res.success) {
            this.$emit('close', {})
            let row = res.data[0]
            this.onCheckDetail(row)
          }
        })
      }
    },
    gotoPreviousCheck(currentIndex) {
      var previousCfxh = this.batchList[currentIndex - 1].CFXH
      var wcqk = this.batchList[currentIndex - 1].WCQK
      if (wcqk == '1') {
        this.type = 'check'
        this.$requestApi('GetZKJCList', {
          CFXH: previousCfxh
        }).then((res) => {
          if (res.success) {
            this.$emit('close', {})
            let checkData = res.data[0]
            this.onDetail(checkData)
          }
        })
      } else {
        this.type = 'check'
        this.$requestApi('GetZKJCList', {
          CFXH: previousCfxh
        }).then((res) => {
          if (res.success) {
            this.$emit('close', {})
            let row = res.data[0]
            this.onCheckDetail(row)
          }
        })
      }
    },
    setChangeBtn(currentIndex) {
      let total = this.batchList.length
      if (currentIndex > 0 && currentIndex < total - 1) {
        this.showNext = true
        this.showPrevious = true
      }
      if (currentIndex == 0) this.showPrevious = false
      if (currentIndex == total - 1) this.showNext = false
    },
    onCheckDetail(row) {
      let width = window.innerWidth * 1
      let height = window.innerHeight * 1
      let dialog = AddTaskDialog
      let params = {
        type: 'check',
        selectZkjb: row.ZKJB,
        rowData: row,
        checkType: row.JCFS,
        listQuery: {
          ZKJB: row.ZKJB,
          ORGID: row.ORGID,
          HospitalCode: row.HospitalCode || ''
        }
      }
      const key = this.$dlg.modal(dialog, {
        width: width,
        height: height,
        title: '检查',
        params,
        callback: () => {},
        cancelCallback: () => {}
      })
    },
    onDetail(row) {
      let width = window.innerWidth * 1
      let height = window.innerHeight * 1
      const key = this.$dlg.modal(TaskDetailDialog, {
        width: width,
        height: height,
        title: '检查',
        params: { type: 'view', showBackBtn: true, rowData: row },
        callback: (data) => {
          if (data.success) {
            this.queryCheckList()
          }
        }
      })
    },
    ifBack(row, item) {
      let same =
        this.form.BJCZDM.length == 2 &&
        this.bjczOptions.find((item) => item.id === this.form.BJCZDM[0])
          .isPatient ==
          !!this.bjczOptions.find((item) => item.id === this.form.BJCZDM[1])
            .isPatient
      if (
        this.form.BJCZDM.length < 1 ||
        this.form.BJCZDM.length > 2 ||
        same ||
        item.toString().startsWith('+')
      ) {
        return
      }
      let patient = ''
      let hs = ''
      if (this.form.BJCZDM.length == 1) {
        let ifPatient = this.bjczOptions.find(
          (item) => item.id === this.form.BJCZDM[0]
        ).isPatient
        patient = ifPatient ? this.form.BJCZDM[0] : ''
        hs = ifPatient ? '' : this.form.BJCZDM[0]
      }
      if (this.form.BJCZDM.length == 2) {
        let ifFirst = this.bjczOptions.find(
          (item) => item.id === this.form.BJCZDM[0]
        ).isPatient
        patient = ifFirst ? this.form.BJCZDM[0] : this.form.BJCZDM[1]
        hs = ifFirst ? this.form.BJCZDM[1] : this.form.BJCZDM[0]
      }
      if (this.xtmj1179 == '2') {
        row.BCBRDM =
          row.BCBRDM.length > 0 ? row.BCBRDM : patient ? [patient] : []
        row.BCHSDM = row.BCHSDM.length > 0 ? row.BCHSDM : hs ? [hs] : []
        row.BCBRMC = []
        row.BCHSMC = []
        for (let i = 0; i < row.BCBRDM.length; i++) {
          row.BCBRMC.push(
            this.bchzSelectList.find((item) => item.ID == row.BCBRDM[i]).Name
          )
        }
        for (let i = 0; i < row.BCHSDM.length; i++) {
          row.BCHSMC.push(
            this.bchsSelectList.find((item) => item.id == row.BCHSDM[i]).name
          )
        }
      }
    },
    handleMark(item, index, row, type) {
      this.SET_BEFORE_CLOSE(true)
      if (row.KFJG == null) row.KFJG = 0
      row.KFJG = formatInput(row.KFJG.toString())
      this.ifBack(row, item)
      if (
        row.JFFS === 1152 &&
        !item.startsWith('+') &&
        Number(item) != 0 &&
        Number(item) !== Number(row.KFFZ)
      ) {
        // 判断是否为完整扣分1152,当分值
        this.$msg('全部扣分只能扣除0分或者完整分!', 'info')
        // this.$nextTick(() => {
        row.KFFZ = row.KFFZ
        row.KFJG = Number(row.KFFZ)
        // })
      }
      if (type && type === 'input') {
        if (row.KFJG.toString().indexOf('+') < 0) {
          const BZFZ = row.BZFZ === 0 ? Number(row.KFFZ) : row.BZFZ
          let maxNum =
            row.JFFS === 1068
              ? row.XMFZ
              : row.JFFS === 1183
              ? BZFZ
              : row.JFFS === 1184
              ? row.BDZF
              : Number(row.KFFZ)
          row.KFJG = String(
            Number(row.KFJG) > Number(maxNum) ? maxNum : row.KFJG
          )
        }
        if (row.KFJG.startsWith('+')) {
          //加分不能超过五位数
          row.KFJG = Number(row.KFJG) > 99999 ? '+99999' : row.KFJG
        }
        row.KFJG = formatInput(row.KFJG.toString())
      }
      this.calcScore('')
      this.settingRowBJCZ(item, row)
      // 1179参数开启时，自动填充扣分原因说明
      if (
        this.xtmj1179 != '0' &&
        (row.firstHandle === 0 || !row.KFYYSM) &&
        row.KFJG !== '' &&
        row.KFJG !== '0' &&
        row.KFJG.indexOf('+') == -1
      ) {
        row.autoAddKFYYSM = 1 //用于判断被查护士和被查患者修改是否默认填充（不好判断是否扣分）
        this.dealKFYYSM(row)
      }
    },
    handleBfzJcjgChange(item, index, row) {
      this.SET_BEFORE_CLOSE(true)
      let jgx = this.BfzJcjgData.filter((i) => i.JGDM == item)
      if (jgx != null && jgx.length > 0) {
        let dfqz = jgx[0].DFQZ
        let kfjg = (Number(dfqz) * Number(row.KFFZ)) / 100
        row.KFJG = kfjg == 0 ? null : kfjg
        row.XXJGMC = jgx[0].JGMC
      }

      this.handleMark(item, index, row)
    },
    // 填充扣分原因说明
    dealKFYYSM(row) {
      row.firstHandle += 1 //判断是否第一次操作
      let kfmc = row.KFMC || row.BZMC
      console.log('xtmj1179')
      if (this.xtmj1179 == '1') {
        row.KFYYSM = row.KFYYSM
          ? row.KFYYSM.includes(kfmc)
            ? row.KFYYSM
            : row.KFYYSM + '\n' + kfmc
          : kfmc
      } else if (
        this.xtmj1179 == '2' &&
        row.autoAddKFYYSM == 1 && //用于判断被查护士和被查患者修改是否默认填充（不好判断是否扣分）
        row['changeKFYYSM'] != 1 // 如果扣分原因说明没有人为改动
      ) {
        // 顶部被检查者有数据，遍历添加到数组里面
        var str = ''
        let strArr = []
        let hsArr = []
        let hzArr = []
        // 检查类型为科室或者护士时添加护士人员
        if (
          (this.form.JCLX == 1019 || this.form.JCLX == 1021) &&
          row.BCHSMC.length > 0
        ) {
          row.BCHSMC.forEach((item, idx) => {
            hsArr.push(item.replace(`(${row.BCHSDM[idx]})`, ''))
          })
          if (hsArr && hsArr.length > 0) {
            strArr.push(hsArr.join(','))
          }
        }

        // 检查类型为科室或者病人时添加患者
        if (
          (this.form.JCLX == 1019 || this.form.JCLX == 1020) &&
          row.BCBRMC.length > 0
        ) {
          row.BCBRMC.forEach((item, idx) => {
            hzArr.push(item)
          })
          if (hzArr && hzArr.length > 0) {
            strArr.push(hzArr.join(','))
          }
        }

        str = strArr.join(',')
        row.KFYYSM = str + kfmc
      }
    },

    handleChangeNum(item, index, row, type) {
      this.SET_BEFORE_CLOSE(true)
      if (type === '总数') {
        row.ZRS = formatInput(row.ZRS.toString())
        if (Number(row.ZRS) < Number(row.HGS)) {
          row.ZRS = row.HGS
          row.BHGS = (Number(row.ZRS) - Number(row.HGS)).toString()
          row.DXHGL = Number(row.ZRS)
            ? Number(row.HGS) / Number(row.ZRS)
            : row.ZRS === '0'
            ? '0'
            : ''
        }
        if (Number(row.ZRS) < Number(row.BHGS)) {
          row.BHGS = row.ZRS
        }
        if (Number(row.ZRS) < row.HGS) {
          row.ZRS = row.BHGS
        }
        if (Number(row.ZRS) !== Number(row.HGS) + Number(row.BHGS) && row.HGS) {
          row.BHGS = (Number(row.ZRS) - Number(row.HGS)).toString()
          row.DXHGL = Number(row.ZRS) ? Number(row.HGS) / Number(row.ZRS) : '0'
        }
        row.DXHGL = row.ZRS ? row.DXHGL : ''
      }
      if (type === '合格数') {
        row.HGS = formatInput(row.HGS.toString())
        if (!row.ZRS || Number(row.ZRS) < Number(row.HGS)) {
          row.ZRS = row.HGS
        }
        row.BHGS = (Number(row.ZRS) - Number(row.HGS)).toFixed(2).toString()
        row.DXHGL =
          Number(row.ZRS) && row.HGS
            ? Number(row.HGS) / Number(row.ZRS)
            : row.HGS === '0'
            ? '0'
            : ''
      }
      if (!row.HGS && !row.ZRS) {
        row.BHGS = ''
        row.DXHGL = ''
      }
    },
    handleChangeQz() {
      this.SET_BEFORE_CLOSE(true)
      this.calcScore('')
    },
    // 计算得分
    calcScore(row) {
      //是否未涉及
      if (row && row.SFWSJ) {
        row.HGL = this.xtmj1256 ? 0 : 1
        if (this.form.JCFS != 1024) {
          row.KFJG = null
        }

        if (row.HCBJGList && row.HCBJGList.length > 0) {
          row.HCBJGList.forEach((item) => {
            item.YBSL = 0
            item.YBZB = 0
          })
        }
        // 参数开启，结果占比计算
        if (
          this.xtmj1146 == '1' &&
          this.xtmj1250 == '1' &&
          this.checkTypeInfo.JCFS == '1024'
        ) {
          row.SJRCS = parseInt(this.frequency)
          let flag = true
          row.HCBJGList.forEach((item) => {
            if (item.ISNRJS == '1' && flag) {
              flag = false
              item.YBSL = parseInt(this.frequency)
              item.YBZB = 1
            }
          })
        }
      }
      let ZKJCInfoList = JSON.parse(JSON.stringify(this.tableData))
      ZKJCInfoList.forEach((item) => {
        item.BCHSDM = item.BCHSDM.join(',')
        item.BCHSMC = item.BCHSMC.join(',')
        item.BCBRDM = item.BCBRDM.join(',')
        item.BCBRMC = item.BCBRMC.join(',')
        item.ZRRDM = item.ZRRDM.join(',')
        item.ZRRMC = item.ZRRMC.join(',')
        item.BJCZDM = item.BJCZDM.join(',')
        item.BJCZMC = item.BJCZMC.join(',')
      })
      let ZKJCModel = {
        BDDM: this.form.JCBD,
        BDMC: this.form.JCBDMC,
        CFXH: this.form.CFXH, // 新建时拆分序号暂时 无法获取到
        ZZJGDM: this.form.SJKS,
        JCZID: this.form.JCZ,
        JCZMC: this.form.ZZMC, //改变后需重新赋值
        QTJCZID: Array.isArray(this.form.QTJCZID)
          ? this.form.QTJCZID.join(',')
          : this.form.QTJCZID,
        QTJCZMC: this.form.QTJCZMC,
        IsSave: '', // 保存 / 提交
        QZXS: this.form.HCB_QZ,
        ZKJCInfoList, //接传递table数据
        BJCZDM: this.form.BJCZDM.join(',')
      }
      CalcZKJCData(ZKJCModel).then((res) => {
        this.scoreInfo = res.data
      })
    },
    // 查询过滤科室
    searchFun(value) {
      this.$nextTick(() => {
        this.$refs.treeSelect.$refs.tree.filter(value)
      })
    },
    handleToggle(val) {
      if (!val) {
        // 清空搜索输入框内容
        this.$refs.treeSelect.clearInnerInput()
        // 触发查询函数过滤数据
        this.searchFun('')
      }
    },
    // 特殊核查表计算合格率
    getHGL(list, index, row, type) {
      // 总数
      let targetNum = row.SJRCS
      if (
        type &&
        this.xtmj1146 == '1' &&
        this.xtmj1250 == '1' &&
        this.checkTypeInfo.JCFS == '1024'
      ) {
        let num = 0
        // 用于计算除了第一个不扣分项之外的所有分值
        let hgX = row.HCBJGList.find((m) => m.ISNRJS == '1') // 第一个合格项
        row.HCBJGList.forEach((item) => {
          if (hgX && item.JGDM != hgX.JGDM) {
            num =
              num +
              parseInt(item.YBSL == '' || item.YBSL == null ? 0 : item.YBSL)
          }
        })
        if (list.JGDM != hgX.JGDM) {
          let resultData = targetNum - num > 0 ? targetNum - num : 0
          row.HCBJGList.forEach((item) => {
            if (item.ISNRJS == '1' && item.JGDM == hgX.JGDM) {
              item.YBSL = resultData
            }
          })
        }
        if (targetNum - num > 0 || targetNum - num == 0) {
          row.isError = false
        }
      }
      // 填写后删除 或者填负数 提示后没有触发计算。百分比与值不匹配
      if (!Number.isInteger(list.YBSL) || list.YBSL < 0) {
        if(list.YBSL<0){
          this.$msg('请输入正整数')
        }
        list.YBSL = 0
      }
      this.SET_BEFORE_CLOSE(true)
      list.YBSL = formatInput(list.YBSL.toString())
      const isnrjs = this.isQualifiedRateCheck ? '0' : '1'
      //不适用数量，即为不纳入分子并且不纳入分母的数量
      let bsySl = 0
      if (this.bsySfcyjs) {
        let totalYBS = eval(
          row.HCBJGList.map((item) => (item.YBSL ? item.YBSL : 0)).join('+')
        )
        bsySl = eval(
          row.HCBJGList.map((item) =>
            item.YBSL && item.ISNRFM === '0' && item.ISNRJS === '0'
              ? item.YBSL
              : 0
          ).join('+')
        )

        let totalActive = eval(
          row.HCBJGList.map((item) =>
            item.ISNRJS === isnrjs && item.ISNRFM != 0
              ? item.YBSL
                ? item.YBSL
                : 0
              : 0
          ).join('+')
        )

        let fmSl = totalYBS - bsySl
        row.HCBJGList.forEach((item) => {
          let result = 0
          if (item.ISNRFM === '0' && item.ISNRJS === '0') {
            result =
              fmSl === 0
                ? 0
                : (((item.YBSL ? item.YBSL : 0) / totalYBS) * 10000) / 10000
          } else {
            result =
              fmSl === 0
                ? 0
                : (((item.YBSL ? item.YBSL : 0) / fmSl) * 10000) / 10000
          }
          this.$set(item, 'YBZB', result.toFixed(4))
        })

        row.HGL =
          fmSl === 0 ? 0 : Math.floor((totalActive / fmSl) * 10000) / 10000
        // 合格率重新赋值
        // row.HGL = 1 - row.HGL
        // 合格率不是100%
        if (row.HGL < 1) {
          this.settingRowBJCZ(1, row)
        }
      } else {
        let totalYBS = eval(
          row.HCBJGList.map((item) =>
            item.YBSL && !(item.ISNRFM === '0' && item.ISNRJS === '0')
              ? item.YBSL
              : 0
          ).join('+')
        )
        if (list.ISNRFM === '0' && list.ISNRJS === '0') {
          return
        }
        let totalActive = eval(
          row.HCBJGList.map((item) =>
            item.ISNRJS === isnrjs && item.ISNRFM != 0
              ? item.YBSL
                ? item.YBSL
                : 0
              : 0
          ).join('+')
        )
        row.HCBJGList.forEach((item) => {
          this.$set(
            item,
            'YBZB',
            totalYBS === 0
              ? 0
              : Math.floor(((item.YBSL ? item.YBSL : 0) / totalYBS) * 10000) /
                  10000
          )
        })

        row.HGL =
          totalYBS === 0
            ? 0
            : Math.floor((totalActive / totalYBS) * 10000) / 10000
        // 合格率重新赋值
        // row.HGL = 1 - row.HGL
        //分数小于一，填充被查护士和患者
        if (row.HGL < 1) {
          this.settingRowBJCZ(1, row)
        }
      }
      // 1179参数开启时，自动填充扣分原因说明 抠的if里加了最后两个条件
      if (
        this.xtmj1179 != '0' &&
        (row.firstHandle === 0 || !row.KFYYSM) &&
        row.KFJG !== '' &&
        row.KFJG !== '0' &&
        row.HCBJGList &&
        row.HCBJGList.some(
          (m) => m.YBSL > 0 && m.ISNRFM === '1' && m.ISNRJS === '0'
        )
      ) {
        row.autoAddKFYYSM = 1 //用于判断被查护士和被查患者修改是否默认填充（不好判断是否扣分）
        this.dealKFYYSM(row)
      }
      this.calcScore()
    },
    getZrrArr(row) {
      for (let i = 0; i < row.ZRRDM.length; i++) {
        if (!this.zrrSelectList.find((item) => item.id === row.ZRRDM[i])) {
          this.zrrSelectList.push({
            id: row.ZRRDM[i],
            name: row.ZRRMC[i]
          })
        }
      }
    },
    changeTopBCHS(val){
      this.SET_BEFORE_CLOSE(true)
      if (val) {
        this.form.BCHSDM = val.BCHSDM
        this.form.BCHSMC = val.BCHSMC
        this.form.BJCZDM = [...new Set(this.form.BCHSDM.concat(this.form.BCHZDM))]
        this.form.BJCZMC =  [...new Set(this.form.BCHSMC.concat(this.form.BCHZMC))]

 
      } else {
        this.form.BJCZDM = []
        this.form.BJCZMC = []
        this.form.BCHSDM = []
        this.form.BCHSMC = []
      }
    },
    changeBCHS(row, index) {
      this.SET_BEFORE_CLOSE(true)
      if (this.isToZRRY === '0') {
        row.ZRRDM = row.BCHSDM
        row.ZRRMC = row.BCHSMC
      } else if (this.isToZRRY === '1') {
        // 1077参数开启后，取组织结构中的责任人(ZYFZR为3)
        if (this.HSZinfo.length > 0 && row.BCHSDM.length > 0) {
          for (let i = 0; i < this.HSZinfo.length; i++) {
            if (!row.ZRRDM.includes(this.HSZinfo[i].CYGH)) {
              row.ZRRDM.push(this.HSZinfo[i].CYGH)
              row.ZRRMC.push(
                this.HSZinfo[i].CYXM.includes('(')
                  ? this.HSZinfo[i].CYXM
                  : this.HSZinfo[i].CYXM + '(' + this.HSZinfo[i].CYGH + ')'
              )
            }
          }
        }
      }
      this.getZrrArr(row)
      this.$set(this.tableData, index, row)
      for (let i = 0; i < row.BCHSDM.length; i++) {
        if (!this.bchsSelectList.some((item) => item.id === row.BCHSDM[i])) {
          this.bchsSelectList.push({
            id: row.BCHSDM[i],
            name: row.BCHSMC[i]
          })
        }
        if (!this.zrrSelectList.find((item) => item.id === row.BCHSDM[i])) {
          this.zrrSelectList.push({
            id: row.BCHSDM[i],
            name: row.BCHSMC[i]
          })
        }
        if (!this.bjczOptions.find((j) => j.id == row.BCHSDM[i])) {
          this.bjczOptions.push({
            id: row.BCHSDM[i],
            name: row.BCHSMC[i]
          })
        }
        if (!this.bjczOptionsHs.some((j) => j.id == row.BCHSDM[i])) {
          this.bjczOptionsHs.push({
            id: row.BCHSDM[i],
            name: row.BCHSMC[i]
          })
        }
        if (!this.form.BJCZDM.includes(row.BCHSDM[i])) {
          this.form.BJCZMC.push(row.BCHSMC[i])
          this.form.BJCZDM.push(row.BCHSDM[i])
        }
        if (!this.form.BCHSDM.includes(row.BCHSDM[i])) {
          this.form.BCHSDM.push(row.BCHSDM[i])
          this.form.BCHSMC.push(row.BCHSMC[i])
        }
      }
      this.dealKFYYSM(row)
    },
    // 修改表格内popover
    changePerson(row, index) {
      this.SET_BEFORE_CLOSE(true)
      this.$set(this.tableData, index, row)
      this.getZrrArr(row)
    },
    changeSearchForm(detail, type) {
      if (type == 'SJKS' && this.xtmj1120) {
        this.$requestApi('GetHlhtService', {
          Zzjgdm: this.form.SJKS
        })
      }

      this.$nextTick(() => {
        this.form.BJCZDM = []
        this.form.BJCZMC = []
      })

      this.isAllSelected = false

      this.SET_BEFORE_CLOSE(true)
      let isChangeJCLX = this.lastJCLX && this.lastJCLX !== detail.JCLX
      this.form = JSON.parse(JSON.stringify(detail))
      this.lastJCLX = this.form.JCLX
      // 改变了检查类型,需要清空被检查者
      if (isChangeJCLX) {
        this.isNeedComfirm = false //切换检查表单时不要弹被检查者改变时候的框
        // this.form.BJCZDM = []
        this.$nextTick(() => {
          this.isNeedComfirm = true
        })
      }
      //添加检查范围默认值
      this.form.JCFW = this.form.SJKS
      this.form.JCFWMC = this.form.SJKSMC
      this.form.CFXH = null //确保

      if (this.form.SJKS && type == 'SJKS') {
        //切换受检科室，检查表单也要清空
        this.form.JCBD = ''
        this.form.JCBDMC = ''
        this.GetHsByZZJG()
      }
      if (this.form.SJKS && this.form.JCBD) {
        this.getBJCZ()
        this.queryListByAdd()
      }
      if (!this.form.SJKS) {
        this.form.SJKSMC = ''
        this.form.JCBD = ''
        this.form.JCBDMC = ''
      }
      if (!this.form.JCBD) {
        this.form.BBH = ''
        this.scoreInfo = {
          DFL: 0,
          LSL: 0,
          WCL: 0,
          ZDF: 0,
          ZKF: 0,
          WSJF: 0
        }
        this.tableData = []
      }
      if (this.checkType === 1024) {
        this.$requestApi('GetHCBCheckResult', {
          Bddm: this.form.JCBD
        }).then((res) => {
          this.checkResultList = res.data

          if (this.TSHCB === '1') {
            this.checkResultList.forEach((item) => {
              this.$set(item, 'YBSL', '')
              this.$set(item, 'DXZB', '')
            })
          }
          this.genResultOptions('1024')
        })
      } else {
        this.genResultOptions('1022')
      }
    },
    genResultOptions(jcfs) {
      if (jcfs == '1024') {
        let orginResultItemColumnList = this.resultItemColumns.filter(
          (i) =>
            i.key == 'DFL' ||
            i.key == 'LSL' ||
            i.key == 'WCL' ||
            i.key == 'BDZF' ||
            i.key == 'WSJF' ||
            i.key == 'ZKF'
        )

        let dflOption = this.resultItemColumns.find((i) => i.key == 'DFL')
        dflOption.checked = true
        dflOption.keepChoosing = true

        let jgxxArr = new Array()
        this.checkResultList.forEach((item) => {
          let jgx = new Object()
          jgx.key = item.JGDM
          jgx.name = item.JGMC
          jgx.keepChoosing = false
          jgx.checked = false
          jgxxArr.push(jgx)
        })
        if (jgxxArr.length > 0) {
          this.resultItemColumns = jgxxArr.concat(orginResultItemColumnList)
        }
        let cacheResult = localStorage.getItem(
          `addDialog_info_${this.rowData.CFXH}`
        )
        if (cacheResult) {
          this.resultCheckList = JSON.parse(cacheResult).resultCheckList
        } else {
          this.resultCheckList = [...this.resultItemColumns]
        }
      } else {
        this.resultItemColumns = this.resultItemColumns.filter(
          (i) =>
            i.key == 'ZDF' ||
            i.key == 'DFL' ||
            i.key == 'LSL' ||
            i.key == 'BDZF' ||
            i.key == 'WSJF' ||
            i.key == 'ZKF'
        )
        this.resultCheckList = this.resultItemColumns
      }
    },
    //发布任务
    publish() {
      const key = this.$dlg.mask('发布中...')
      let that = this
      setTimeout(() => {
        this.loading = false
        that.$dlg.close(key)
      }, 1000)
    },
    //原因 操作行
    handleResonFocus(row) {
      this.row = row
    },
    //查询原因
    queryRenson(row) {
      this.$requestApi('GetKFYYList', {
        BDDM: row.BDDM,
        BZDM: row.BZDM,
        YYMC: ''
      }).then((res) => {
        this.reasonList = res.data.map((v) => {
          return {
            YYMC: v.YYMC,
            id: v.YYDM,
            KFFZ: v.KFFZ,
            SFLSYY: v.SFLSYY
          }
        })
      })
    },
    handleSelect(current) {
      this.row.KFYYDM = this.reasonList.filter(
        (item) => item.YYMC === current
      )[0].YYDM
      this.row.KFYYMC = this.reasonList.filter(
        (item) => item.YYMC === current
      )[0].YYMC
    },

    submit(flag) {
      //子组table 展示所需的参数
      this.showCondition.TSHCB = this.TSHCB
      this.showCondition.isHGL = this.isHGL
      this.showCondition.JCFS = this.checkTypeInfo.JCFS
      this.showCondition.checkResultList = this.checkResultList
      this.showCondition.xtmj1195 = this.xtmj1195val
      this.showCondition.JFFS = this.JFFS
      this.showCondition.ORGID = this.form.ORGID || this.listQuery.ORGID
      this.showCondition.Mjdm = this.Mjdm //1127参数设置
      this.showCondition.xtmj1113 = this.xtmj1113
      this.showCondition.bsySfcyjs = this.bsySfcyjs
      this.showCondition.KFXDM = this.rowData.KFXDM
      this.showCondition.isQualifiedRateCheck = this.isQualifiedRateCheck //1032
      this.showCondition.xtmj1179 = this.xtmj1179
      this.showCondition.isToZRRY = this.isToZRRY // 1077参数
      this.showCondition.jczOptions = this.jczOptions
      this.showCondition.bjczOptions = this.bjczOptions
      this.showCondition.bjczOptionsHs = this.bjczOptionsHs
      this.showCondition.HSZinfo = this.HSZinfo
      this.showCondition.isShowKFBZColumn = this.isShowKFBZColumn
      this.isSave = true
      //先保存数据
      if (flag) {
        this.save('2') //非多人检查提交数据
      } else {
        this.save('1')
      }

      // if (flag) {
      //   this.$Confirm(
      //     '对检查问题的修改将会修改检查结果，确认提交吗？',
      //     '提示',
      //     {
      //       confirmButtonText: '确定',
      //       cancelButtonText: '取消',
      //       type: 'warning'
      //     }
      //   ).then(() => {
      //     this.save('2')
      //   })
      // } else {
      //   this.save('2')
      // }
    },
    formatUser(user) {
      if (user) {
        if (user.UserName.indexOf(user.UserId) <= -1) {
          return `${user.UserName}(${user.UserId})`
        }
        return `${user.UserName}`
      }
      return ''
    },
    validatesBeforeSave(callback) {
      if (!this.form.SJKS) {
        this.$msg('请选择受检科室!', 'warning')
        return
      }
      if (!this.form.JCBD) {
        this.$msg('请选择检查表单!', 'warning')
        return
      }
      //枚举 1115 检查时间超过子计划结束时间，提交表单时弹出提示
      if (
        this.isRemindSaveAfterPlanDate &&
        this.rowData &&
        (this.rowData.JSSJ || this.rowData.JcJSSJ)
      ) {
        // if (this.moment(this.form.DCSJ).diff(this.rowData.JSSJ || this.rowData.JcJSSJ, 'day') > 0) {
        if (
          new Date().getTime() -
            (new Date(
              this.rowData.ZjhJSSJ === null
                ? this.rowData.JcJSSJ
                : this.rowData.ZjhJSSJ
            ).getTime() +
              86400000) >
          0
        ) {
          this.$Confirm(
            '当前表单的督查时间跟计划检查时间不符，会影响后面的统计数据，是否继续操作？',
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }
          )
            .then(() => {
              callback()
            })
            .catch(() => {})
          return
        }
      }
      callback()
    },
    handleAutoSave() {
      const temptableData = cloneDeep(this.tableData)
      const tempCloneTableData = cloneDeep(this.cloneTableData)
      temptableData.forEach((item) => {
        delete item._X_ID
        delete item._X_ROW_KEY
        item.KFJG = null
      })
      tempCloneTableData.forEach((item) => {
        delete item._X_ID
        delete item._X_ROW_KEY
        item.KFJG = null
      })
      if (
        !isEqual(this.form, this.cloneFormData) ||
        !isEqual(temptableData, tempCloneTableData)
      ) {
        this.save('1', true, true)
      }
    },
    // type: 0 保存 1 保存并退出 2提交; flag : true直接保存，false校验必填
    save(type, flag, notValid) {
      if (document.getElementsByClassName('showRedBorder').length > 0) {
        var redBorderList = document.getElementsByClassName('showRedBorder')
        var redBorderNum = redBorderList.length
        var focusRedBorderEle = null

        for (var i = 0; i < redBorderNum; i++) {
          var redBorderEle = redBorderList[i]
          focusRedBorderEle = redBorderEle.getElementsByTagName('textarea')[0]
          if (focusRedBorderEle != null) break
        }

        if (focusRedBorderEle != null) {
          focusRedBorderEle.scrollIntoView()
          focusRedBorderEle.focus()
        } else {
          document.getElementsByClassName('showRedBorder')[0].scrollIntoView()
        }
      }
      this.SET_BEFORE_CLOSE(false)
      // 校验1157参数
      let isValid = true
      let str1 = ''
      let str2 = ''
      let str3 = ''

      //1157开启，验证以下是否有未填写的
      let fillIn = true
      if (this.xtmj1157.includes('1')) {
        this.tableData.forEach((item) => {
          if (item.BCHSDM !== '') {
            fillIn = item.ZRRDM !== '' && item.BCBRDM !== '' ? true : false
          }
        })
      }

      if (this.tableData.length > 0) {
        this.tableData.forEach((item) => {
          if (!item.KFJG) {
            return false
          }

          // 核查表校验是否扣分
          if (
            item.HCBJGList != null &&
            item.HCBJGList.length > 0 &&
            item.HCBJGList &&
            !item.HCBJGList.some(
              (m) => m.YBSL > 0 && m.ISNRFM === '1' && m.ISNRJS === '0'
            )
          ) {
            return false
          }

          if (
            !item.SFWSJ &&
            (!item.KFYYSM ||
              (item.BCHSDM.length == 0 && item.BCBRDM.length == 0) ||
              item.ZRRDM.length === 0 ||
              (item.HCBJGList &&
                !item.HCBJGList.some(
                  (m) => m.YBSL > 0 && m.ISNRFM === '1' && m.ISNRJS === '0'
                )))
          ) {
            if (item.KFJG && this.checkTypeInfo.JCFS === 1022) {
              //百分制根据KFJG是否有值判断是否扣分
              isValid = false
            }
            if (this.checkTypeInfo.JCFS === 1024) {
              //核查表根据是否纳入分子分母判断
              if (
                this.checkResultList.find((i) => i.JGDM == item.KFJG).ISNRJS ===
                '0'
              ) {
                //表示是纳入分子
                isValid = false
              }
            }
          }
          if (
            !item.SFWSJ &&
            (!item.KFYYSM ||
              ((item.BCHSDM.length == 0 || item.BCBRDM.length == 0) &&
                this.form.JCLX === 1019 &&
                this.Mjdm === '1') ||
              item.ZRRDM.length === 0)
          ) {
            if (
              this.xtmj1157[0] == '1' &&
              !item.KFYYSM &&
              this.isInclude('KFYYSM')
            ) {
              str1 = '【扣分原因】'
            }
            //检查病人时校验病人
            let check1020 = this.form.JCLX == 1020 && item.BCBRDM.length == 0
            // 检查科室，护士必填，1127参数开启时增加了检查患者列，则检查患者必填
            let check1019 =
              this.form.JCLX === 1019 &&
              (item.BCHSDM.length == 0 ||
                (this.Mjdm === '1' && item.BCBRDM.length == 0))
            // 检查护士时护士必填
            let check1021 = this.form.JCLX == 1021 && item.BCHSDM.length == 0
            if (
              this.xtmj1157[1] == '1' &&
              (check1020 || check1019 || check1021) &&
              this.isInclude('BCHSDM')
            ) {
              str2 = '【被查护士 / 患者】'
            }
            if (
              this.xtmj1157[2] == '1' &&
              item.ZRRDM.length === 0 &&
              this.isInclude('ZRRDM')
            ) {
              str3 = '【责任人】'
            }
            if (item.KFJG && this.checkTypeInfo.JCFS === 1022) {
              //百分制根据KFJG是否有值判断是否扣分
              isValid = false
            }
            if (this.checkTypeInfo.JCFS === 1024) {
              //核查表根据是否纳入分子分母判断
              if (
                this.checkResultList.find((i) => i.JGDM == item.KFJG).ISNRJS ===
                '0'
              ) {
                //表示是纳入分子
                isValid = false
              }
            }
          }
        })
      }

      if (
        (this.xtmj1157[0] != '0' ||
          this.xtmj1157[1] != '0' ||
          this.xtmj1157[2] != '0') &&
        !flag &&
        (str1 + str2 + str3).length > 0 &&
        !fillIn
      ) {
        if (type === '2') {
          //提交
          this.$msg(`${str1 + str2 + str3}必填!`)
        } else {
          //保存
          this.$Confirm(
            `存在${str1 + str2 + str3}未录入内容，是否继续保存？`,
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }
          )
            .then(() => {
              this.save(type, true)
            })
            .catch(() => {})
        }
      } else {
        this.validatesBeforeSave(() => {
          this.tableLoading = true
          let JCZObj = this.jczOptions.filter(
            (item) => item.UserId === this.form.JCZ
          )[0]

          // 拼接检查者名称格式为张三(10001)
          this.form.JCZMC = this.formatUser(JCZObj) //JCZObj.UserName + '(' + JCZObj.UserId + ')'
          let ZKJCInfoList = JSON.parse(JSON.stringify(this.tableData))
          // 开启验证
          let isSavejudge = true
          let targetErrorRow = {}
          let targetIndex = 0
          if (
            this.xtmj1146 == '1' &&
            this.xtmj1250 == '1' &&
            this.xtmj1146 == '1' &&
            this.xtmj1250 == '1' &&
            this.checkTypeInfo.JCFS == '1024'
          ) {
            this.tableData.forEach((item, index) => {
              let numData = 0
              item.HCBJGList.forEach((ele) => {
                numData = parseInt(ele.YBSL) + numData
              })
              if (numData != item.SJRCS) {
                isSavejudge = false
                item.isError = true
                if (!targetErrorRow.isError) {
                  targetErrorRow = JSON.parse(JSON.stringify(item))
                  targetIndex = index
                }
              }
              if (numData == item.SJRCS) {
                item.isError = false
              }
            })
          }

          if (!isSavejudge) {
            this.tableLoading = false
            this.$msg(`受检人/次数与结果占比数据不一致，请更正`, 'warning')
            // 表格完整高度
            let tab_height = this.$refs.checkTable.$el.querySelector(
              '.vxe-table--body-wrapper'
            ).scrollHeight
            // 可视高度
            let see_height = this.$refs.checkTable.$el.querySelector(
              '.vxe-table--empty-placeholder'
            ).style.height
            // 滚动条滚动高度
            let table_scroll = this.$refs.checkTable.getScroll().scrollTop
            // 表格条数
            let lines = this.tableData.length
            //计算结果
            let resultData = (
              (tab_height - parseInt(see_height)) /
              lines
            ).toFixed(0)
            // 滚动到指定高度
            this.$refs.checkTable.scrollTo(
              table_scroll,
              parseInt(resultData) * (targetIndex == 0 ? 0 : targetIndex + 1)
            )
            this.$refs.checkTable.setCurrentRow(this.tableData[targetIndex])
            return
          }

          ZKJCInfoList.forEach((item) => {
            item.BCHSDM = Array.isArray(item.BCHSDM)
              ? item.BCHSDM.join(',')
              : item.BCHSDM
            item.BCHSMC = Array.isArray(item.BCHSMC)
              ? item.BCHSMC.join(',')
              : item.BCHSMC
            item.ZRRDM = Array.isArray(item.ZRRDM)
              ? item.ZRRDM.join(',')
              : item.ZRRDM
            item.ZRRMC = Array.isArray(item.ZRRMC)
              ? item.ZRRMC.join(',')
              : item.ZRRMC
            item.BCBRDM = Array.isArray(item.BCBRDM)
              ? item.BCBRDM.join(',')
              : item.BCBRDM
            item.BCBRMC = Array.isArray(item.BCBRMC)
              ? item.BCBRMC.join(',')
              : item.BCBRMC
            item.BJCZDM = Array.isArray(item.BJCZDM)
              ? item.BJCZDM.join(',')
              : item.BJCZDM
            item.BJCZMC = Array.isArray(item.BJCZMC)
              ? item.BJCZMC.join(',')
              : item.BJCZMC
          })

          let fjData = this.otherData.forEach((val) => {
            if (val.FJFS == 1214) {
              val.FJVal =
                val.valArr && val.valArr.length > 0 ? val.valArr.join(';') : ''
            }
          })

          let ZKJCModel = {
            ZKJB: this.selectZkjb
              ? `${this.form.ZKJB}`
              : `${this.listQuery.ZKJB}`,
            ORGID: this.selectZkjb ? this.form.ORGID : this.listQuery.ORGID,
            HospitalCode: this.listQuery.HospitalCode,
            CurrentUserId: this.$store.state.user.loginUserInfo.UserId,
            CurrentUserName: this.$store.state.user.loginUserInfo.username,
            BDDM: this.form.JCBD,
            BDMC: this.form.JCBDMC,
            CFXH: this.form.CFXH,
            TempCfxh: this.form.CFXH ? '' : this.uploadInfo.CFXH,
            ZZJGDM: this.form.SJKS,
            JCZID: this.form.JCZ,
            JCZMC: this.form.ZYMC,
            QTJCZID: Array.isArray(this.form.QTJCZID)
              ? this.form.QTJCZID.join(',')
              : this.form.QTJCZID,
            QTJCZMC: this.form.QTJCZMC,
            BJCZDM: this.form.BJCZDM.join(','),
            BJCZMC: this.form.BJCZMC.join(','),
            BJCZXX: this.form.BJCZXX.join(','),
            IsSave: type, // 1 保存 2 完成
            HCB_QZ: this.form.HCB_QZ ? this.form.HCB_QZ : 100,
            ZKJCInfoList, //接传递table数据
            ...this.scoreInfo,
            MEMO: this.form.MEMO,
            SFBXZG: this.form.SFBXZG ? 1 : 0,
            BFZSLJC_HGS: this.form.BFZSLJC_HGS,
            BFZSLJC_CJS: this.form.BFZSLJC_CJS,
            BFZSLJC_HGL: this.form.BFZSLJC_HGL,
            BFZSLJC_ZT: this.isShowHGSCheck ? '1' : '0',
            DCSJ: moment(this.form.DCSJ).format('YYYY-MM-DD'),
            JLJCSJ: this.laterUse ? '1' : '0',
            ShowTableCheckList: this.showTableCheckList,
            FJXMList: this.otherData,
            SJRCS: this.frequency,
            TaskToPlan: this.form.TaskToPlan ? 1 : 0,
            ZXH: this.form.ZXH,
            saveType: notValid ? '2' : null // 自动保存时传2 后端去除数据校验
          }
          if (this.isCopy) {
            ZKJCModel.IsCopy = '1'
          }
          //多人检查需要保留的数据
          //判断markData是否有数据，modify by Helang
          if (this.markData && this.markData.length > 0) {
            this.markData.forEach((item) => {
              item.SFWSJ =
                item.SFWSJ === false || item.SFWSJ == null || item.SFWSJ == '0'
                  ? '0'
                  : '1'
              item.BCHSDM = Array.isArray(item.BCHSDM)
                ? item.BCHSDM.join(',')
                : item.BCHSDM
              item.BCHSMC = Array.isArray(item.BCHSMC)
                ? item.BCHSMC.join(',')
                : item.BCHSMC
              item.ZRRDM = Array.isArray(item.ZRRDM)
                ? item.ZRRDM.join(',')
                : item.ZRRDM
              item.ZRRMC = Array.isArray(item.ZRRMC)
                ? item.ZRRMC.join(',')
                : item.ZRRMC
              item.BCBRDM = Array.isArray(item.BCBRDM)
                ? item.BCBRDM.join(',')
                : item.BCBRDM
              item.BCBRMC = Array.isArray(item.BCBRMC)
                ? item.BCBRMC.join(',')
                : item.BCBRMC
              item.BJCZDM = Array.isArray(item.BJCZDM)
                ? item.BJCZDM.join(',')
                : item.BJCZDM
              item.BJCZMC = Array.isArray(item.BJCZMC)
                ? item.BJCZMC.join(',')
                : item.BJCZMC
            })
          }
          // 多人检查解决冲突的数据，提交数据
          if (this.isGroupLeader && type == '2') {
            ZKJCModel.DRJCDetailList = ZKJCInfoList
            ZKJCModel.ZKJCInfoList = this.markData
            ZKJCModel.DRJC = 1
          }
          // 保存数据
          if (type == '1' && (this.isGroups || this.isGroupLeader)) {
            ZKJCModel.DRJCDetailList = ZKJCInfoList
            ZKJCModel.ZKJCInfoList = this.markData
            ZKJCModel.DRJC = 1
          }
          let msg = ''
          if (notValid) {
            msg = ' 正在进行自动保存...'
          } else {
            msg =
              this.isDRJC == true && type == '1' && !flag
                ? '正在获取打分冲突项...'
                : '保存中...'
          }
          const key = this.$dlg.mask(msg)

          // 如果是质控组,且是-1112_1这种形式，需要处理
          if (
            typeof ZKJCModel.ORGID == 'string' &&
            ZKJCModel.ORGID.indexOf('-1112') != -1
          ) {
            ZKJCModel.ORGID = '-1112'
          }
          this.$requestApi('SaveZKJC', ZKJCModel)
            .then((res) => {
              this.$dlg.close(key)
              this.tableLoading = false
              this.isSaved = true
              // Bug 748657: 【NMS测试】-【NQCS】-【质控检查】 -V5.1.2204质量检查界面中，点击开始检查，点击保存不应该关闭界面
              if (res.success) {
                if (type === '2') {
                  this.$emit('close', 'success')
                } else {
                  this.form.CFXH = res.data.code ? res.data.Cfxh : res.data
                  this.$requestApi('GetZKJCByCFXH', {
                    Cfxh: this.form.CFXH
                  }).then((result) => {
                    // 假如被检查者，不在接口内部，需要手动加入这些人员
                    if (result.data[0] && result.data[0].BJCZDM) {
                      this.form.BJCZMC = result.data[0].BJCZMC
                      this.form.BJCZDM = result.data[0].BJCZDM
                        ? _.compact(result.data[0].BJCZDM.split(',')).filter(
                            function (item) {
                              return item != '-1'
                            }
                          )
                        : [] // 被检查护士
                      let codeArr = result.data[0].BJCZDM.split(',')
                      let nameArr = result.data[0].BJCZMC.split(',')
                      codeArr.map((m, index) => {
                        if (
                          !this.bjczOptions.some((item) => {
                            return item.id == m
                          })
                        ) {
                          this.bjczOptions.push({
                            id: m,
                            name: nameArr[index]
                          })
                        }
                      })
                    }
                  })
                  this.$msg('数据保存成功!', 'success')
                  if (this.isDRJC) {
                    if (this.isSave && !flag && !this.isRevoke) {
                      this.getConflictData()
                    }
                    if (this.isSave && !flag && this.isRevoke) {
                      this.save('2')
                    }
                    //组长保存数据
                    // if(this.isGroupLeader){
                    //   this.save('2')
                    // }
                  }
                  this.cloneFormData = cloneDeep(this.form)
                  this.cloneTableData = cloneDeep(this.tableData)
                }
                if (this.laterUse) {
                  let obj = {
                    time: this.form.DCSJ,
                    expire: new Date().getTime() + 7 * 24 * 60 * 60 * 1000,
                    laterUse: this.laterUse
                  }
                  localStorage.setItem('lastTime', JSON.stringify(obj))
                } else {
                  localStorage.removeItem('lastTime')
                }
                // 已经检查完，返回的数据是个对象
                this.form.CFXH = res.data.code ? res.data.Cfxh : res.data
                this.getChangeRecordList()
              }
            })
            .catch((res) => {})
            .finally(() => {
              // 接口调用后,清除定时器重新触发校验
              if (this.paramTime) {
                clearInterval(this.timer)
                this.setInterVal()
              }
            })
        })
      }
    },
    // 取消
    exit() {
      if (!this.beforeClose) {
        this.$emit('close', {})
      } else {
        if (document.getElementsByClassName('v-dialog-modal').length == 1) {
          document.getElementsByClassName(
            'v-dialog-modal'
          )[0].style.zIndex = 1500
          document.getElementsByClassName(
            'v-dialog-overlay'
          )[0].style.zIndex = 1499
        }
        this.$Confirm('您填写的内容尚未保存，确定要离开吗？', '提示', {
          showCancelButton: true,
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
        })
          .then(() => {
            this.$emit('close', {})
          })
          .catch(() => {})
      }
    },
    // 是否折叠
    changeCollapse() {
      this.moreVisiable = !this.moreVisiable
    },
    handleScoreChange(val, row, type) {
      this.SET_BEFORE_CLOSE(true)
      this.calcScore()
      if (type && type === 'radio') {
        const hcbj = row.HCBJGList.find((v) => v.JGDM.toString() === val)

        //radio 要根据 ISNRFM 和 ISNRJS判断
        if (
          this.xtmj1179 != '0' &&
          row.firstHandle === 0 &&
          hcbj &&
          hcbj.ISNRFM === '1' &&
          hcbj.ISNRJS === '0'
        ) {
          row.autoAddKFYYSM = 1 //用于判断被查护士和被查患者修改是否默认填充（不好判断是否扣分）
          this.dealKFYYSM(row)
        }

        const optionList = row.HCBJGList || []
        const result = optionList.some((m) => m.JGDM == val && m.ISNRJS === '0')
        const ifBack =
          optionList.find((m) => m.JGDM == val).ISNRFM !== '0' &&
          optionList.find((m) => m.JGDM == val).ISNRJS === '0'
        if (result) {
          this.settingRowBJCZ(1, row)
        } else {
          this.settingRowBJCZ(0, row)
          // 1179参数开启时，自动填充扣分原因说明
          if (
            this.xtmj1179 != '0' &&
            row.firstHandle === 0 &&
            val !== '0' &&
            Number(val) !== 0
          ) {
            row.autoAddKFYYSM = 1 //用于判断被查护士和被查患者修改是否默认填充（不好判断是否扣分）
            this.dealKFYYSM(row)
          }
        }
        if (ifBack) {
          this.ifBack(row, 1)
        }
        return
      } else {
        this.ifBack(row, val)
      }
      this.settingRowBJCZ(val, row)
      // 1179参数开启时，自动填充扣分原因说明
      if (
        this.xtmj1179 != '0' &&
        (row.firstHandle === 0 || !row.KFYYSM) &&
        row.KFJG != '' &&
        row.KFJG != '0'
      ) {
        row.autoAddKFYYSM = 1 //用于判断被查护士和被查患者修改是否默认填充（不好判断是否扣分）
        this.dealKFYYSM(row)
      }
    },
    handleBchsChange(val, row) {
      this.SET_BEFORE_CLOSE(true)
      // 被查护士筛选，添加 val 的类型是['20230000000726',"20230000000721"],BCHSArr 已选择的被护士数组
      row.BCHSMC = []
      for (let i = 0; i < val.length; i++) {
        // 当选择的护士存在BCHSArr中添加到 BCHSMC中国
        row.BCHSMC.push(
          this.bchsSelectList.find((item) => item.id == val[i]).name
        )
      }

      // 需求 #1236272 被查护士默认选择成护士长
      if (this.isToZRRY === '2' && this.HSZinfo.length > 0 && val.length > 0) {
        // 有护士长 有被查护士数据
        for (let i = 0; i < this.HSZinfo.length; i++) {
          if (!row.ZRRDM.includes(this.HSZinfo[i].CYGH)) {
            row.ZRRDM.push(this.HSZinfo[i].CYGH) // 如果责任人中不包含护士长，就把护士长添加到责任人数组当中
            row.ZRRMC.push(
              this.HSZinfo[i].CYXM.includes('(')
                ? this.HSZinfo[i].CYXM
                : this.HSZinfo[i].CYXM + '(' + this.HSZinfo[i].CYGH + ')'
            )
            // 添加到选项
            row.zrrArr.push({
              id: row.ZRRDM[i],
              name: row.ZRRMC[i]
            })
          }
        }
      }
      if (this.isToZRRY === '0') {
        // 开启 1077参数时, 责任人赋值
        row.ZRRDM = row.BCHSDM
        row.ZRRMC = row.BCHSMC
      } else if (this.isToZRRY === '1') {
        // 1077参数开启后，取组织结构中的责任人(ZYFZR为3)
        if (this.HSZinfo.length > 0 && row.BCHSDM.length > 0) {
          // 有护士长 有被查护士数据
          for (let i = 0; i < this.HSZinfo.length; i++) {
            if (!row.ZRRDM.includes(this.HSZinfo[i].CYGH)) {
              row.ZRRDM.push(this.HSZinfo[i].CYGH) // 如果责任人中不包含护士长，就把护士长添加到责任人数组当中
              row.ZRRMC.push(
                this.HSZinfo[i].CYXM.includes('(')
                  ? this.HSZinfo[i].CYXM
                  : this.HSZinfo[i].CYXM + '(' + this.HSZinfo[i].CYGH + ')'
              )
            }
          }
        }
      }
      this.getZrrArr(row)
      for (let i = 0; i < val.length; i++) {
        if (!this.bjczOptions.some((j) => j.id == val[i])) {
          this.bjczOptions.push({
            id: val[i],
            name: row.BCHSMC[i]
          })
        }
        if (!this.form.BJCZDM.includes(row.BCHSDM[i])) {
          this.form.BJCZDM.push(row.BCHSDM[i])
        }

        if (!this.form.BCHSDM.includes(row.BCHSDM[i])) {
          this.form.BCHSDM.push(row.BCHSDM[i])
          this.form.BCHSMC.push(row.BCHSMC[i])
        }
        if (!this.bjczOptionsHs.some((j) => j.id == val[i])) {
          this.bjczOptionsHs.push({
            id: val[i],
            name: row.BCHSMC[i]
          })
        }
      }
      this.dealKFYYSM(row)
    },
    handleZrrChange(val, row, index) {
      this.SET_BEFORE_CLOSE(true)
      row.ZRRMC = []
      for (let i = 0; i < val.length; i++) {
        row.ZRRMC.push(
          this.zrrSelectList.find((item) => item.id == val[i]).name
        )
      }
      this.$set(this.tableData, index, row)
    },
    handleBcbrChange(val, row) {
      this.SET_BEFORE_CLOSE(true)
      // 是否是新增的
      let isAdd = row.BCBRDM.length > row.BCBRMC.length
      row.BCBRMC = []
      for (let i = 0; i < val.length; i++) {
        row.BCBRMC.push(
          this.bchzSelectList.find((item) => item.ID == val[i]).Name
        )
        if (!this.bjczOptions.some((j) => j.id == val[i])) {
          this.bjczOptions.push({
            id: val[i],
            name: row.BCBRMC[i],
            isPatient: true
          })
          if (!this.form.BJCZDM.includes(row.BCHSDM[i])) {
            this.form.BJCZDM.push(row.BCHSDM[i])
          }
          if (!this.form.BCHZDM.includes(row.BCHSDM[i])) {
            this.form.BCHZDM.push(row.BCHSDM[i])
            this.form.BCHZMC.push(row.BCBRMC[i])
          }
        }
      }
      if (this.isToZRRY === '2') {
        let temp = this.zrrSelectList.filter((i) => i.flag != '1')
        row.ZRRDM = row.ZRRDM.filter((i) => temp.find((j) => j.id == i))
        row.ZRRMC = row.ZRRMC.filter((i) => temp.find((j) => j.name == i))
      }
      if (
        row.BCBRDM &&
        row.BCBRDM.length > 0 &&
        this.isToZRRY === '2' &&
        this.bchzSelectList &&
        this.bchzSelectList.length > 0
      ) {
        // 保存后打开不能够知道患者是门诊还是院区的
        let blhs = row.BCBRDM.filter((m) => {
          return this.bchzSelectList.some((k) => {
            return k.ID == m && (k.type == undefined || k.type == '1')
          })
        }).join(',')
        let arr = []
        row.BCBRDM.forEach((i) => {
          if (this.dialogZrrArr.find((j) => j.ID == i && j.ZRHSList)) {
            this.dialogZrrArr
              .find((j) => j.ID == i && j.ZRHSList)
              .ZRHSList.forEach((k) => {
                if (k && k.ID && k.NAME) {
                  arr.push(k)
                }
              })
          }
        })
        if (blhs) {
          if (arr && arr.length > 0) {
            row.zrrArr = [
              ...arr.map((m) => {
                return {
                  id: m.ID,
                  name: m.NAME,
                  flag: '1'
                }
              }),
              ...row.zrrArr
            ]
          }

          let newArr = []
          if (row.zrrArr.length > 0) {
            newArr.push(row.zrrArr[0])
          }
          for (let i = 1; i < row.zrrArr.length; i++) {
            if (!newArr.find((item) => item.id == row.zrrArr[i].id)) {
              newArr.push(row.zrrArr[i])
            }
          }
          row.zrrArr = newArr
          // 问题 1251380  选择被查患者后，责任人自动清空了
          // row.ZRRDM = arr.map((m) => m.ID)
          // row.ZRRMC = arr.map((m) => m.NAME)
          if (arr.length > 0) {
            row.ZRRDM = arr.map((m) => m.ID)
            row.ZRRMC = arr.map((m) => m.NAME)
          }
        }
      }
      this.dealKFYYSM(row)
    },
    // 设置默认被检查者 val为0不设置，val为1 设置
    settingRowBJCZ(val, row) {
      // 需求 #1236272 被查护士默认选择成护士长
      if (this.isToZRRY === '2' && this.HSZinfo.length > 0) {
        // 有护士长 有被查护士数据
        for (let i = 0; i < this.HSZinfo.length; i++) {
          if (!row.ZRRDM.includes(this.HSZinfo[i].CYGH)) {
            row.ZRRDM.push(this.HSZinfo[i].CYGH) // 如果责任人中不包含护士长，就把护士长添加到责任人数组当中
            row.ZRRMC.push(
              this.HSZinfo[i].CYXM.includes('(')
                ? this.HSZinfo[i].CYXM
                : this.HSZinfo[i].CYXM + '(' + this.HSZinfo[i].CYGH + ')'
            )
            if (!row.zrrArr) row.zrrArr = []
            // 添加到选项
            row.zrrArr.push({
              id: row.ZRRDM[i],
              name: row.ZRRMC[i]
            })
          }
        }
      }
      // 开关未开启直接返回
      if (!this.isSettingDefaultBJCZ) {
        return
      }
      //确定表单类型,病人类型表单需要设置被查患者字段,其他设置被查护士
      const isCheckPatient = this.form.JCLX === 1020
      // 加分清除(与产品确认,加分情况不清除)
      // 等于0 或'0'
      if (!Number(val) || val.toString().includes('+')) {
        return
      }
      // 顶部被检查者有数据，遍历添加到数组里面
      if (this.form.BJCZDM.length > 0) {
        let hsArr = []
        let hzArr = []
        this.form.BJCZDM.forEach((item) => {
          if (this.bjczOptions.find((i) => i.id == item && !i.isPatient)) {
            hsArr.push(item)
          } else {
            hzArr.push(item)
          }
        })
        const firstBJCZDM = hsArr[0] ? hsArr[0] : ''
        const firstBJCZMC = firstBJCZDM
          ? this.bjczOptions.find((m) => m.id == firstBJCZDM).name
          : ''
        const secondBJCZDM = hzArr[0] ? hzArr[0] : ''
        const secondBJCZMC = secondBJCZDM
          ? this.bjczOptions.find((m) => m.id == secondBJCZDM).name
          : ''
        if (row.BCHSDM.length == 0 && this.xtmj1179 == '2') {
          row.BCHSDM = firstBJCZDM ? firstBJCZDM.split(',') : []
          row.BCHSMC = firstBJCZMC ? firstBJCZMC.split(',') : []
          if (
            !this.bchsSelectList.find((i) => i.id == firstBJCZDM) &&
            firstBJCZDM != null &&
            firstBJCZDM.length > 0
          ) {
            this.bchsSelectList.push({
              id: firstBJCZDM,
              name: firstBJCZMC
            })
          }
        }
        if (row.BCBRDM.length == 0 && this.xtmj1179 == '2') {
          row.BCBRDM = secondBJCZDM ? secondBJCZDM.split(',') : []
          row.BCBRMC = secondBJCZMC ? secondBJCZMC.split(',') : []
          let index = this.bchzSelectList.findIndex((m) => m.ID == secondBJCZDM)
          if (index < 0 && secondBJCZDM != null && secondBJCZDM.length > 0) {
            this.bchzSelectList.push({
              id: secondBJCZDM,
              name: secondBJCZMC,
              ID: secondBJCZDM,
              Name: secondBJCZMC
            })
          }
        }
        // 检查患者表单不需要同步zrr
        if (this.isToZRRY === '0' && !isCheckPatient) {
          row.ZRRDM = firstBJCZDM ? firstBJCZDM.split(',') : []
          row.ZRRMC = firstBJCZMC ? firstBJCZMC.split(',') : []
        }
      }

      if (this.isToZRRY === '1') {
        // 1077参数开启后，取组织结构中的责任人(ZYFZR为3)
        if (this.HSZinfo.length > 0) {
          for (let i = 0; i < this.HSZinfo.length; i++) {
            if (!row.ZRRDM.includes(this.HSZinfo[i].CYGH)) {
              row.ZRRDM.push(this.HSZinfo[i].CYGH)
              row.ZRRMC.push(
                this.HSZinfo[i].CYXM.includes('(')
                  ? this.HSZinfo[i].CYXM
                  : this.HSZinfo[i].CYXM + '(' + this.HSZinfo[i].CYGH + ')'
              )
            }
          }
        }
      }
      this.getZrrArr(row)
    },
    // 通用行合并函数（将相同多列数据合并为一行）
    rowspanMethod({ row, _rowIndex, column, visibleData }) {
      if (this.tableData.length > 200) {
        return
      }
      const fields = this.isShowKFBZColumn ? ['XMDM', 'BZDM'] : ['XMDM']
      const cellValue = row[column.property]
      if (cellValue && fields.includes(column.property)) {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        if (prevRow && prevRow[column.property] === cellValue) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow[column.property] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      }
    },

    // changeTable(row, index) {
    //   this.$set(this.tableData, index, row)
    // },
    //明细项被查患者弹框 关闭
    dialogClose(val) {
      let that = this
      this.dialogVisible = false
      if (val) {
        let names = []
        let values = []
        let ZRHSLists = []
        let zyHz = [] //住院患者

        val.map((v) => {
          // 这个处理一下 Name 和 ID
          let targetID = v.ID === null ? v.BLH : v.ID
          names.push(v.Name === null ? v.HZXM : v.Name)
          values.push(targetID)
          if (v.ZRHSList) {
            v.ZRHSList.forEach((i) => {
              ZRHSLists.push(i)
            })
          }
          this.dialogZrrArr.push({
            ID: targetID,
            ZRHSList: v.ZRHSList
          })
          if (v.type == '1') {
            zyHz.push(targetID)
          }
          if (!this.bchzSelectList.find((i) => i.ID === v.ID)) {
            this.bchzSelectList.push({
              id: v.ID,
              name: v.Name,
              ...v
            })
          }
        })
        let arr = []
        if (ZRHSLists.length > 0) {
          arr.push(ZRHSLists[0])
        }
        for (let i = 1; i < ZRHSLists.length; i++) {
          if (!arr.find((item) => item.ID == ZRHSLists[i].ID)) {
            arr.push(ZRHSLists[i])
          }
        }
        this.tableData[this.tableIndex].BCBRDM = values
        this.tableData[this.tableIndex].BCBRMC = names
        if (zyHz && zyHz.length > 0 && this.isToZRRY === '2') {
          // let blhs = zyHz.join(',')
          // this.$requestApi('GetZRHSList', {
          //   blhs: blhs
          // }).then((res) => {
          //   if (res.success) {
          //     if (res.data.length == 0) return
          //     if (this.tableData[this.tableIndex].ZRRDM.length > 0) {
          //       return
          //     }
          //     let arr = []
          //     arr.push(res.data[0])
          //     for (let i = 1; i < res.data.length; i++) {
          //       if (res.data[i].ID !== res.data[0].ID) {
          //         arr.push(res.data[i])
          //       }
          //     }
          this.tableData[this.tableIndex].ZRRDM = [
            ...this.tableData[this.tableIndex].ZRRDM,
            ...arr.map((m) => m.ID)
          ]
          this.tableData[this.tableIndex].ZRRMC = [
            ...this.tableData[this.tableIndex].ZRRMC,
            ...arr.map((m) => m.NAME)
          ]
          arr.forEach((element) => {
            if (
              element.ID &&
              !that.zrrSelectList.some((m) => m.id == element.ID)
            ) {
              that.zrrSelectList.push({
                id: element.ID,
                name: element.NAME,
                flag: '1'
              })
            }
          })
          //   }
          // })
        }

        for (let i = 0; i < val.length; i++) {
          if (!this.bjczOptions.some((j) => j.id == val[i].ID)) {
            this.bjczOptions.push({
              id: val[i].ID,
              name: val[i].Name,
              isPatient: true
            })
          }
          if (!this.form.BJCZDM.includes(val[i].ID)) {
            this.form.BJCZDM.push(val[i].ID)
          }
          if (!this.form.BCHZDM.includes(val[i].ID)) {
            this.form.BCHZDM.push(val[i].ID)
            this.form.BCHZMC.push(val[i].Name)
          }
        }
        this.concatPeople(val)
        this.dealKFYYSM(this.tableData[this.tableIndex])
      }
    },
    //主任务被查患者弹框 关闭
    patientDialogClose(val) {
      this.patientDialogVisible = false
      if (val) {
        this.tableData.forEach((item) => {
          for (let i = 0; i < val.length; i++) {
            if (!this.bchzSelectList.find((item) => item.ID === val[i].ID)) {
              this.bchzSelectList.push({
                id: val[i].ID,
                name: val[i].Name,
                ID: val[i].ID,
                Name: val[i].Name
              })
            }
          }
        })
        const values = []
        const names = []
        const patient = []
        val.map((v) => {
          if (!this.form.BJCZDM.includes(v.ID)) {
            values.push(v.ID)
            names.push(v.Name)
          }
          const isExsit =
            this.bjczOptions != null &&
            this.bjczOptions.some((item) => item.id == v.ID)
          if (!isExsit) {
            patient.push({
              id: v.ID,
              name: v.Name,
              isPatient: true
            })
          }
          this.dialogZrrArr.push({
            ID: v.ID,
            ZRHSList: v.ZRHSList
          })
        })
        const bjczArr = _.clone(this.bjczOptions) || []
        const bjczdmArr = _.clone(this.form.BJCZDM) || []
        const bjczmcArr = _.clone(this.form.BJCZMC) || []

        const bchzdmArr = _.clone(this.form.BCHZDM) || []
        const bchzmcArr = _.clone(this.form.BCHZMC) || []
        const bchzList = _.clone(this.bchzSelectList) || []

        this.bjczOptions = bjczArr.concat(patient)
        this.form.BJCZDM = bjczdmArr.concat(values)
        this.form.BJCZMC = bjczmcArr.concat(names)

        let temp = patient.filter((m) => {
          return !this.bchzSelectList.some((k) => m.id == k.ID)
        })
        if (temp) {
          this.bchzSelectList = bchzList.concat(
            temp.map((m) => {
              return {
                ...m,
                ID: m.id,
                Name: m.name
              }
            })
          )
        }
        this.form.BCHZDM = bchzdmArr.concat(values)
        this.form.BCHZMC = bchzmcArr.concat(names)
        this.buildBJCZInfo()
        this.concatPeople(val)
      }
    },
    concatPeople(val) {
      for (let i = 0; i < val.length; i++) {
        if (this.jczOptions.find((j) => j.UserId == val[i].ID)) {
          return
        }
        this.jczOptions = this.jczOptions.concat({
          UserId: val[i].ID,
          UserName: val[i].Name
        })
      }
    },
    addPatient(row, index) {
      this.SET_BEFORE_CLOSE(true)
      this.row = row
      this.tableIndex = index
      this.dialogVisible = true
    }, //在任务被查患者中添加患者
    addMainTaskPatient() {
      this.SET_BEFORE_CLOSE(true)
      if (!this.rowData.KFXDM) {
        this.patientDialogVisible = true
      }
    },
    // 多次检查添加
    handleAddRow(item, index, title) {
      this.SET_BEFORE_CLOSE(true)
      const KFDMList = this.tableData.filter((tb) => tb.KFDM === item.KFDM)
      // if (KFDMList.length >= this.form.BJCZDM.length) {
      //   this.$msg(`${title}标准个数超出被检查者人数`, 'warning')
      //   return
      // }
      if (KFDMList.length >= this.form.BCHSDM.length) {
        this.$msg(`${title}标准个数超出被检查者人数`, 'warning')
        return
      }
      let xhArr = new Array()
      this.tableData.forEach((i) => {
        if (i.KFDM === item.KFDM) {
          xhArr.push(i.XSXH)
        }
      })
      let maxXsxh = Math.max.apply(null, xhArr) + 1
      let kfCount = xhArr.length

      let newObj = JSON.parse(JSON.stringify(item))
      newObj.firstHandle = 0
      const row = {
        ...newObj,
        KFYYSM: '',
        BCHSDM: [],
        BCHSMC: [],
        ZRR: '',
        ZRRDM: [],
        ZRRMC: [],
        BCBRDM: [],
        BCBRMC: [],
        SFWSJ: false,
        ID: 0,
        KFJG: '',
        ISADD: 1,
        TPSL: ''
      }
      row.XSXH = maxXsxh

      // 设置默认选项
      this.setDefaultKFJG(row)
      this.tableData.splice(index + kfCount, 0, row)
      if (item.SFWSJ) {
        this.tableData.forEach((i) => {
          if (i.KFDM === item.KFDM) {
            i.SFWSJ = true
            //百分表模式,不设置未涉及默认值
            if (this.checkTypeInfo.JCFS !== 1024) {
              i.KFJG = null
            }
          }
        })
      }

      this.calcScore()
    },
    handleDelRow(item, index) {
      this.SET_BEFORE_CLOSE(true)
      this.tableData.splice(index, 1)

      this.calcScore()
    },
    // 打开上传
    handleOpenUpload(row) {
      if (row.SFWSJ || !row.editAble) {
        return
      }
      this.SET_BEFORE_CLOSE(true)

      let rowIndex = 1
      this.tableData.forEach((i) => {
        if (i.KFDM === row.KFDM) {
          if (i.XSXH == 0 && rowIndex > 1) {
            i.XSXH = rowIndex
          }
          rowIndex++
        }
      })

      this.uploadInfo = row
      this.uploadInfo.CFXH = this.uploadInfo.CFXH
        ? this.uploadInfo.CFXH
        : 'Temp_' + new Date().getTime()
      this.upVisible = true
    },
    updateNum(num) {
      if (this.uploadInfo.CFXH.toString().indexOf('Temp_') <= -1) {
        this.tableData.find(
          (i) => i.ID == this.uploadInfo.ID && i.XSXH == this.uploadInfo.XSXH
        ).TPSL = num
      } else {
        this.tableData.find(
          (i) =>
            i.Index == this.uploadInfo.Index && i.XSXH == this.uploadInfo.XSXH
        ).TPSL = num
      }
    },
    //上传
    uploadDialogClose() {
      this.upVisible = false
    },
    // 将结果另存为
    saveResultForOther(item) {
      let that = this
      this.tableData.forEach((el) => {
        if (!el.SFWSJ) {
          el.KFJG = item.JGDM.toString()
        }
        // 1179参数开启时，自动填充扣分原因说明
        if (
          that.xtmj1179 != '0' &&
          el.firstHandle === 0 &&
          item.ISNRFM == 1 &&
          item.ISNRJS == 0
        ) {
          el.autoAddKFYYSM = 1 //用于判断被查护士和被查患者修改是否默认填充（不好判断是否扣分）
          this.dealKFYYSM(el)
        }
        this.settingRowBJCZ(1, el)
      })
      this.calcScore()
    },
    handleSFWSJ(val, row) {
      row.changeKFYYSM = 0
      row.autoAddKFYYSM = 0
      this.indeterminate =
        this.tableData.find((i) => i.SFWSJ) &&
        this.tableData.find((i) => !i.SFWSJ)
          ? true
          : false
      this.allSFWSJ = this.tableData.find((i) => !i.SFWSJ) ? false : true
      this.SET_BEFORE_CLOSE(true)
      if (val && row.KFYYSM) {
        row.KFYYSM = ''
      }
      if (!val && this.xtmj1179 != '0') {
        row.firstHandle = 0
      }
      row.HGL = this.xtmj1256 ? 0 : 1

      if (val) {
        if (this.checkTypeInfo.JCFS !== 1024 && this.xtmj1186 && this.bd1186) {
          row.ZRS = null
          row.HGS = null
          row.BHGS = null
          row.DXHGL = null
        }
        if (this.form.JCLX !== 1020) {
          row.BCHSMC = []
          row.BCHSDM = []
        }
        row.ZRRMC = []
        row.ZRRDM = []
        if (
          this.form.JCLX === 1020 ||
          (this.form.JCLX === 1019 && this.Mjdm === '1')
        ) {
          row.BCBRMC = []
          row.BCBRDM = []
        }
      }

      //核查表模式,设置未涉及默认值
      if (this.checkTypeInfo.JCFS === 1022) {
        row.KFJG = null
      }
      // if (val) {
      this.setDefaultKFJG(row) //取消未涉及时接过勾选默认值
      // }
      // 多次检查将
      if (row.DCJC === 1) {
        this.tableData.forEach((item) => {
          if (item.KFDM === row.KFDM) {
            item.SFWSJ = val
            if (this.checkTypeInfo.JCFS !== 1024) {
              item.KFJG = null
            }
            if (val) {
              this.setDefaultKFJG(item)
              this.clearCheckInfo(item, this.form.JCFS, this.form.JCLX)
            }
          }
        })
      }

      this.calcScore(row)
    },
    clearCheckInfo(row, jcfs, jclx) {
      row.KFYYSM = ''
      row.KFYYDM = ''
      row.KFYYMC = ''
      if (jcfs !== 1024 && this.xtmj1186 && this.bd1186) {
        row.ZRS = null
        row.HGS = null
        row.BHGS = null
        row.DXHGL = null
      }
      if (jclx !== 1020) {
        row.BCHSMC = []
        row.BCHSDM = []
      }
      row.ZRRMC = []
      row.ZRRDM = []
      if (jclx === 1020 || (jclx === 1019 && this.Mjdm === '1')) {
        row.BCBRMC = []
        row.BCBRDM = []
      }
    },
    //未涉及全选
    handleCheckAll() {
      this.indeterminate = false
      this.tableData.forEach((item) => {
        //设置合格率
        item.HGL = this.xtmj1256 ? 0 : 1
        item.changeKFYYSM = 0
        item.autoAddKFYYSM = 0
        item.SFWSJ = this.allSFWSJ
        // 清空数据
        item.HCBJGList.forEach((items) => {
          items.YBSL = 0
          items.YBZB = 0
        })

        if (item.SFWSJ) {
          item.KFYYSM = ''
          if (
            this.checkTypeInfo.JCFS !== 1024 &&
            this.xtmj1186 &&
            this.bd1186
          ) {
            item.ZRS = null
            item.HGS = null
            item.BHGS = null
            item.DXHGL = null
          }
          if (this.form.JCLX !== 1020) {
            item.BCHSMC = []
            item.BCHSDM = []
          }
          item.ZRRMC = []
          item.ZRRDM = []
          if (
            this.form.JCLX === 1020 ||
            (this.form.JCLX === 1019 && this.Mjdm === '1')
          ) {
            item.BCBRMC = []
            item.BCBRDM = []
          }
          if (this.checkTypeInfo.JCFS === 1022) {
            item.KFJG = null
          }
        } else {
          if (this.xtmj1179 != '0') {
            item.firstHandle = 0
          }
        }
        this.setDefaultKFJG(item)
        // if (item.DCJC === 1) {
        //   this.tableData.forEach((i) => {
        //     if (i.KFDM === item.KFDM) {
        //       i.SFWSJ = item.SFWSJ
        //       if (this.checkTypeInfo.JCFS !== 1024) {
        //         i.KFJG = null
        //       }
        //       if (val) {
        //         this.setDefaultKFJG(item)
        //       }
        //     }
        //   })
        // }
      })

      this.calcScore()
    },
    setDefaultKFJG(row) {
      if (
        this.form.JCFS === 1024 &&
        row.HCBJGList &&
        row.HCBJGList.length > 0
      ) {
        row.KFJG = row.HCBJGList.find((m) => m.ISNRJS == '1').JGDM + '' //解决点击反选后无法设置默认值问题
      }
    },
    handleSelectAll(val) {
      this.SET_BEFORE_CLOSE(true)
      if (val) {
        this.form.BCHSDM = this.bjczOptions.map((item) => item.id)
        this.form.BCHSMC = this.bjczOptions.map((item) =>
          item.name.indexOf(item.id) > -1
            ? item.name
            : item.name + `(${item.id})`
        )

        this.form.BJCZDM = this.form.BCHSDM.concat(this.form.BCHZDM)
        this.form.BJCZMC = this.form.BCHSMC.concat(this.form.BCHZMC)
      } else {
        this.form.BJCZDM = []
        this.form.BJCZMC = []
        this.form.BCHSDM = []
        this.form.BCHSMC = []
      }
    },
    hgsChange() {
      this.form.BFZSLJC_HGS = formatInput1(
        this.form.BFZSLJC_HGS ? this.form.BFZSLJC_HGS.toString() : ''
      )
      this.form.BFZSLJC_CJS = formatInput1(
        this.form.BFZSLJC_CJS ? this.form.BFZSLJC_CJS.toString() : ''
      )
      // 两者都有值
      if (this.form.BFZSLJC_HGS && this.form.BFZSLJC_CJS) {
        let hgs = Number(this.form.BFZSLJC_HGS)
        let cjs = Number(this.form.BFZSLJC_CJS)
        if (hgs > cjs) {
          this.$msg('合格数不允许大于抽检数！')
          this.form.BFZSLJC_CJS = this.form.BFZSLJC_HGS
          this.form.BFZSLJC_HGL = 100
          return
        }
        if (isNumber(hgs) && isNumber(cjs) && cjs != 0) {
          this.form.BFZSLJC_HGL = Math.round((100 * (100 * hgs)) / cjs) / 100
        } else {
          this.form.BFZSLJC_HGL = ''
          this.$msg('请正确填写合格数和抽检数！')
        }
      } else {
        this.form.BFZSLJC_HGL = ''
      }
    },
    buildSnapshot() {
      if (!this.tableData || this.tableData.length <= 0) {
        return
      }
      if (this.tableData[0].DCJC === 1) {
        this.$nextTick(() => {
          this.lastSnapshot = JSON.stringify(
            this.tableData,
            function (key, val) {
              return val === '' ? null : val
            }
          )
        })
      }
    },
    updateCheckContent() {
      const newSnapshot = JSON.stringify(this.tableData, function (key, val) {
        return val === '' ? null : val
      })
      if (newSnapshot == this.lastSnapshot) {
        this.copyRowAccordingToBJCZNumber()
        return
      }
      this.$Confirm('是否覆盖现有‘核查内容‘?', '提示', {
        confirmButtonText: '覆盖',
        cancelButtonText: '不覆盖',
        type: 'warning'
      })
        .then(() => {
          this.allSFWSJ = false
          this.indeterminate = false
          this.copyRowAccordingToBJCZNumber()
        })
        .catch(() => {})
    },
    copyRowAccordingToBJCZNumber() {
      // 多次检查时根据被检查者人数生成表
      if (this.form.BJCZDM.length <= 1) {
        return
      }

      // 是否患者类型表单
      const isCheckPatient = this.form.JCLX === 1020
      const newTableData = []
      let bchsNum = 0
      for (let i = 0; i < this.form.BJCZDM.length; i++) {
        if (
          !this.bjczOptions.find((j) => j.id == this.form.BJCZDM[i]).isPatient
        ) {
          bchsNum = bchsNum + 1
        }
      }
      if (Number(this.xtmj1198) < this.tableData.length * bchsNum) {
        this.$msg(`扣分标准数量不能超过${this.xtmj1198}`)
        return
      }

      this.tableData.forEach((item) => {
        if (item.ISADD === 1) {
          return
        }
        this.form.BJCZDM.forEach((bjcz, index) => {
          let newObj = JSON.parse(JSON.stringify(item))
          const isAdd = index === 0 ? 0 : 1
          const bjczmc = this.bjczOptions.find((m) => m.id === bjcz).name
          const row = {
            ...newObj,
            KFYYSM: '',
            BCHSDM:
              !isCheckPatient &&
              !this.bjczOptions.find((j) => j.id == bjcz).isPatient
                ? bjcz.split(',')
                : [],
            BCHSMC:
              !isCheckPatient &&
              !this.bjczOptions.find((j) => j.id == bjcz).isPatient
                ? bjczmc.split(',')
                : [],
            ZRR: '',
            ZRRDM: [],
            ZRRMC: [],
            BCBRDM:
              isCheckPatient ||
              this.bjczOptions.find((j) => j.id == bjcz).isPatient
                ? bjcz.split(',')
                : [],
            BCBRMC:
              isCheckPatient ||
              this.bjczOptions.find((j) => j.id == bjcz).isPatient
                ? bjczmc.split(',')
                : [],
            SFWSJ: false,
            ID: 0,
            KFJG: '',
            ISADD: isAdd // 是手动新增
          }
          this.setDefaultKFJG(row) //核查表设置默认选项值
          if (
            isCheckPatient ||
            !this.bjczOptions.find((m) => m.id === bjcz).isPatient
          ) {
            newTableData.push(row)
          }
        })
      })

      this.tableData = newTableData
      this.calcScore()
    },
    // 处理被检查者变化 type 1护士，2患者
    handleExamineeChange(type) {
      if (type == '1') {
        this.bchsChanged()
      } else {
        this.bchzChangeed()
      }
      this.SET_BEFORE_CLOSE(true)
      // 1181设置默认被检查者参数开启时处理,
      if (!this.isSettingDefaultBJCZ) {
        return
      }

      if (this.form.BJCZDM.length <= 0) {
        return
      }
      const isCheckPatient = this.form.JCLX === 1020
      let isPatient = this.bjczOptions.find(
        (i) => i.id == this.form.BJCZDM[0]
      ).isPatient
      const codeKey = isCheckPatient || isPatient ? 'BCBRDM' : 'BCHSDM'
      const nameKey = isCheckPatient || isPatient ? 'BCBRMC' : 'BCHSMC'
      // 获取扣了分,但是没有设置被查者的记录
      const unSettingBJCZList = this.tableData.filter((item) => {
        if (!this.isHaveKFJG(item)) {
          return false
        }
        if (item[codeKey].length > 0) {
          return false
        }
        return true
      })
      const firstBJCZDM = this.form.BJCZDM[0]
      const firstBJCZMC = this.bjczOptions.find((m) => m.id == firstBJCZDM).name
      unSettingBJCZList.forEach((row) => {
        row[codeKey] = firstBJCZDM ? firstBJCZDM.split(',') : []
        row[nameKey] = firstBJCZMC ? firstBJCZMC.split(',') : []
        if (this.isToZRRY === '0' && !isCheckPatient && !isPatient) {
          row.ZRRDM = firstBJCZDM ? firstBJCZDM.split(',') : []
          row.ZRRMC = firstBJCZMC ? firstBJCZMC.split(',') : []
          this.getZrrArr(row)
        } else if (this.isToZRRY === '1' && !isCheckPatient && !isPatient) {
          // 1077参数开启后，取组织结构中的责任人(ZYFZR为3)
          if (this.HSZinfo.length > 0) {
            for (let i = 0; i < this.HSZinfo.length; i++) {
              if (!row.ZRRDM.includes(this.HSZinfo[i].CYGH)) {
                row.ZRRDM.push(this.HSZinfo[i].CYGH)
                row.ZRRMC.push(
                  this.HSZinfo[i].CYXM.includes('(')
                    ? this.HSZinfo[i].CYXM
                    : this.HSZinfo[i].CYXM + '(' + this.HSZinfo[i].CYGH + ')'
                )
              }
            }
          }
          this.getZrrArr(row)
        }
      })
      if (this.type === 'add') {
        this.form.BJCZMC = []
        this.form.BJCZDM.forEach((item) => {
          this.form.BJCZMC.push(this.bjczOptions.find((i) => i.id == item).name)
        })
      }
    },
    //判断当前行是否扣了分
    isHaveKFJG(row) {
      if (this.checkType === 1022) {
        if (row.KFJG) {
          return true
        }
        return false
      }
      // 核查表
      const optionList = row.HCBJGList || []
      const result = optionList.some(
        (m) => m.JGDM == row.KFJG && m.ISNRJS === '0'
      )
      return result
    },
    //任务被检查者是否与明细中一致
    isHaveSameBJCZ() {
      const isCheckPatient = this.form.JCLX === 1020
      const codeKey = isCheckPatient ? 'BCBRDM' : 'BCHSDM'
      const bjczDetail = this.tableData.filter((row) => row[codeKey])
      if (_.isEmpty(bjczDetail)) {
        return true
      }
      const bjczdmDetail = bjczDetail.map((row) => row[codeKey])
      const unqBjczDetail = _.uniq(bjczdmDetail)
      let unqBjczDetailArr = []
      unqBjczDetail.forEach((item) => {
        item.forEach((i) => {
          if (i) {
            unqBjczDetailArr.push(i)
          }
        })
      })
      unqBjczDetailArr = [...new Set(unqBjczDetailArr)]
      const result = _.isEqual(this.form.BJCZDM.sort(), unqBjczDetailArr.sort())
      return result
    },
    settingDCSJ() {
      if (
        localStorage.getItem('lastTime') &&
        JSON.parse(localStorage.getItem('lastTime')).expire >
          new Date().getTime()
      ) {
        if (!this.canNotModifyCheckDate) {
          this.form.DCSJ = JSON.parse(localStorage.getItem('lastTime')).time
        }
      }
    },
    validateIsHaveSameBJCZ(callback) {
      //多次检查时判断,检查明细中的“被查护士”与检查任务的“被检查者”不一致的情况
      const isDCJC = _.isEmpty(this.tableData)
        ? false
        : this.tableData[0].DCJC === 1
      //不是多次检查,直接保存
      if (!isDCJC) {
        callback()
        return
      }
      if (this.isHaveSameBJCZ()) {
        callback()
        return
      }
      //多次检查判断明细与任务的被检查者是否一致
      this.$Confirm(
        '检查明细中的“被查护士”与检查任务的“被检查者”不一致，是否继续保存/提交？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          callback()
        })
        .catch(() => {})
    },
    handleClickArrow(row) {
      this.SET_BEFORE_CLOSE(true)
      this.isShowReason = true
      this.queryRenson(row)
    },
    //隐藏表单
    hide() {
      document.body.click()
    },
    addSelfReason(val, row) {
      if (!val) {
        this.$msg('扣分原因说明不能为空！')
        return
      }
      if (Array.isArray(val)) {
        let KFJG = 0
        val.forEach((item) => {
          row.KFYYSM
            ? (row.KFYYSM = row.KFYYSM + '\n' + item.YYMC)
            : (row.KFYYSM = item.YYMC)
          KFJG += item.KFFZ ? item.KFFZ : 0
        })
        let maxNum =
          row.JFFS === 1068
            ? row.XMFZ
            : row.JFFS === 1183
            ? row.BZFZ
            : row.JFFS === 1184
            ? row.BDZF
            : row.BZFZ
        if (KFJG && KFJG > 0) {
          row.KFJG = KFJG > Number(maxNum) ? Number(maxNum) : KFJG
          this.calcScore('')
        }
      } else {
        this.saveReason(row, val)
        row.selfReason = ''
      }
    },
    saveReason(row, val) {
      this.$requestApi('SaveKFYY', {
        BDDM: row.BDDM,
        BZDM: row.BZDM,
        YYMC: val,
        SFLSYY: 1
      }).then((res) => {
        this.queryRenson(row)
      })
    },
    deleteSelfReason(val, row) {
      if (val == null || val.length == 0) {
        this.$msg('请选择要删除的扣分原因')
        return
      }

      let deleteFlag = true
      for (var i = 0; i < val.length; i++) {
        if (val[i].SFLSYY != 1) {
          deleteFlag = false
          break
        }
      }
      if (!deleteFlag) {
        this.$msg('不能删除检查表单设置时所增加的扣分原因')
        return
      }

      this.$requestApi('DeleteKFYY', {
        YYDM: val.map((item) => item.id).join(',')
      }).then((res) => {
        this.queryRenson(row)
      })
    },
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    handleCheckChange(val) {
      this.anchorId = val.id
      document.getElementById(val.id).scrollIntoView()
    },
    handleInputChange(val) {
      this.$refs.filterTree.filter(val)
    },
    handleClickTree() {
      if (this.showTree) {
        this.showTree = false
      } else {
        this.showTree = true
      }
      this.$nextTick(() => {
        if (this.anchorId) {
          document.getElementById(this.anchorId).scrollIntoView()
        }
      })
    },
    handleGet() {
      this.$Confirm(
        '自动提取将调用外部接口自动获取部分检查结果，获取成功将替换现有内容，确定提取吗？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.$requestApi('GetFillPatientUserList', {
            Bddm: this.form.JCBD,
            // Bqdm: this.$store.state.user.HospitalCode
            Bqdm: 12
          }).then((res) => {
            res.data.forEach((item) => {
              let BCBRMCArr = []
              let BCBRDMArr = []
              item.UserList.forEach((k) => {
                BCBRMCArr.push(k.Name)
                BCBRDMArr.push(k.ID)
              })
              item.UserName = BCBRMCArr
              item.UserId = BCBRDMArr
              if (BCBRMCArr.length > 0) {
                this.tableData.find((i) => i.KFDM === item.KFDM).BCBRMC =
                  item.UserName
                this.tableData.find((i) => i.KFDM === item.KFDM).BCBRDM =
                  item.UserId
              }
            })
          })
        })
        .catch(() => {})
    },
    exitExport() {
      this.showExportConfig = false
      this.columnArr = this.lastCloumns
    },
    confirmExport() {
      this.showExportConfig = false
      // localStorage.setItem('columnArr', JSON.stringify(this.columnArr))
    },
    exportConfig() {
      this.showExportConfig = true
      this.lastCloumns = this.columnArr
    },
    print() {
      this.loading = true
      let ExportColumns = []
      this.exportColumns.forEach((item) => {
        if (this.columnArr.includes(item.key)) {
          ExportColumns.push(item)
        }
      })
      const param = {
        Cfxh: this.rowData.CFXH,
        ExportColumns: JSON.stringify(ExportColumns),
        FileType: 'PDF'
      }
      Print('NQCS/Print?act=ExportCheckTask', param).then((res) => {
        let width = window.innerWidth
        let height = window.innerHeight
        const key = this.$dlg.modal(PdfDialog, {
          width: width,
          height: height,
          title: '文件打印',
          params: {
            pdfUrl: res.data.FilePath
          },
          callback: (data) => {
            if (this.isRefreshTable) {
              this.getDataList(this.listQuery)
            }
          },
          cancelCallback: () => {}
        })
        this.loading = false
      })
    },
    async handleShowBGCS() {
      const data = await this.getChangeRecordList()
      let width = window.innerWidth * 0.85
      let height = window.innerHeight * 0.8

      const key = this.$dlg.modal(BgcsDialog, {
        width: width,
        height: height,
        title: '变更记录',
        params: {
          data
        },

        callback: (data) => {},
        cancelCallback: () => {}
      })
    },
    getChangeRecordList() {
      return new Promise((resolve, reject) => {
        this.$requestApi('GetCheckChangeRecordList', {
          Cfxh: this.form.CFXH
        })
          .then((res) => {
            if (res.success) {
              this.changeNumber = res.data.RecordCount
              resolve(res.data.RecordList)
            } else {
              reject()
            }
          })
          .catch(() => {
            reject()
          })
      })
    },
    //  切换 全选其他检查者
    handleCheck(val) {
      let that = this
      if (val) {
        if (this.qtjczSourceList.length == 0) {
          this.$requestApi('GetCheckUser', {
            OrgId: that.listQuery.ORGID,
            CFXH: that.form.CFXH,
            pageIndex: 1,
            pageSize: 999,
            Query: ''
          }).then((res) => {
            if (res.success) {
              that.qtjczSourceList = res.data
              let qtjczid = that.qtjczSourceList
                .filter((m) => m.ID != that.form.JCZ)
                .map((m) => m.ID)
                .join(',')
              let qtjczmc = that.qtjczSourceList
                .filter((m) => m.ID != that.form.JCZ)
                .map((m) => m.NAME + `(${m.ID})`)
                .join(',')
              that.$nextTick(() => {
                that.$set(that.form, 'QTJCZID', qtjczid)
                that.$set(that.form, 'QTJCZMC', qtjczmc)
              })
            }
          })
        } else {
          let qtjczid = that.qtjczSourceList
            .filter((m) => m.ID != that.form.JCZ)
            .map((m) => m.ID)
            .join(',')
          let qtjczmc = that.qtjczSourceList
            .filter((m) => m.ID != that.form.JCZ)
            .map((m) => m.NAME + `(${m.ID})`)
            .join(',')
          that.$nextTick(() => {
            that.$set(that.form, 'QTJCZID', qtjczid)
            that.$set(that.form, 'QTJCZMC', qtjczmc)
          })
        }
      } else {
        that.$nextTick(() => {
          that.$set(that.form, 'QTJCZID', '')
          that.$set(that.form, 'QTJCZMC', '')
        })
      }
    },
    FJOption(row) {
      if (row.FJFSXX) {
        var arr = row.FJFSXX.split(';')
        return arr.map((m) => {
          return {
            id: m,
            lable: m
          }
        })
      }
      return []
    },
    inspectDialogClose() {
      this.inspectVisible = false
    },
    conflictData(data) {
      //更新数据
      this.inspectVisible = false
      let arrIndex = []
      let targetIndex = []
      data.forEach((item, count) => {
        item.SFWSJ =
          item.SFWSJ == false || item.SFWSJ == null || item.SFWSJ == '0'
            ? '0'
            : '1'
        this.markData.forEach((items, index) => {
          if (items.KFDM === item.KFDM) {
            arrIndex.push(count)
            targetIndex.push(index)
            item.ID = items.ID
            item.HasDealConflict = '1'
          }
        })
      })

      //替换数据
      for (let n = 0; n < arrIndex.length; n++) {
        this.markData.splice(targetIndex[n], 1, data[arrIndex[n]])
      }
      this.markData = JSON.parse(JSON.stringify(this.markData))
      this.save('2')
    },
    // 获取冲突项数据
    getConflictData() {
      //id 拆分序号
      // 每次清除一下
      this.inspectRow = []
      this.$requestApi('GetConflictItems', { Cfxh: this.form.CFXH }).then(
        (res) => {
          if (res.success && res.data.length > 0) {
            //冲突数据设置不可更改
            let groupingArr = []
            let standardStr = ''
            res.data.forEach((item, index) => {
              item.editAble = false
              if (index == 0) {
                standardStr = item.KFDM
              } else {
                if (item.KFDM != standardStr) {
                  standardStr = item.KFDM
                  groupingArr.push(index - 1)
                }
              }
            })
            //最后一组没统计，加上
            if (res.data[0] != standardStr) {
              groupingArr.push(res.data.length - 1)
            }

            this.inspectRow = res.data

            // 添加组长打分编辑数据
            for (let n = 0; n < groupingArr.length; n++) {
              let cloneData = cloneDeep(this.inspectRow)
              let addData = cloneData[groupingArr[n] + n]
              //可编辑
              addData.editAble = true
              // 责任人,被查患者，被查护士，扣分原因重置
              addData.BCBRDM = ''
              addData.BCBRMC = Array.isArray(addData.BCBRMC) ? [] : ''
              addData.BCHSMC = Array.isArray(addData.BCHSMC) ? [] : ''
              addData.BCHSDM = ''
              addData.ZRRDM = ''
              addData.ZRRMC = Array.isArray(addData.ZRRMC) ? [] : ''
              addData.KFYYSM = ''
              addData.KFJG = 0
              // 检查者
              addData.JCZMC = this.groupLeader
              addData.JCZ = this.groupJCZ
              // ID
              addData.ID = ''
              // 未涉及
              addData.SFWSJ = false
              // 扣分计算
              addData.HCBJGList.forEach((item) => {
                item.YBSL = null
                item.YBZB = null
              })
              //添加，改变数组长度
              if (n == 0) {
                this.inspectRow.splice(groupingArr[n] + 1, 0, addData)
              } else {
                this.inspectRow.splice(groupingArr[n] + (n + 1), 0, addData)
              }
            }
            // 添加标识,为冲突准备
            this.inspectRow.forEach((items, index) => {
              items.onlyId = index + 10
            })

            this.inspectRow = cloneDeep(this.inspectRow)
            //开启弹窗，解决冲突
            this.inspectVisible = true
          } else {
            this.save('2')
          }
        }
      )
    },
    frequencyChange() {
      this.tableData.forEach((item) => {
        // 设置纳入结果技计算值,没有手动更改
        if (!item.isChangeNum) {
          item.SJRCS = this.frequency
          let flag = true
          item.HCBJGList.forEach((items) => {
            if (items.ISNRJS == '1' && flag) {
              flag = false
              items.YBSL = this.frequency
              items.YBZB = 1
            }
          })
        }
      })
    },
    testedPerson(data) {
      let index = data.rowIndex
      let targetData = data.row
      // 总数
      let targetNum = targetData.SJRCS
      targetData.isChangeNum = true
      // 占比数
      let zbNum = 0
      let zbRatio = 0
      let hgX = targetData.HCBJGList.find((m) => m.ISNRJS == '1')
      targetData.HCBJGList.forEach((item) => {
        if (item.JGDM != hgX?.JGDM) {
          let targetRtio =
            (item.YBSL ? item.YBSL : 0) / targetNum == 0
              ? 0
              : parseFloat((item.YBSL / targetNum).toFixed(4))
          item.YBZB = targetRtio
          item.YBSL = parseInt(item.YBSL ? item.YBSL : 0)
          zbNum = parseInt(item.YBSL ? item.YBSL : 0) + zbNum
          zbRatio = targetRtio + zbRatio
        }
      })
      // 计算出 纳入计算结果的值
      targetData.HCBJGList.forEach((item) => {
        if (item.JGDM == hgX?.JGDM) {
          if (targetNum - zbNum < 0) {
            item.YBSL = 0
            item.YBZB = 0
          } else {
            item.YBSL = targetNum - zbNum
            item.YBZB = 1 - zbRatio
            targetData.isError = false
          }
        }
        this.getHGL(item, index, targetData)
      })
    },
    handleChangeCrosswise(val) {
      sessionStorage.setItem('IS_CROSSWISE', val)
      this.checkTableKey = Math.random()
    },
    checkListChange(val) {
      if (this.type === 'add') {
        return
      }
      if (val.length > 0) {
        localStorage.setItem(
          `addDialog_info_${this.rowData.CFXH}`,
          JSON.stringify({
            resultCheckList: val
          })
        )
      } else {
        localStorage.removeItem(`addDialog_info_${this.rowData.CFXH}`)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.blue {
  color: blue;
}
.form {
  margin-bottom: 20px;
}
.collapse {
  width: 10%;
  color: var(--COLOR-NORMAL);
  cursor: pointer;
  text-align: center;
  position: relative;
  top: -10px;
  i {
    margin-right: 4px;
  }
}
.moreVisiable {
  position: relative;
  top: -30px;
}
.w50 {
  width: 50%;
  text-align: left;
}
.w30 {
  width: 30%;
}
.w20 {
  width: 30%;
  text-align: right;
}
.w60 {
  width: 60%;
}
.w40 {
  width: 40%;
}
.w100 {
  width: 100%;
  text-align: left;
}
.flex-center {
  display: flex;
  align-items: center;
}

.flex-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.info {
  padding: 10px 30px;
  background-color: #f1f1ee;
  border-radius: 5px;
  min-height: 50px;
  line-height: 28px;
}
.high-color {
  color: #f00909;
  font-size: 18px;
  font-weight: 600;
}
.modal-window-footer {
  border-top: 1px solid #f1f1ee;
  width: 100%;
  margin-right: 15px;
  .tooltip-wrapper {
    margin: 0 10px;
    display: inline-block;
  }
}
.reason-select /deep/ .w-input__wrapper .w-input__inner {
  min-height: 32px !important;
}

.editShow {
  margin-left: 10px;
  cursor: pointer !important;
}
.multiSelect /deep/ .w-select__tags {
  max-width: 100% !important;
  white-space: nowrap;
}
.pic-people {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.kfmc {
  margin-left: 8px;
  cursor: pointer;
  font-size: 20px;
  float: right;
}
.kfmc-add {
  color: #0c93b1;
}
.kfmc-del {
  color: #f13d10;
}
.add-img {
  font-size: 22px;
  cursor: pointer;
  position: relative;
}

.add-img::after {
  content: '';
  position: absolute;
  left: -20px;
  top: -15px;
  right: -20px;
  bottom: -15px;
}
.width-100 {
  width: 120%;
  max-width: 180px;
}
.width-160 {
  width: 120%;
  max-width: 160px;
}
.width-230 {
  width: 120%;
  max-width: 230px;
}

.margin-left-10 {
  margin-left: 10px;
}
.yan-yong {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 60px;
  margin-left: 10px;
}
.font-red {
  color: red;
}
.hasIcon {
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  width: 28px;
  height: 28px;
  background: url('../../../../../../common/assets/images/ypfj.svg') no-repeat
    100% 100%;
}
.scroll-style {
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
/deep/ .result-list {
  display: block;
  width: auto !important;
  min-width: 180px;
  .w-input-suggestion-popper__list {
    min-height: 75px;
    .w-input-suggestion-popper__item {
      white-space: nowrap;
      text-align: left;
    }
  }
}
.arrow-container {
  width: 30px;
  height: 24px;
  border: 1px solid #c9c9c9;
  margin: auto;
  margin-left: 10px;
  .w-icon-triangle-bottom {
    transform: translate(-80%, -20%);
  }
}
/deep/ .w-checkbox__label {
  padding-left: 3px;
}
/deep/ .padd0 {
  transform: translate(-170px, 14px);
}
/deep/ .tree-container-hide {
  border: 1px solid #c9c9c9;
  position: fixed;
  top: 250px;
  background-color: #fff;
  left: 15px;
  width: 300px;
  overflow-x: hidden;
  // transform: translateX(-200%);
  z-index: 99;
  .tree-header {
    height: 24px;
    background-color: #eaeefe;
    .icon-close {
      line-height: 24px;
      float: right;
      margin-right: 5px;
    }
  }
  .tree-input {
    margin: 5px;
    width: calc(100% - 10px);
  }
  .w-tree {
    height: 580px;
    overflow: auto;
    .w-tree-node__label {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
.tree-container {
  z-index: 999;
  // transform: translateX(0);
  // transition-duration: 0.5s;
}
.arrow-tree-container {
  cursor: pointer;
  position: fixed;
  top: 50%;
  left: 0;
  width: 20px;
  height: 20px;
  z-index: 9999;
  .w-icon-triangle-left,
  .w-icon-triangle-right {
    font-size: 20px;
  }
}

.WSJContainer {
  // display: flex;
  justify-content: space-between;
}
.tip {
  position: absolute;
  right: 20px;
  width: 24px;
  height: 24px;
  z-index: 999;
}
/deep/ .w-icon-warning {
  font-size: 24px;
  color: #e49826;
}
.showRedBorder /deep/ .w-input__inner,
.showRedBorder /deep/ .w-textarea__inner {
  border-color: #ec0000 !important;
}
.imgNum {
  position: absolute;
  right: 6px;
  top: 6px;
  color: #e49826;
}
.selectAll {
  position: absolute;
  right: -10px;
  top: 5px;
}
.showRed {
  width: 100%;
  height: 100%;
  padding: 10px;
  border: 1px solid red;
}
.dqbh  {
  border-radius: 50%;
  height: 25px;
  width: 25px;
  display: inline-block;
  background: #38a4fa;
  text-align: center;
  border: 1px solid#38a4fa;
  white-space: nowrap;
  padding: 1px 3px 1px 1px;
  font-size: 20px;
  color: #ffffff;
  transform: scale(0.8);
}
.ml {
  margin-left: 6px;
}
/deep/ td {
  background-position: 0px 0px !important;
}

.checkTables,
.checkTableOther {
  /deep/ .vxe-table--body {
    border-bottom: 1px solid #c9c9c9;
  }
}
.leaders {
  margin-top: 28px;
  position: relative;
  left: 36px;
  .lea {
    margin-left: 8px;
  }
}
.leader {
  // margin-left: 40px;
  margin-top: 4px;
  // position: absolute;
}
.mt-5 {
  margin-bottom: 10px;
}
.tested {
  margin-top: 6px;
}
.input-number {
  min-width: 80px !important;
}
.bdbb {
  white-space: nowrap;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
}
.d-flex{
  display: flex;
  align-items: center;
}
.popover-nurse-top{
  position: relative;
  transform: translateY(5px)
}
</style>
